/* eslint-disable prettier/prettier */
module.exports = {
  app: "App",
  news: "Novidades",
  component: "Componente",
  download: "Baixar",
  downloading: "Baixando",
  unableToDownload: "Não foi possível baixar",
  features: "Funcionalidades",
  applications: "Aplicações",
  dashboard: "Painel",
  customers: "Clientes",
  warehouses: "Armazéns",
  management: "Gerenciamento",
  carriers: "Transportadoras",
  operations: "Operações",
  warehousing: "Armazenagem",
  quote: "Cotação",
  business: "Empresa",
  invoices: "Faturas",
  prepayments: "Pré-pagamentos",
  billsToPay: "Contas a Pagar",
  modules: "Módulos",
  agency: "Agência",
  pages: "Páginas",
  gallery: "Galeria",
  pricing: "Preços",
  privacyPolicy: "Política de Privacidade",
  feedback: "Feedback",
  report: "Relatório",
  faqS: "Perguntas Frequentes",
  advanceComponent: "Componente Avançado",
  blank: "Em branco",
  session: "Sessão",
  login: "Entrar",
  reset: "Redefinir",
  register: "Registrar",
  lockScreen: "Tela de Bloqueio",
  forgotPassword: "Esqueci a Senha",
  forgotYourPassword: "Esqueceu sua senha?",
  letsGetYouBackIn: "Vamos te reconectar",
  recoverPassword: "Recuperar Senha",
  dontWorryJustEnterYourEmailAddressBelowAndWellAssistYou: "Não se preocupe! Digite seu endereço de e-mail abaixo e iremos te ajudar.",
  withInstructionsToResetYourPassword: "com instruções para redefinir sua senha",
  checkYourEmail: "Verifique seu e-mail",
  emailNotReceived: "Não recebeu o e-mail?",
  resend: "Reenviar",
  uiComponents: "Componentes de UI",
  alerts: "Alertas",
  appBar: "Barra de App",
  avatars: "Avatares",
  buttons: "Botões",
  bottomNavigations: "Navegações Inferiores",
  badges: "Emblemas",
  cards: "Cartões",
  cardsMasonry: "Cartões em Mosaico",
  chip: "Chip",
  dialog: "Diálogo",
  dividers: "Divisores",
  drawers: "Gavetas",
  draft: "Rascunho",
  totalQuotes: "Total de Cotações",
  inspect: "Inspecionar",
  expansionPanel: "Painel Expansível",
  gridList: "Lista em Grade",
  list: "Lista",
  menu: "Menu",
  popOverTooltip: "Pop Over e Dica",
  progress: "Progresso",
  snackbar: "Notificação",
  selectionControls: "Controles de Seleção",
  dateTimePicker: "Seletor de Data e Hora",
  tabs: "Abas",
  stepper: "Passo a Passo",
  notification: "Notificação",
  notifications: "Notificações",
  sweetAlert: "Alerta",
  autoComplete: "Autocompletar",
  aboutUs: "Sobre Nós",
  widgets: "Widgets",
  forms: "Formulários",
  formElements: "Elementos de Formulário",
  textField: "Campo de Texto",
  selectList: "Lista de Seleção",
  charts: "Gráficos",
  reCharts: "Re Charts",
  reactChartjs2: "React Chartjs 2",
  icons: "Ícones",
  themifyIcons: "Ícones Themify",
  simpleLineIcons: "Ícones de Linha Simples",
  materialIcons: "Ícones Material",
  tables: "Tabelas",
  basic: "Básico",
  dataTable: "Tabela de Dados",
  responsive: "Responsivo",
  maps: "Mapas",
  googleMaps: "Google Maps",
  leafletMaps: "Leaflet Maps",
  inbox: "Caixa de Entrada",
  users: "Usuários",
  userProfile1: "Perfil de Usuário 1",
  userProfile2: "Perfil de Usuário 2",
  userManagement: "Gerenciamento de Usuários",
  userList: "Lista de Usuários",
  calendar: "Calendário",
  cultures: "Culturas",
  selectable: "Selecionável",
  customRendering: "Renderização Personalizada",
  chat: "Chat",
  todo: "Tarefas",
  editor: "Editor",
  wysiwygEditor: "Editor WYSIWYG",
  quillEditor: "Editor Quill",
  dragAndDrop: "Arrastar e Soltar",
  reactDragula: "React Dragula",
  reactDnd: "React Dnd",
  ecommerce: "E-commerce",
  shopList: "Lista de Loja",
  shopGrid: "Grade de Loja",
  invoice: "Fatura",
  crm: "CRM",
  ratings: "Avaliações",
  number: "Número",
  welcomeBack: "Bem-vindo de volta!",
  pleaseCreateANewPasswordForYourAccount: "Por favor, crie uma nova senha para sua conta",
  emailOrUsername: "E-mail ou nome de usuário",
  rememberMe: "Lembrar de mim",
  notRegisteredYet: "Ainda não está registrado?",
  clickToResend: "Clique para reenviar",
  clickHere: "clique aqui.",
  youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically: "Você será redirecionado para a página de login. Se não for redirecionado automaticamente, ",
  createAnAccount: "Criar uma conta",
  web: "Web",
  done: "Concluído",
  inProgress: "Em Andamento",
  waiting: "Aguardando",
  subscribed: "Inscrito",
  searchItem: "Buscar Item",
  startDate: "Data de Início",
  endDate: "Data de Término",
  password: "Senha",
  newPassword: "Nova senha",
  createNewPassword: "Criar nova senha",
  filters: "Filtros",
  private: "Privado",
  corporate: "Corporativo",
  name: "Nome",
  volume: "Volume",
  sidebarOverlay: "Sobreposição da Barra Lateral",
  appSettings: "Configurações do App",
  sidebarImage: "Imagem da Barra Lateral",
  miniSidebar: "Barra Lateral Mini",
  boxLayout: "Layout em Caixa",
  rtlLayout: "Layout RTL",
  darkMode: "Modo Escuro",
  light: "Claro",
  dark: "Escuro",
  refresh: "Atualizar",
  refreshing: "Atualizando",
  record: "Gravar",
  play: "Reproduzir",
  start: "Iniciar",
  cancel: "Cancelar",
  copy: "Copiar",
  send: "Enviar",
  add: "Adicionar",
  update: "Atualizar",
  confirm: "Confirmar",
  delete: "Excluir",
  yes: "Sim",
  no: "Não",
  addNewContact: "Adicionar novo contato",
  editAContact: "Editar um contato",
  addNewLocation: "Adicionar nova localização",
  editALocation: "Editar uma localização",
  summary: "Resumo",
  week: "Semana",
  weekday: "Dia da Semana",
  month: "Mês",
  firstName: "Nome",
  lastName: "Sobrenome",
  address: "Endereço",
  description: "Aqui você pode enviar seus próprios arquivos (como inventário, equipe ou listas de serviços) ou começar com a lista padrão do Shipeezi. Você sempre pode atualizar isso depois.",
  total: "Total",
  selectRoom: "Selecionar Cômodo",
  selectDescription: "Selecionar Descrição",
  addNew: "Adicionar novo",
  revoke: "Revogar",
  assign: "Atribuir",
  save: "Salvar",
  saveComment: "Salvar Comentário",
  create: "Criar",
  savePublishTask: "Salvar e Publicar Tarefa",
  accept: "Aceitar",
  accepted: "Aceito",
  complete: "Concluir",
  back: "Voltar",
  ok: "Ok",
  next: "Próximo",
  saveChanges: "Salvar Alterações",
  cancelChanges: "Cancelar Alterações",
  more: "Mais",
  remove: "Remover",
  changePhoto: "Alterar foto",
  booking: "Reserva",
  enterBooking: "Inserir reserva",
  user: "Usuário",
  promo: "Promoção",
  themeColor: "Cor do Tema",
  selectProject: "Selecionar Projeto",
  shop: "Loja",
  cart: "Carrinho",
  checkout: "Finalizar Compra",
  product: "Produto",
  removeProduct: "Remover Produto",
  noItemFound: "Nenhum Item Encontrado",
  saas: "SAAS",
  multilevel: "Multinível",
  level1: "Nível 1",
  level2: "Nível 2",
  imageCropper: "Recortador de Imagem",
  videoPlayer: "Reprodutor de Vídeo",
  dropzone: "Área de Envio",
  cropImage: "Recortar Imagem",
  preview: "Pré-visualização",
  projects: "Projetos",
  projectDetail: "Detalhes do Projeto",
  clients: "clientes",
  shipments: "Envios",
  editShipment: "Editar Embarque",
  viewShipment: "Visualizar Embarque",
  newShipment: "Novo Embarque",
  loadBy: "Carregar por",
  createShipment: "Criar Embarque",
  products: "Produtos",
  latestScan: "Última Leitura",
  dateOfLoading: "Data de Carregamento",
  editProduct: "Editar Produto",
  newProduct: "Novo Produto",
  noProductsToShow: "Nenhum produto para exibir",
  theProductWasRemovedSuccesfully: "O produto foi removido com sucesso",
  containers: "Contêineres",
  settings: "Configurações",
  cartonQuantity: "Quantidade de Caixas",
  palletQuantity: "Quantidade de Paletes",
  despatches: "Despachos",
  edit: "Editar",
  details: "Detalhes",
  detail: "Detalhe",
  locations: "Localizações",
  comments: "Comentários",
  estimatedDates: "Datas estimadas",
  destinationWh: "Armazém de Destino",
  vessel: "Navio",
  vesselName: "Nome do Navio",
  travel: "Viagem",
  container: "Contêiner",
  containerType: "Tipo de Contêiner",
  selectContainerType: "Selecionar Tipo de Contêiner",
  shipmentType: "Tipo de envio",
  containerNumbers: "Números de Contêiner",
  grossWeight: "Peso Bruto",
  inputWeight: "Inserir Peso",
  project: "Projeto",
  totalQuantity: "Quantidade Total",
  totalPallets: "Total de Paletes",
  eta: "ETA",
  etaFinalPort: "ETA Porto Final",
  etaWarehouse: "ETA Armazém",
  pickUpDate: "Data de Coleta",
  scanDate: "Data de Leitura",
  departureDate: "Data de Saída",
  arrivalAtDestination: "Data de Entrega",
  hawb: "HAWB",
  flightNumber: "Número do Voo",
  airline: "Companhia Aérea",
  etaUnpackData: "ETA Dados de Desembalagem",
  actualDates: "Datas reais",
  agent: "Agente",
  agentId: "ID do Agente",
  agentParentCode: "ID pai do Agente",
  email: "E-mail",
  businessAddress: "Endereço Comercial",
  businessContacts: "Contatos Comerciais",
  businessName: "Nome Comercial",
  businessNumber: "Número Comercial",
  businessRegistration: "Registro Comercial",
  businessRegistrationNumber: "Número de Registro Comercial",
  mainEmailAddress: "Endereço de e-mail principal",
  website: "Site",
  bodyType: "Tipo de Carroceria",
  fuelType: "Tipo de Combustível",
  condition: "Condição",
  engine: "Motor",
  ownership: "Propriedade",
  branch: "Filial",
  fleetStatus: "Status da Frota",
  dryStandard: "Seco Padrão",
  dryHigh: "Seco Alto",
  tank: "Tanque",
  open: "Aberto",
  openTop: "Topo Aberto",
  openTopHigh: "Topo Aberto Alto",
  flat: "Plano",
  flatStandard: "Plano Padrão",
  flatHigh: "Plano Alto",
  reeferStandard: "Refrigerado Padrão",
  reeferHigh: "Refrigerado Alto",
  po: "PO #",
  sku: "SKU",
  itemRemovedSuccessfully: "Item removido com sucesso!",
  import: "Importar",
  export: "Exportar",
  importCsvFile: "Importar arquivo CSV",
  printDeliveryDocket: "Imprimir Comprovante de Entrega",
  despatch: "Despacho",
  qtyOfCartonsDespatched: "Qtd de Caixas Despachadas",
  qtyOfPalletsDespatched: "Qtd de Paletes Despachados",
  ofDespatches: "Nº de Despachos",
  ofOrdersDespatched: "Nº de Pedidos Despachados",
  stockOnHand: "Estoque em mãos",
  stockOnHandDetailed: "Estoque em mãos - Detalhado",
  crossDockStatus: "Status Cross-Dock",
  packing: "Embalagem",
  addMaterial: "Adicionar Material",
  fillAllFieldsToSave: "Preencha todos os campos para salvar",
  addItem: "Adicionar item",
  instructionStatus: "Status da instrução",
  selectWhen: "Selecionar Quando",
  addInstruction: "Adicionar Instrução",
  availableInstructions: "Instruções Disponíveis",
  remark: "Observação",
  inputYourRemarkAndPressEnter: "Digite sua observação e pressione Enter",
  uplift: "Coleta",
  coordinator: "Coordenador",
  selectedInstructions: "instruções selecionadas",
  selectAStatus: "Selecionar um status",
  applyChooseLocations: "Aplicar e escolher localizações",
  filterConditions: "Filtrar Condições",
  filterLocations: "Filtrar Localizações",
  conditions: "Condições",
  typeOfPacking: "Tipo de Embalagem",
  itemStatus: "Status do Item",
  itemNumber: "Número do Item",
  width: "Largura",
  length: "Comprimento",
  leader: "Líder",
  searchLeader: "Buscar Líder",
  staffs: "Funcionários",
  searchForStaff: "Buscar funcionário",
  fleets: "Frotas",
  searchForFleet: "Buscar frota",
  height: "Altura",
  cartonPerPallet: "Caixas por Palete",
  palletHeight: "Altura do Palete",
  heightWithPallet: "Altura com Palete",
  heightIncPallet: "Altura incl. Palete",
  ti: "Ti",
  hi: "Olá",
  selectProductsBelowToAddThem: "Selecione produtos abaixo para adicioná-los",
  productSkuSearch: "Busca de Produto (SKU)",
  productName: "Nome do Produto",
  shippingItem: "Item de Envio",
  truckTransport: "Caminhão/Transporte",
  customerName: "Nome do Cliente",
  addNewProject: "Adicionar Novo Projeto",
  projectName: "Nome do Projeto",
  projectCustomer: "Cliente do Projeto",
  importFiles: "Importar Arquivos",
  fileHistory: "Histórico de Arquivos",
  projectCreatedWithSuccess: "Projeto criado com sucesso!",
  uploadNewFile: "Enviar Novo Arquivo",
  imapHost: "Host IMAP",
  imapPort: "Porta IMAP",
  emailUser: "Usuário de E-mail",
  emailPassword: "Senha de E-mail",
  useTls: "Usar TLS",
  addNewComment: "Adicionar novo comentário",
  typeYourCommentHere: "Digite seu comentário aqui",
  order: "Pedido",
  origin: "Origem",
  destination: "Destino",
  type: "Tipo",
  dateCreated: "Data de criação",
  dateUpdated: "Data de atualização",
  buyerName: "Nome do Comprador",
  shipVia: "Enviar via",
  shipTo: "Enviar para",
  incoterm: "Incoterm",
  createNewSupplier: "Criar novo fornecedor",
  fulfilled: "Cumprido",
  quantityOrdered: "Quantidade pedida",
  quantityRequested: "Quantidade solicitada",
  quantityFullfilled: "Quantidade cumprida",
  variation: "Variação",
  switchToActualInventory: "Alternar para Inventário Real",
  switchToQuotedInventory: "Alternar para Inventário Cotado",
  switchToEstimatedInventory: "Alternar para Inventário Estimado",
  searchByNameOrEmail: "Buscar por nome ou e-mail",
  supplierDetails: "Detalhes do Fornecedor",
  supplier: "Fornecedor",
  supplierName: "Nome do Fornecedor",
  supplierCode: "Código do Fornecedor",
  address1: "Endereço 1",
  address2: "Endereço 2",
  suburbTown: "Bairro/Cidade",
  streetNumber: "Número",
  postalCode: "CEP",
  state: "Estado",
  country: "País",
  contactName: "Nome do contato de cobrança",
  locationStatus: "Status da localização",
  filterByShipment: "Filtrar por Embarque #",
  noInformationToBeShown: "Nenhuma informação a ser exibida.",
  loadingShipments: "Carregando Embarques",
  loadingDispatches: "Carregando Despachos",
  loadingSuppliers: "Carregando Fornecedores...",
  loadingNotifications: "Carregando Notificações",
  task: "Tarefa",
  usedBy: "Usado por",
  fleetNumber: "Número da Frota",
  make: "Marca",
  model: "Modelo",
  body: "Carroceria",
  position: "Posição",
  username: "Nome de Usuário",
  location: "Localização",
  mainContact: "Contato Principal",
  role: "Cargo",
  rooms: "Cômodos",
  fullName: "Nome completo",
  symbol: "Símbolo",
  decimalPoints: "Casas Decimais",
  lastUpdate: "Última Atualização",
  lastModified: "Última Modificação",
  flatFee: "Taxa Fixa",
  hourlyFee: "Taxa por Hora",
  halfHourFee: "Taxa por Meia Hora",
  triggers: "Gatilhos",
  tasksType: "Tipo de Tarefas",
  jobsType: "Tipo de Trabalhos",
  branches: "Filiais",
  updated: "Atualizado",
  color: "Cor",
  icon: "Ícone",
  packaging: "Embalagem",
  configuration: "Configuração",
  currency: "Moeda",
  currencies: "Moedas",
  measurements: "Medidas",
  addCustomCurrency: "Adicionar moeda personalizada",
  displayUnit: "Unidade de exibição",
  languages: "Idiomas",
  prefix: "Prefixo",
  language: "Idioma",
  room: "Cômodo",
  types: "Tipos",
  descriptiveSymbol: "Símbolo Descritivo",
  descriptiveSymbols: "Símbolos Descritivos",
  exceptionSymbol: "SÍMBOLO DE EXCEÇÃO",
  exceptionSymbols: "Símbolos de Exceção",
  locationSymbol: "SÍMBOLO DE LOCALIZAÇÃO",
  locationSymbols: "Símbolos de Localização",
  photoIsMandatory: "Foto é obrigatória",
  selectTheRoom: "Selecionar o cômodo",
  editRoom: "Editar cômodo",
  addNewType: "Adicionar novo tipo",
  editType: "Editar tipo",
  addNewDescriptiveSymbol: "Adicionar novo símbolo descritivo",
  selectSymbol: "Selecionar Símbolo",
  editDescriptiveSymbol: "Editar símbolo descritivo",
  addNewExceptionSymbol: "Adicionar novo símbolo de exceção",
  editExceptionSymbol: "Editar símbolo de exceção",
  addNewLocationSymbol: "Adicionar novo símbolo de localização",
  editLocationSymbol: "Editar símbolo de localização",
  addNewOne: "Adicionar novo",
  createFleet: "Criar Frota",
  editFleet: "Editar Frota",
  viewFleet: "Visualizar Frota",
  editThisFleet: "Editar esta frota",
  addANewFleet: "Adicionar uma nova frota",
  viewThisFleet: "Visualizar esta frota",
  vinNumber: "Número VIN",
  year: "Ano",
  engineType: "Tipo de Motor",
  plateNumber: "Número da Placa",
  addCondition: "Adicionar Condição",
  typeMode: "Modo de Tipo",
  warehouse: "Armazém",
  searchForWarehouse: "Buscar armazém",
  searchForBranch: "Buscar filial",
  capacity: "Capacidade",
  capacityOfEachLiftvan: "Capacidade de cada Liftvan",
  volumeCapacityM3: "Capacidade de Volume (m³)",
  weightCapacityKG: "Capacidade de Peso (Kg)",
  outOfService: "Fora de Serviço",
  serialNumber: "Número de Série",
  inputSerialNumber: "Inserir Número de Série",
  mechanicalElectricalChecklist: "Checklist Mecânico e Elétrico",
  hasTheMEChecklistBeenDoneOnThisItem: "O checklist M&E foi realizado neste item?",
  isItWorking: "Está funcionando?",
  userDetails: "Detalhes do Usuário",
  permissions: "Permissões",
  placeName: "Nome do Local",
  local: "Local",
  companyId: "ID da Empresa",
  suppliers: "Fornecedores",
  newSupplier: "Novo Fornecedor",
  viewSupplier: "Visualizar Fornecedor",
  editSupplier: "Editar Fornecedor",
  printSupplier: "Imprimir Fornecedor",
  editPlace: "Editar Local",
  newPlace: "Novo Local",
  newUser: "Novo Usuário",
  createdAt: "Criado em",
  voyage: "Viagem",
  voyageNumber: "Número da Viagem",
  voyageStatus: "Status da Viagem",
  voyageInformation: "Informações da Viagem",
  containerNumber: "Número do Contêiner",
  inputContainer: "Inserir Contêiner",
  inputShipment: "Inserir Embarque",
  internalReference: "Referência Interna",
  exportShipment: "Exportar Embarque",
  eventProductUpdate: "Atualização de Produto do Evento",
  importProductsEvents: "Importar Eventos de Produtos",
  view: "Visualizar",
  close: "Fechar",
  closed: "Fechado",
  closedForInvoicing: "Fechado para Faturamento",
  closedForReceiving: "Fechado para Recebimento",
  createNetwork: "Criar rede",
  createCustomer: "Criar cliente",
  createAgent: "Criar agente",
  createSupplier: "Criar fornecedor",
  linkAccounts: "Vincular contas",
  understood: "Entendido",
  productEvents: "Eventos de Produto",
  birthDate: "Data de Nascimento",
  emergencyName: "Nome de Emergência",
  emergencyPhone: "Telefone de Emergência",
  emergencyRelationship: "Parentesco de Emergência",
  gender: "Gênero",
  skills: "Habilidades",
  residencyStatus: "Status de Residência",
  certificates: "Certificados",
  addressLine1: "Linha de Endereço 1",
  addressLine2: "Linha de Endereço 2",
  suburb: "Bairro",
  staffStatus: "Status do Funcionário",
  staffMnt: "Funcionário - MNT",
  editStaff: "Editar Funcionário",
  newStaff: "Novo Funcionário",
  saveAsUser: "Salvar como Usuário",
  yourPasswordMustBeAtLeast12CharactersLong: "Sua senha deve ter pelo menos 12 caracteres",
  yourPasswordMustContainAtLeastOneSpecialCharacter: "Sua senha deve conter pelo menos um caractere especial",
  pleaseEnterYourPassword: "Por favor, insira sua senha",
  yourPasswordMustBeAtMaximumOf30CharactersLong: "Sua senha deve ter no máximo 30 caracteres",
  pleaseEnterAValidPhoneNumber: "Por favor, insira um número de telefone válido",
  phoneNumber: "Número de telefone",
  pleaseEnterALastName: "Por favor, insira um Sobrenome",
  yourLastNameMustBeAtLeast4CharactersLong: "Seu sobrenome deve ter pelo menos 4 caracteres",
  pleaseEnterAFirstName: "Por favor, insira um Nome",
  yourFirstNameMustBeAtLeast4CharactersLong: "Seu nome deve ter pelo menos 4 caracteres",
  pleaseEnterAName: "Por favor, insira um Nome",
  yourNameMustBeAtLeast4CharactersLong: "Seu nome deve ter pelo menos 4 caracteres",
  yourRegistrationNumberMustBeAtLeast4CharactersLong: "Seu número de registro deve ter pelo menos 4 caracteres",
  pleaseEnterAPhoneNumber: "Por favor, insira um Número de Telefone",
  yourPhoneMustBeAtLeast6CharactersLong: "Seu telefone deve ter pelo menos 6 caracteres",
  yourWebMustBeAtLeast4CharactersLong: "Seu site deve ter pelo menos 4 caracteres",
  pleaseEnterAAddressLine: "Por favor, insira uma Linha de Endereço",
  yourAddressLineMustBeAtLeast4CharactersLong: "Sua linha de endereço deve ter pelo menos 4 caracteres",
  pleaseEnterASuburb: "Por favor, insira um Bairro",
  yourSuburbMustBeAtLeast4CharactersLong: "Seu bairro deve ter pelo menos 4 caracteres",
  pleaseEnterAStateNumber: "Por favor, insira um Estado",
  yourStateMustBeAtLeast3CharactersLong: "Seu estado deve ter pelo menos 3 caracteres",
  pleaseEnterAPostalCodeNumber: "Por favor, insira um CEP",
  yourPostalCodeMustBeAtLeast4CharactersLong: "Seu CEP deve ter pelo menos 4 caracteres",
  pleaseEnterACountry: "Por favor, insira um País",
  yourCountryMustBeAtLeast4CharactersLong: "Seu país deve ter pelo menos 4 caracteres",
  newItemSType: "Tipo do novo item",
  editItemSType: "Editar tipo do item",
  newItemSDescription: "Descrição do novo item",
  editItemSDescription: "Editar descrição do item",
  network: "Rede",
  anErrorOccurredTryAgain: "Ocorreu um erro, tente novamente",
  operationPerformedSuccessfully: "Operação realizada com sucesso",
  labelCreated: "Etiqueta Criada",
  sunday: "Domingo",
  monday: "Segunda-feira",
  tuesday: "Terça-feira",
  wednesday: "Quarta-feira",
  thursday: "Quinta-feira",
  friday: "Sexta-feira",
  saturday: "Sábado",
  january: "Janeiro",
  february: "Fevereiro",
  march: "Março",
  april: "Abril",
  may: "Maio",
  june: "Junho",
  july: "Julho",
  august: "Agosto",
  september: "Setembro",
  october: "Outubro",
  november: "Novembro",
  december: "Dezembro",
  customerSTimeZone: "Fuso horário do cliente",
  startTime: "Hora de Início",
  endTime: "Hora de Término",
  whatsapp: "Whatsapp",
  sms: "SMS",
  originAddress: "Endereço de origem",
  destinationAddress: "Endereço de destino",
  active: "Ativo",
  Active: "Ativo",
  disabled: "Desabilitado",
  sendToAmos: "Enviar para AMOS",
  printReports: "Imprimir relatórios",
  cancelOrder: "Cancelar pedido",
  cancelQuote: "Cancelar cotação",
  inactive: "Inativo",
  Inactive: "Inativo",
  invertStatuses: "Inverter status",
  filterByStatus: "Filtrar por Status",
  activeInactive: "Ativo / Inativo",
  selectType: "Selecionar tipo",
  selectStatus: "Selecionar status",
  userCode: "Código do usuário",
  enterUserCode: "Inserir código do usuário",
  emailAddress: "Endereço de e-mail",
  mobileNumber: "Número celular",
  contactType: "Tipo de contato",
  enterHere: "Inserir aqui",
  dateOfBirth: "Data de nascimento",
  typeOfUser: "Tipo de usuário",
  thisUserIsALeader: "Este usuário é um líder",
  checkThisBoxIfTheUserAboveIsAlsoALeader: "Marque esta caixa se o usuário acima também for um líder",
  useEmailAddress: "Usar endereço de e-mail",
  citySuburb: "Cidade / Bairro",
  postcode: "CEP",
  countryOrRegion: "País ou Região",
  timezone: "Fuso Horário",
  enterFirstName: "Inserir nome",
  enterLastName: "Inserir sobrenome",
  dateNumberFormat: "Formato de data / número",
  defaultCurrency: "Moeda padrão",
  userInactive: "Usuário inativo",
  roles: "Cargos",
  communications: "Comunicações",
  communicationSubscriptions: "Assinaturas de comunicação",
  searchByEnter: "Pesquisar pressionando Enter",
  approve: "Aprovar",
  decline: "Recusar",
  activeNetwork: "Rede ativa",
  invites: "Convites",
  reject: "Rejeitar",
  approved: "Aprovado",
  waitingForApproval: "Aguardando aprovação",
  sendToReview: "Enviar para revisão",
  automaticallyInvitationSentBy: "Convite enviado automaticamente por",
  importerExporter: "Importador e Exportador",
  newRole: "Novo cargo",
  editRole: "Editar cargo",
  continue: "Continuar",
  saveWithoutAssigning: "Salvar sem atribuir",
  saveAndAssign: "Salvar e atribuir",
  createRole: "Criar cargo",
  createRoom: "Criar cômodo",
  updateRole: "Atualizar cargo",
  assignUser: "Atribuir usuário",
  productSIsRequired: "Produto(s) é obrigatório!",
  roleName: "Nome do cargo",
  roleDescriptionOptional: "Descrição do cargo (opcional)",
  quoteAssignedTo: "Cotação atribuída a",
  manager: "Gerente",
  searchForManager: "Pesquisar gerente",
  youMustEnterAnEntityName: "*Você deve inserir um Nome da entidade",
  youMustEnterAnAddress: "*Você deve inserir um Endereço",
  youMustEnterASuburbTown: "*Você deve inserir um Bairro/Cidade",
  youMustEnterAState: "*Você deve inserir um Estado",
  youMustEnterACountry: "*Você deve inserir um País",
  youMustEnterAPostalcode: "*Você deve inserir um CEP",
  youMustEnterARegistrationNumber: "*Você deve inserir um Número de registro",
  youMustEnterABillingEmail: "*Você deve inserir um E-mail de cobrança",
  youMustEnterAMobile: "*Você deve inserir um Celular",
  youMustEnterATimezone: "*Você deve inserir um Fuso horário",
  youMustEnterAConsultant: "*Você deve inserir um Consultor",
  youMustEnterAContactPerson: "*Você deve inserir uma Pessoa de contato",
  youMustEnterAFirstName: "*Você deve inserir um Nome",
  youMustEnterALastName: "*Você deve inserir um Sobrenome",
  youMustEnterAnEmail: "*Você deve inserir um E-mail",
  youMustEnterAName: "*Você deve inserir um Nome",
  youMustEnterAPhoneNumber: "*Você deve inserir um Número de telefone",
  youMustEnterAParentCode: "*Você deve inserir um Número de ID pai",
  youMustEnterALocationName: "*Você deve inserir um Nome de localização",
  youMustEnterAStatus: "*Você deve inserir um Status",
  youMustEnterAnEstablishedYear: "*Você deve inserir um Ano de fundação",
  youMustEnterASince: "*Você deve inserir um Desde",
  youMustEnterAnEntityLegalName: "*Você deve inserir um Nome legal da entidade",
  youMustEnterAWebsite: "*Você deve inserir um Website",
  youMustEnterAContactName: "*Você deve inserir um Nome do contato",
  youMustEnterAContactType: "*Você deve inserir um Tipo de contato",
  startTypingToSearchDots: "Comece a digitar para pesquisar...",
  established: "Fundado",
  establishedYear: "Ano de fundação",
  since: "Desde",
  entity: "Entidade",
  entityLegalName: "Nome legal da entidade",
  mobile: "Celular",
  customerDetails: "Detalhes do cliente",
  editCustomer: "Editar Cliente",
  useTheSameAddressForPostalAddress: "Usar o mesmo endereço para endereço postal?",
  registrationNumber: "Número de registro",
  addAnotherContact: "Adicionar outro contato",
  includeInEmail: "Incluir no e-mail",
  consultant: "Consultor",
  searchConsultant: "Pesquisar consultor",
  searchWarehouse: "Pesquisar armazém",
  searchTimezone: "Pesquisar fuso horário",
  billingEmail: "E-mail de cobrança",
  postalAddress: "Endereço postal",
  contact: "Contato",
  contactPerson: "Pessoa de Contato",
  invalidLink: "Link inválido",
  closeWindow: "Fechar janela",
  youHaventAcceptedTheInvitation: "Você não aceitou o convite",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink: "Este link não é válido. Verifique se você acessou o link correto",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay: "Você pode fechar esta janela com segurança. Se precisar de mais ajuda, sinta-se à vontade para entrar em contato. Tenha um ótimo dia!",
  enterLocationName: "Inserir nome de localização",
  enterWebsite: "Inserir website",
  enterRegistrationNumber: "Inserir número de registro",
  primaryContact: "Contato principal",
  createLocation: "Criar localização",
  viewLocation: "Ver localização",
  editLocation: "Editar localização",
  jobType: "Tipo de Trabalho",
  warehouseOrigin: "Armazém de origem",
  warehouseDestination: "Armazém de destino",
  tag: "Etiqueta",
  billingAs: "Cobrado como:",
  leadSourceFrom: "Fonte do lead",
  moveCoordinator: "Coordenador de mudança",
  inventoryQuoted: "Inventário cotado",
  inventoryLeader: "Líder de inventário",
  inventoryActual: "Inventário real",
  myDetails: "Meus detalhes",
  orderDetails: "Detalhes do Pedido",
  actualAsQuoted: "Real como cotado",
  movingFrom: "Saindo de",
  movingTo: "Indo para",
  itemQuantity: "Quantidade de itens",
  inventories: "Inventários",
  originContact: "Contato de origem",
  destinationContact: "Contato de destino",
  seeAccessChecklist: "Ver lista de verificação de acesso",
  pickupAccessDetails: "Detalhes de acesso para coleta",
  deliveryAccessDetails: "Detalhes de acesso para entrega",
  noContactsAdded: "Nenhum contato adicionado",
  complement: "Complemento",
  street: "Rua",
  typeOfBuilding: "Tipo de construção",
  loadingDockHeight: "Altura da doca de carga",
  liftAvailable: "Elevador disponível",
  accessInstructions: "Instruções de acesso",
  navigationNotes: "Notas de navegação",
  createYourShipeeziAccount: "Crie sua conta no Shipeezi",
  createAccount: "Crie sua conta",
  haveAnAccountSignIn: "Tem conta? Entrar",
  mode: "Modal",
  service: "Serviço",
  editOrder: "Editar Pedido",
  newOrder: "Novo Pedido",
  weight: "Peso",
  truckType: "Tipo de caminhão",
  carrier: "Transportadora",
  truckBookingNumber: "Número de reserva do caminhão",
  trackingNumber: "Número de Rastreamento",
  palletsPerTruck: "Paletes por caminhão",
  deliveryDate: "Data de entrega",
  proposedDeliveryDate: "Data de entrega proposta",
  bookingDetails: "Detalhes da reserva",
  deliveryAddress: "Endereço de entrega",
  deliveryAddressLine: "Linha de endereço de entrega",
  deliveryAddressSuburb: "Bairro de entrega",
  receiver: "Destinatário",
  senderAddress: "Endereço do remetente",
  senderAddressLine: "Linha de endereço do remetente",
  senderAddressSuburb: "Bairro do remetente",
  palletsQty: "Qtd. de paletes",
  cartonQty: "Qtd. de caixas",
  despatchDate: "Data de despacho",
  pleaseEnterAYourFirstName: "*Por favor, insira seu Nome.",
  pleaseEnterAYourLastName: "*Por favor, insira seu Sobrenome.",
  pleaseEnterAYourEmailAddress: "*Por favor, insira seu endereço de e-mail.",
  pleaseEnterAPassword: "*Por favor, insira uma senha.",
  pleaseConfirmAPassword: "*Por favor, confirme a senha.",
  pleaseEnterAUsername: "*Por favor, insira um nome de usuário.",
  pleaseEnterAMobilePhone: "*Por favor, insira um celular.",
  atLeastOnePhotoIsRequired: "*É necessária pelo menos uma foto",
  atLeastOneProductIsRequired: "Pelo menos um produto é necessário",
  thisEmailIsInvalid: "*Este e-mail é inválido",
  thisFieldIsRequired: "Este campo é obrigatório",
  selectAnAccessRule: "Selecionar uma regra de acesso",
  youNeedToSelectAtLeastOneBranch: "*Você precisa selecionar pelo menos uma filial",
  youNeedToSelectAtLeastOneSection: "*Você precisa selecionar pelo menos uma seção",
  youNeedToSelectAtLeastOneContact: "*Você precisa selecionar pelo menos um contato",
  youMustEnterACustomer: "*Você deve inserir um cliente",
  youMustEnterAEmail: "*Você deve inserir um e-mail",
  youMustEnterAnMobile: "*Você deve inserir um celular",
  youMustHaveAtLeastOneLocation: "*Você deve ter pelo menos uma localização",
  youMustHaveAtLeastOnePrimaryLocation: "*Você deve ter pelo menos uma localização principal",
  pleaseEnterAValidEmail: "*Por favor insira um e-mail válido",
  quoted: "Cotado",
  actual: "Real",
  totalItems: "Total de itens",
  registered: "Registrado",
  loaded: "Carregado",
  taken: "Retirado",
  delivered: "Entregue",
  void: "Nulo",
  disposal: "Descarte",
  missing: "Faltando",
  missingShipment: "Envio faltando",
  shipped: "Enviado",
  packed: "Embalado",
  uplifted: "Coletado",
  bol: "BoL",
  selectNewStatusForItem: "Selecionar novo status para item",
  item: "Item",
  items: "Itens",
  packer: "Embalador",
  selectPacker: "Selecionar embalador",
  selectNewStatusForItems: "Selecionar novo status para itens",
  newStatus: "Novo status",
  changeItemsStatus: "Alterar status dos itens",
  addNewItem: "Adicionar novo item",
  createNewItem: "Criar novo item",
  addNewRoom: "Adicionar novo cômodo",
  editItem: "Editar item",
  viewItem: "Ver item",
  createNewOne: "Criar + Novo",
  comment: "Comentário",
  createNewComment: "Criar novo comentário",
  newComment: "Novo comentário",
  commentBy: "Comentário de",
  hideCommentHistory: "Ocultar histórico de comentários",
  seeCommentHistory: "Ver histórico de comentários",
  copyInfoFromPickup: "Copiar informações da Coleta",
  copyInfoFromDelivery: "Copiar informações da Entrega",
  pickup: "Coleta",
  pickUp: "Coleta",
  delivery: "Entrega",
  switchToManual: "Mudar para entrada manual de endereço",
  switchToGoogle: "Mudar para entrada pelo Google Maps",
  addAnotherAddress: "Adicionar outro endereço",
  selectATask: "Selecionar uma tarefa",
  enterADateInField: "Inserir uma data no campo",
  theSurveyDateMustBeGreaterThanTheCurrentDate: "A data da pesquisa deve ser maior que a data atual",
  time: "Hora",
  date: "Data",
  addATask: "Adicionar uma tarefa",
  enterOnTheVideoSurvey: "Entrar na pesquisa de vídeo",
  startVideoSurvey: "Iniciar Pesquisa de Vídeo",
  scheduleAVideoSurvey: "Agendar uma Pesquisa de Vídeo",
  thisDateIsInvalid: "Esta data é inválida",
  notAvailable: "Não disponível",
  addATaskHomeSurveyOrVideoSurveyToCreateAQuote: "Adicione uma tarefa de Vistoria Presencial ou Vistoria por Vídeo para criar um orçamento",
  pickupAccess: "Acesso de Coleta",
  deliveryAccess: "Acesso de Entrega",
  switchToPickupAccess: "Mudar para acesso de coleta",
  switchToDeliveryAccess: "Mudar para acesso de entrega",
  duplicate: "Duplicar",
  willTheEntryOfTheHouseBeObstructed: "A entrada da casa será obstruída?",
  driveway: "Entrada de veículos",
  steep: "Íngreme",
  long: "Longo",
  whatIsTheLengthM: "Qual é o comprimento (m)?",
  residence: "Residência",
  residenceType: "Tipo de residência",
  house: "Casa",
  apartment: "Apartamento",
  level: "Nível",
  howManyLevels: "Quantos andares?",
  groundFloor: "Térreo",
  split: "Dividido",
  multiStorey: "Vários andares",
  steps: "Degraus",
  notAuthorizedByCustomer: "Não autorizado pelo cliente",
  photos: "Fotos",
  addPhoto: "Adicionar foto",
  hasLift: "Possui elevador?",
  lift: "Elevador",
  internal: "Interno",
  external: "Externo",
  streetAccess: "Acesso pela rua",
  wide: "Largo",
  narrow: "Estreito",
  step: "Degrau",
  normal: "Normal",
  permitRequired: "Permissão necessária",
  oneWay: "Mão única",
  culDeSac: "Beco sem saída",
  roundabout: "Rotatória",
  speedHumps: "Lombadas",
  noThroughRoad: "Via sem saída",
  road: "Rodoviário",
  sea: "Marítimo",
  air: "Aéreo",
  ferry: "Balsa",
  storage: "Armazenamento",
  other: "Outro",
  parking: "Estacionamento",
  parkingType: "Tipo de estacionamento",
  carry: "Transportar",
  carryM: "Transportar(m)",
  treesPowerline: "Árvores/Rede elétrica",
  overhanging: "Pendente",
  low: "Baixo",
  action: "Ação",
  vehicleSize: "Tamanho do veículo",
  small: "Pequeno",
  rigid: "Rígido",
  semi: "Semi",
  isFerryRequired: "É necessário balsa?",
  saveAComment: "Salvar um comentário",
  createComment: "Criar comentário",
  saveABookmark: "Salvar um favorito",
  takeAScreenshot: "Tirar uma captura de tela",
  accessDetailsDescribedAboveAreAccurateToTheBestOfMyKnowledge: "Os detalhes de acesso descritos acima são precisos de acordo com meu melhor conhecimento.",
  specialInstructions: "Instruções Especiais",
  itemInstructionStatus: "Status da instrução do item",
  deleteAddress: "Excluir endereço",
  thereAreItemsOrMaterialsRegisteredWithThisAddressIfYouDeleteThisAddressNowAllItemsWillBeRegisteredWithTheMainDeliveryAddressWouldYouLikeToDoThat: "Há itens ou materiais registrados com este endereço. Se você excluir este endereço agora, todos os itens serão registrados com o endereço de entrega principal. Deseja fazer isso?",
  inventory: "Inventário",
  itemDetails: "Detalhes do item",
  materialDetails: "Material - Detalhes",
  addAnother: "Adicionar outro",
  fileIsTooBigMax2Mb: "Arquivo muito grande (Máximo 2MB)",
  thisFileExtensionIsNotAllowed: "Esta extensão de arquivo não é permitida",
  fileIsTooBigMax8Mb: "Arquivo muito grande (Máximo 8MB)",
  fileAlreadyExistsInThisFolder: "Arquivo já existe nesta pasta",
  anotherFolderWithThisNameAlreadyExists: "Outra pasta com este nome já existe",
  newFolder: "Nova Pasta",
  upload: "Enviar",
  uploading: "Enviando",
  uploadingYourContent: "Enviando seu conteúdo",
  share: "Compartilhar",
  shared: "Compartilhado",
  unshare: "Cancelar compartilhamento",
  notBeingShared: "Não está sendo compartilhado",
  stopSharing: "Parar de compartilhar",
  cancelRequest: "Cancelar solicitação",
  requestDocument: "Solicitar documento",
  empty: "Vazio",
  file: "Arquivo",
  files: "Arquivos",
  folder: "Pasta",
  rename: "Renomear",
  currentStock: "Estoque Atual",
  theFolderNameIsRequired: "O nome da pasta é obrigatório",
  theFileNameIsRequired: "O nome do arquivo é obrigatório",
  accessChecklistSummary: "Resumo da Lista de Verificação de Acesso",
  selectAnOption: "Selecione uma opção",
  searchTask: "Buscar Tarefa",
  anErrorOccuredTryAgain: "Ocorreu um erro, tente novamente.",
  secondContact: "Segundo Contato",
  pleaseSelectAQuoteType: "Por favor, selecione um tipo de orçamento",
  pleaseFillAReference: "Por favor, preencha uma referência",
  pleaseSelectAStatus: "Por favor, selecione um status",
  pleaseSelectAConsultant: "Por favor, selecione um Consultor",
  pleaseSelectAManager: "Por favor, selecione um Gerente",
  pleaseSelectAMode: "Por favor, selecione um Modo",
  pleaseFillPickUpCustomerFields: "Por favor, preencha os campos do cliente de coleta",
  pleaseFillPickUpAddressFields: "Por favor, preencha os campos de endereço de coleta",
  pleaseFillDeliveryCustomerFields: "Por favor, preencha os campos do cliente de entrega",
  pleaseFillDeliveryAddressFields: "Por favor, preencha os campos de endereço de entrega",
  pleaseCheckTheAccessDetailsDescribedOnPickupAccess: "Por favor, verifique os detalhes de acesso descritos no acesso de coleta",
  customRange: "Intervalo Personalizado",
  summaryFromSales: "Resumo de Vendas",
  toAddAnOrderClickOnTheButtonBelow: "Para adicionar um pedido, clique no botão abaixo.",
  addOrderToAShipment: "Adicionar pedido a uma remessa",
  addOrder: "Adicionar Pedido",
  addOrders: "Adicionar Pedidos",
  changeOrderToAShipment: "Alterar pedido para uma remessa",
  selectShipmentsBelowToAddThem: "Selecione as remessas abaixo para adicioná-las.",
  matchOrigin: "Corresponder Origem",
  matchDestination: "Corresponder Destino",
  notSent: "Não Enviado",
  shipmentOrigin: "Origem do Embarque",
  shipmentDestination: "Destino do Embarque",
  portName: "Nome do Porto",
  airportName: "Nome do Aeroporto",
  recordDeleted: "Registro excluído",
  noVideoRecorded: "Nenhum vídeo gravado",
  noCommentsRegistered: "Nenhum comentário registrado",
  noScreenshotsRegistered: "Nenhuma captura de tela registrada",
  noBookmarksRegistered: "Nenhum marcador registrado",
  videoSurvey: "Pesquisa em Vídeo",
  videos: "Vídeos",
  communication: "Comunicação",
  document: "Documento",
  documents: "Documentos",
  documentSharing: "Compartilhamento de Documentos",
  documentsForThisBooking: "Documentos desta reserva",
  map: "Mapa",
  costing: "Custeio",
  addProduct: "Adicionar Produto",
  addProducts: "Adicionar Produtos",
  addProductToCarton: "Adicionar Produto à Caixa",
  sendEmail: "Enviar E-mail",
  sendSMS: "Enviar SMS",
  attachmentFailedPleaseTryAgainLater: "Falha no anexo. Por favor, tente novamente mais tarde!",
  clickToViewJson: "Clique para visualizar JSON",
  closeJsonFile: "Fechar Arquivo JSON",
  invalidEmailFormat: "Formato de E-mail Inválido",
  emailSuccessfullySent: "E-mail enviado com sucesso!",
  somethingWentWrongPleaseTryAgain: "Algo deu errado. Por favor, tente novamente!",
  typeTheEmailAddressEnter: "Digite o endereço de e-mail + enter",
  addGroupCosting: "Adicionar Custeio do Grupo",
  deleteConfirmation: "Confirmação de Exclusão",
  areYouSureYouWantToRemoveThisItem: "Tem certeza que deseja remover este item?",
  selectAtLeastOneItemToChangeStatus: "Selecione pelo menos um item para alterar o status",
  anItemWasAddToTheSelectedRoom: "Um item foi adicionado ao cômodo selecionado",
  aRoomHasBeenAddedToTheInventory: "Um cômodo foi adicionado ao inventário",
  anItemWasUpdatedAtTheSelectedRoom: "Um item foi atualizado no cômodo selecionado",
  anItemWasRemovedFromTheSelectedRoom: "Um item foi removido do cômodo selecionado",
  couldNotFindItemToDuplicate: "Não foi possível encontrar o item para duplicar",
  emailSentSuccesfuly: "E-mail enviado com sucesso!",
  smsSentSuccesfuly: "SMS enviado com sucesso!",
  couldNotSendEmail: "Não foi possível enviar o e-mail",
  ifAMatchingAccountWasFoundAnEmailWasSentTo: "Se uma conta correspondente foi encontrada, um e-mail foi enviado para",
  toAllowYouToResetYourPassword: "para permitir que você redefina sua senha.",
  isAnUser: "É um usuário",
  isNotAnUser: "Não é um usuário",
  allContacts: "Todos os contatos",
  seeAllOfYourBusinessContacts: "Ver todos os seus contatos comerciais",
  editContact: "Editar contato",
  addContact: "Adicionar contato",
  addLocation: "Adicionar localização",
  addContactUser: "Adicionar usuário de contato",
  editContactUser: "Editar usuário de contato",
  viewAllContacts: "Ver todos os contatos",
  registerAsAnUser: "Registrar como usuário",
  editThisBusinessContact: "Editar este contato comercial",
  contactDetails: "Detalhes do Contato",
  pleaseEnterARegistrationNumber: "Por favor, insira um número de registro",
  otherDetails: "Outros detalhes",
  shipeeziNetwork: "Rede Shipeezi",
  agentIsConnectedToTheShipeezisNetwork: "O agente está conectado à rede do Shipeezi",
  inviteToNetwork: "Convidar para a rede",
  actions: "Ações",
  sortBy: "Ordenar por",
  inactiveCompany: "Empresa inativa",
  billing: "Faturamento",
  primary: "Principal",
  secondary: "Secundário",
  general: "Geral",
  generalPhoto: "Foto Geral",
  overview: "Visão Geral",
  manageUsers: "Gerenciar usuários",
  monthlyPayment: "Pagamento mensal",
  addSeats: "Adicionar assentos",
  currentPlan: "Plano atual",
  changePlan: "Alterar plano",
  lastPaidInvoice: "Última fatura paga",
  billingDetails: "Detalhes de cobrança",
  editPaymentDetails: "Editar detalhes de pagamento",
  cardHolder: "Titular do cartão",
  creditCardNumber: "Número do cartão de crédito",
  cvv: "CVV",
  expDate: "Data de validade",
  billingAddress: "Endereço de Cobrança",
  people: "Pessoas",
  resources: "Recursos",
  configurations: "Configurações",
  preferences: "Preferências",
  orderType: "Tipo de Pedido",
  leadSource: "Fonte do lead",
  statuses: "Status",
  integrations: "Integrações",
  apiAllied: "API Allied",
  history: "Histórico",
  checklistForms: "Checklists e Formulários",
  fleet: "Frota",
  equimpent: "Equipamento",
  staff: "Equipe",
  itemList: "Lista de Itens",
  packagingType: "Tipo de embalagem",
  modeType: "Tipo de modal",
  exceptionCodes: "Códigos de exceção",
  exceptionLocationCode: "Código de localização de exceção",
  materials: "Materiais",
  instructions: "Instruções",
  itemDestination: "Destino do item",
  automation: "Automação",
  access: "Acesso",
  iso174511: "ISO17451-1:2016 - Certificado",
  createNewUser: "Criar novo usuário",
  createNewRole: "Criar novo perfil",
  createNewCustomer: "Criar novo cliente",
  deleteCustomer: "Excluir cliente",
  deleteAgent: "Excluir agente",
  deleteSelected: "Excluir selecionados",
  typePressEnter: "Digite + Pressione enter",
  createUser: "Criar usuário",
  viewUser: "Visualizar usuário",
  viewUsers: "Visualizar usuários",
  editUser: "Editar usuário",
  useCompanyAddress: "Usar endereço da empresa",
  timezoneIsUpdatedAutomaticallyToMatchYourComputerTimezone: "O fuso horário é atualizado automaticamente para corresponder ao fuso do seu computador",
  inactiveUser: "Usuário inativo",
  activeUser: "Usuário ativo",
  logUserOut: "Desconectar usuário",
  searchAndSelectTheRoleTo: "Buscar e selecionar o perfil para",
  assignUsers: "Atribuir usuários",
  searchAndSelectUsersTo: "Buscar e selecionar usuários para",
  viewRole: "Visualizar perfil",
  editThisRole: "Editar este perfil",
  viewThisRole: "Visualizar este perfil",
  setPermissions: "Definir permissões",
  addANewItem: "Adicionar um novo item",
  viewAnItem: "Visualizar um item",
  editAnItem: "Editar um item",
  editLocationForCustomer: "Editar localização do cliente",
  createNewLocationForCustomer: "Criar nova localização do cliente",
  viewLocationForCustomer: "Visualizar localização do cliente",
  editOrderType: "Editar tipo de pedido",
  createNewOrderType: "Criar novo tipo de pedido",
  editLeadSource: "Editar fonte do lead",
  createNewLeadSource: "Criar nova fonte do lead",
  leadSourceStatus: "Status da fonte do lead",
  editStatus: "Editar status",
  createNewStatus: "Criar novo status",
  itemName: "Nome do Item",
  itemCode: "Código do Item",
  itemVolume: "Volume do Item",
  itemWeight: "Peso do Item",
  photosAreMandatory: "Fotos são obrigatórias",
  brandIsMandatory: "Marca é obrigatória",
  commentIsMandatory: "Comentário é obrigatório",
  mEChecklistIsMandatory: "Checklist M&E é obrigatório",
  inactiveItem: "Item inativo",
  roomName: "Nome do Cômodo",
  roomCode: "Código do Cômodo",
  inactiveLocation: "Localização Inativa",
  editPackagingType: "Editar Tipo de Embalagem",
  createPackagingType: "Criar Tipo de Embalagem",
  packagingTypeName: "Nome do tipo de embalagem",
  packagingTypeCode: "Código do tipo de embalagem",
  yourComment: "Seu comentário",
  packagingTypeStatus: "Status do tipo de embalagem",
  reason: "Motivo",
  code: "Código",
  enterTypeOfContact: "Inserir tipo de contato",
  dimensions: "Dimensões",
  couldnTSubscribeShipment: "Não foi possível assinar o embarque",
  couldnTRetrieveShipmentStatus: "Não foi possível recuperar o status do embarque",
  voyageStatusUpdated: "Status da viagem atualizado",
  pod: "Pod",
  pressEnterToAdd: "Pressione enter para adicionar",
  inputYourComments: "Insira seus comentários",
  portOfDestination: "Porto de Destino",
  placeOfDestination: "Local de destino",
  containerGateInAtPol: "Entrada do contêiner no POL",
  containerGateInPort: "Entrada do contêiner no porto",
  nextPort: "Próximo Porto",
  containerLoadedAtFirstPolPortOfLoad: "Contêiner carregado no primeiro POL (Porto de Carregamento)",
  containerGateOutAtPodPortOfDischarge: "Saída do contêiner no POD (Porto de Descarga)",
  originPort: "Porto de Origem",
  finalDestinationPort: "Porto de Destino Final",
  estimatedArrival: "Chegada Estimada",
  actualArrival: "Chegada Real",
  carrierEstimatedArrival: "Chegada Estimada pelo Armador",
  carrierActualArrival: "Chegada Real pelo Armador",
  arrivalAtPort: "Chegada ao Porto",
  departureAtPort: "Saída do Porto",
  predictiveArrivalAt: "Chegada preditiva em",
  arrivalAt: "Chegada em",
  editCurrency: "Editar Moeda",
  createCurrency: "Criar Moeda",
  editItemInstruction: "Editar Instrução do Item",
  createItemInstruction: "Criar Instrução do Item",
  addANewCurrency: "Adicionar uma nova moeda",
  australianDollar: "Dólar australiano",
  a: "A$",
  currencyView: "Visualização de Moeda",
  currencyStatus: "Status da moeda",
  editLanguage: "Editar Idioma",
  actualStatus: "Status Real",
  createNewLanguage: "Criar novo idioma",
  baseLanguage: "Idioma base",
  en: "EN",
  measurementStatus: "Status da medida",
  flag: "Sinalização",
  where: "Onde",
  usage: "Uso",
  filteringBy: "Filtrando por ",
  editModeType: "Editar Tipo de Modo",
  createModeType: "Criar Tipo de Modo",
  editThisModeType: "Editar este tipo de modo",
  addNewModeType: "Adicionar novo tipo de modo",
  modeTypeStatus: "Status do tipo de modo",
  needAddAHomeOrVideoSurvey: "Necessário adicionar uma Vistoria Presencial ou por Vídeo",
  quotedInventory: "Inventário Orçado",
  chooseADestination: "Escolha um destino",
  aMaterialWasAddToTheSelectedRoom: "Um material foi adicionado ao cômodo selecionado",
  pressEnterToSaveOrEscToCancel: "Pressione Enter para salvar ou ESC para cancelar",
  youHaveToChooseAQuoteModeToAddAnItem: "Você precisa escolher um modo de orçamento para adicionar um item",
  youHaveToChooseAQuoteModeToAddAMaterial: "Você precisa escolher um modo de orçamento para adicionar um material",
  youHaveToSelectARoomBeforeAddAMaterial: "Você precisa selecionar um cômodo antes de adicionar um material",
  aRoomWithThisNameAlreadyExists: "Já existe um cômodo com este nome",
  youHaveToSelectARoomBeforeAddAnItem: "Você precisa selecionar um cômodo antes de adicionar um item",
  generateToken: "Gerar token",
  copyToken: "Copiar token",
  copiedSuccessfully: "Copiado com sucesso",
  unitQty: "Qtd. Unitária",
  productQty: "Qtd. Produto",
  qtyStock: "Qtd. (Estoque)",
  qtyShipping: "Qtd. (Envio)",
  latitude: "Latitude",
  longitude: "Longitude",
  vesselType: "Tipo de Embarcação",
  vesselPosition: "Posição da embarcação",
  speedKnots: "Velocidade (Nós)",
  editMeasurement: "Editar Medida",
  createMeasurement: "Criar Medida",
  createNewStaff: "Criar novo colaborador",
  viewStaff: "Ver colaborador",
  male: "Masculino",
  female: "Feminino",
  createService: "Criar Serviço",
  editService: "Editar serviço",
  viewService: "Ver serviço",
  serviceStatus: "Status do serviço",
  sellDescription: "Descrição de venda",
  serviceDescription: "Descrição do serviço",
  sellType: "Tipo de venda",
  m3Fee: "Taxa M3",
  defaultPrice: "Preço padrão",
  serviceGroup: "Grupo de serviço",
  inputMessage: "Mensagem de entrada",
  viewChecklist: "Ver Lista de Verificação",
  editChecklist: "Editar Lista de Verificação",
  createChecklist: "Criar Lista de Verificação",
  emptyList: "Lista Vazia",
  addAll: "Adicionar todos",
  addType: "Adicionar Tipo",
  addBranch: "Adicionar filial",
  jobTypeAlreadyExistInTheList: "Tipo de trabalho já existe na lista",
  branchAlreadyExistInTheList: "Filial já existe na lista",
  riskAssessment: "Avaliação de Risco",
  vehicleTrailer: "Veículo/Reboque",
  required: "Obrigatório",
  title: "Bem-vindo ao Shipeezi — onde visibilidade, controle e simplicidade se unem.",
  needAction: "Necessita de Ação",
  answerAction: "Responder Ação",
  addNewQuestion: "Adicionar nova pergunta",
  trigger: "Gatilho",
  addNewTrigger: "Adicionar novo gatilho",
  notes: "Notas",
  taskTypeAlreadyExistInTheList: "Tipo de tarefa já existe na lista",
  taskType: "Tipo de Tarefa",
  questions: "Perguntas",
  appTriggers: "Gatilhos do App",
  beforeStartTask: "Antes de iniciar a tarefa",
  beforeContinueTask: "Antes de continuar a tarefa",
  beforeFinishTask: "Antes de finalizar a tarefa",
  beforeAcceptTask: "Antes de aceitar a tarefa",
  text: "Texto",
  checkbox: "Caixa de seleção",
  decimal: "Decimal",
  integer: "Inteiro",
  signature: "Assinatura",
  photo: "Foto",
  checkboxText: "Caixa de Seleção e Texto",
  radioButton: "Botão de Rádio",
  textarea: "Área de texto",
  radioButtonText: "Botão de Rádio e Texto",
  johnny: "Johnny",
  bravo: "Bravo",
  john: "John",
  sampleEmailCom: "sample@email.com",
  emergency: "Emergência",
  pendingCustomerUpload: "Aguardando envio do cliente",
  sharedWithCustomer: "Compartilhado com o cliente",
  resendRequest: "Reenviar solicitação",
  uploadedByCustomer: "Enviado pelo cliente",
  noDocumentsRequestedYet: "Nenhum documento solicitado ainda",
  donTWorryIfAnyDocumentsAreRequestedByUsYouWillBeNotifiedAndWillBeAbleToManageThem: "Não se preocupe, se algum documento for solicitado por nós, você será notificado e poderá gerenciá-los.",
  oneOrMoreRequiredFieldsAreEmpty: "Um ou mais campos obrigatórios estão vazios",
  noChangeHasBeenDetected: "Nenhuma alteração foi detectada",
  noCommentsBeTheFirstToComment: "Sem comentários! Seja o primeiro a comentar...",
  mainAddress: "Endereço Principal",
  createANewBusinessContact: "Criar um novo contato comercial",
  editABusinessContact: "Editar um contato comercial",
  includeInCommunications: "Incluir nas comunicações",
  thisUserNeedsToHaveSomeProjectSelected: "Este usuário precisa ter algum projeto selecionado",
  thisUserNeedsToHaveSomeRoleSelected: "Este usuário precisa ter alguma função selecionada",
  thePasswordDoesNotMatch: "A senha não corresponde",
  selectPerformancePrediction: "Selecionar Previsão de Desempenho",
  performancePrediction: "Previsão de Desempenho",
  passwordAndConfirmPasswordMustBeTheSame: "A senha e a confirmação de senha devem ser iguais",
  newPasswordAndConfirmPasswordMustBeTheSame: "A nova senha e a confirmação de nova senha devem ser iguais",
  hiThere: "Olá!",
  pleaseFindTheJsonFileAttachedForShipmentS: "Por favor, encontre o arquivo json em anexo para a(s) remessa(s)",
  best: "Melhor, ",
  discard: "Descartar",
  discardChanges: "Descartar alterações",
  areYouSureYouWantToDiscardAllChanges: "Tem certeza de que deseja descartar todas as alterações?",
  thisActionIsPermanentAndCannotBeUndone: "Esta ação é permanente e não pode ser desfeita!",
  shipeeziAustralia: "Shipeezi  Australia",
  supportShipeeziCom: "support@shipeezi.com",
  wwwShipeeziCom: "www.shipeezi.com",
  shipeeziKey: "Chave Shipeezi",
  termsOfUsePrivacyPolicySecurityPolicy: "Termos de uso, Política de privacidade, Política de segurança",
  andSaasAgreement: " e Acordo SaaS ",
  agreed: "concordado",
  thisCurrencyIsAlreadyRelatedToACompanyThereforeYouCannotChangeHisStatus: "Esta moeda já está relacionada a uma empresa, portanto você não pode alterar seu status.",
  select: "Selecionar",
  hello: "Olá,",
  dateRange: "Intervalo de Datas",
  viewToday: "Ver Hoje",
  activeQuotes: "Orçamentos Ativos",
  quotedVolume: "Volume Orçado",
  videoSurveys: "Vistorias por Vídeo",
  activeOrders: "Pedidos Ativos",
  orderVolume: "Volume de Pedidos",
  branchOrigin: "Filial de origem",
  branchDestination: "Filial de destino",
  material: "Material",
  accessStatus: "Status de acesso",
  instruction: "Instrução",
  scheduleCreateSuccessfully: "Agendamento criado com sucesso",
  sendAutomaticalyASmsEmailInvite: "Enviar automaticamente um convite por SMS/E-mail",
  theEmailOrPhoneIsAlreadyInUseByAnotherCustomer: "O e-mail ou telefone já está em uso por outro cliente",
  wouldYouLikeToSendTheDetailsOfTheCallToYourCustomerBy: "Deseja enviar os detalhes da chamada ao seu cliente por",
  assignRole: "Atribuir Função",
  duplicateRole: "Duplicar Função",
  accessRule: "Regra de Acesso",
  accessRules: "Regras de Acesso",
  membersInGroup: "Membros neste grupo",
  showAll: "Mostrar Todos",
  enterNameForThisGroup: "Insira o nome para este grupo",
  describeThisGroupInFewWords: "Descreva este grupo em poucas palavras",
  groupCreatedSuccessfully: "Grupo '{{groupName}}' criado com sucesso",
  groupUpdatedSuccessfully: "Grupo '{{groupName}}' atualizado com sucesso",
  anErrorOccurredWhileUpdatingGroup: "Ocorreu um erro ao atualizar o grupo '{{groupName}}'. Entre em contato com o suporte do Shipeezi para obter assistência",
  thisIsADefaultSystemGroupThatCannotBeModifiedButYouCanAddOrRemoveMembersFromIt: "Este é um grupo padrão do sistema que não pode ser modificado, mas você pode adicionar ou remover membros dele",
  kindlyResolveTheFormErrorsBeforeProceeding: "Resolva os erros do formulário antes de prosseguir ...",
  theGroupNameAlreadyExistsPleaseChooseADifferentName: "O nome do grupo '{{groupName}}' já existe. Por favor, escolha um nome diferente.",
  changeStatus: "Alterar Status",
  purchase: "Compra",
  purchaseOrder: "Pedido de Compra",
  salesOrder: "Pedido de Venda",
  asPlanned: "Conforme planejado",
  potentialDelay: "Atraso Potencial",
  delayed: "Atrasado",
  selectAVideoSurveyOfToday: "Selecionar uma vistoria por vídeo de hoje",
  openVideoSurvey: "Abrir Vistoria por Vídeo",
  searchOrAddAReference: "Buscar ou adicionar uma referência",
  searchOriginAddress: "Buscar Endereço de Origem",
  searchDestinationAddress: "Buscar Endereço de Destino",
  searchOrAddACustomer: "Buscar ou adicionar um cliente",
  jobAlreadyExists: "Trabalho já existe",
  associateCustomer: "Associar Cliente",
  thereIsAlreadyACustomerWithThisEmailOrPhoneNumberDoYouWantToAssociateTheTask: "Já existe um cliente com este e-mail ou número de telefone, deseja associar a tarefa?",
  associate: "Associar",
  phone: "Número de telefone",
  translation: "Tradução",
  viewActivity: "Ver Atividade",
  seeActivity: "Ver Atividade",
  activity: "Atividade",
  createItem: "Criar item",
  folders: "Pastas",
  shipment: "Envio",
  quotes: "Cotações",
  estimate: "Estimativa",
  loadingQuotes: "Carregando cotações",
  quotesWonVsLost: "Cotações ganhas vs perdidas",
  quotesWon: "cotações ganhas",
  quotesLost: "cotações perdidas",
  won: "Ganho",
  lost: "Perdido",
  lastUpdatedOn: "Última atualização",
  instructionsNotFound: "Instruções não encontradas",
  quotesPerformed: "Cotações realizadas",
  ordersByType: "Pedidos por tipo",
  orders: "Pedidos",
  loadingOrders: "Carregando pedidos",
  itFeelsABitEmpty: "Parece um pouco vazio",
  videoName: "Nome do vídeo",
  fetchingVideo: "Buscando vídeo",
  fetchDetails: "Buscar detalhes",
  videoUploadInProgress: "Upload de vídeo em andamento",
  noVideoAvailable: "Nenhum vídeo disponível",
  screenshots: "Capturas de tela",
  imageOfAScreenshot: "Imagem de uma captura de tela",
  fetchingScreenshots: "Buscando capturas de tela",
  seeMore: "Ver mais",
  noScreenshotAvailable: "Nenhuma captura de tela disponível",
  fetchingComments: "Buscando comentários",
  noCommentsAvailable: "Nenhum comentário disponível",
  screenSharing: "Compartilhar tela",
  bookmarks: "Favoritos",
  fetchingBookmarks: "Buscando favoritos",
  noBookmarksAvailable: "Nenhum favorito disponível",
  bookmarkSavedSuccessfully: "Favorito salvo com sucesso.",
  couldNotSaveBookmark: "Não foi possível salvar o favorito",
  searchByCustomerNamePhoneNumberOrEmailAddress: "Pesquisar por nome do cliente, número de telefone ou e-mail",
  searchManager: "Pesquisar gerente",
  totalQty: "Qtd. total",
  totalVolume: "Volume Total",
  totalWeight: "Peso total",
  contacts: "Contatos",
  createANewWarehouse: "Criar um novo armazém",
  editWarehouse: "Editar Armazém",
  createANewBranch: "Criar uma nova filial",
  editBranch: "Editar Filial",
  viewBranch: "Visualizar Filial",
  viewWarehouse: "Visualizar Armazém",
  closeAllPanels: "Fechar todos os painéis",
  collapseAllPanels: "Recolher todos os painéis",
  expandAllPanels: "Expandir todos os painéis",
  expandAll: "Expandir tudo",
  collapseAll: "Recolher tudo",
  tba: "TBA",
  editMaterial: "Editar material",
  createANewMaterial: "Criar um novo material",
  materialStatus: "Status do material",
  isAnItem: "É um item?",
  editInstruction: "Editar instrução",
  createInstruction: "Criar instrução",
  when: "Quando",
  editTaskType: "Editar tipo de tarefa",
  createTaskType: "Criar tipo de tarefa",
  taskTypeStatus: "Status do tipo de tarefa",
  isBookable: "É reservável?",
  isItBookable: "É reservável?",
  viewDestination: "Ver destino",
  editDestination: "Editar destino",
  createDestination: "Criar destino",
  destinationStatus: "Status do destino",
  colorValueMustStartWithAndCannotBeAWhiteColor: "O valor da cor deve começar com # e não pode ser branco",
  automaticSequencing: "Sequenciamento automático",
  nextNumber: "Próximo número",
  changeStatuses: "Alterar status",
  changeAllSelectedStatusesTo: "Alterar todos os status selecionados para",
  changeItemStatuses: "Alterar status dos itens",
  changeAllSelectedItemsStatusesTo: "Alterar todos os status dos itens selecionados para",
  visibilityControlAndTransparencyOfYourShipments: "Visibilidade, controle e transparência dos seus envios.",
  yourRequestHasExpiredMakeANewRecovery: "Sua solicitação expirou. Faça uma nova recuperação",
  pleaseEnterAEmail: "Por favor, insira um e-mail.",
  resetPassword: "Redefinir senha",
  pleaseCheckYourEmail: "Por favor, verifique seu e-mail.",
  yourPasswordHasBeenUpdated: "Sua senha foi atualizada.",
  returnToLogin: "Voltar ao login",
  backToLogin: "Voltar ao login",
  didnTReceiveTheEmail: "Não recebeu o e-mail? ",
  aPasswordResetMessageWasSentToYourEmailAddress: "Uma mensagem de redefinição de senha foi enviada para seu e-mail.",
  enterTheEmailAddressAssociatedWithYourAccountAndWeLlSendYouALinkToResetYourPassword: "Insira o endereço de e-mail associado à sua conta e enviaremos um link para redefinir sua senha",
  createAccessOption: "Criar opção de acesso",
  editAccessOption: "Editar opção de acesso",
  drivewayLength: "Comprimento da entrada",
  carryDistance: "Distância de transporte",
  switchTo: "Mudar para",
  questionFieldsAreRequired: "Os campos de perguntas são obrigatórios.",
  triggerFieldTypeIsRequired: "O tipo de campo do gatilho é obrigatório.",
  valueOfEntryIsAlreadyInUsed: "O valor da entrada já está em uso",
  aRoleOfTypeSystemIsSelectedAndCannotBeChanged: "Um cargo do tipo sistema está selecionado e não pode ser alterado",
  theDateIsWrong: "A data está incorreta",
  theUserMustBeAtLeast18YearsOldAndUnder100YearsOld: "O usuário deve ter pelo menos 18 anos e menos de 100 anos",
  approveQuote: "Aprovar cotação",
  doYouReallyWantToApproveTheQuote: "Realmente deseja aprovar a cotação?",
  areYouSureYouWantToDeliverThisOrder: "Tem certeza que deseja entregar este pedido?",
  areYouSureYouWantToCancelTheOrder: "Tem certeza que deseja cancelar o pedido?",
  yesCancelOrder: "Sim, cancelar pedido",
  areYouSureYouWantToCancelTheQuote: "Tem certeza que deseja cancelar a cotação?",
  yesCancelQuote: "Sim, cancelar cotação",
  oops: "Ops!",
  youShouldCancelTheseTasksInYourAppBeforeContinue: "Você deve cancelar estas tarefas no seu aplicativo antes de continuar.",
  itLooksLikeSomeTasksOfThisOrderAreInProgress: "Parece que algumas tarefas deste pedido estão em andamento.",
  declineQuote: "Recusar cotação",
  doYouReallyWantToDeclineTheQuote: "Realmente deseja recusar a cotação?",
  viewInCalendarMode: "Ver no modo calendário",
  viewInGridMode: "Ver no modo grade",
  removeAll: "Remover tudo",
  roleNotFound: "Cargo não encontrado",
  userNotFound: "Usuário não encontrado",
  searchForRole: "Pesquisar cargo...",
  searchForUser: "Pesquisar usuário...",
  inbound: "Entrada",
  atPort: "No porto",
  atDc: "No DC",
  ofTotalContainers: "Do total de contêineres",
  containerDistributionByDestination: "Distribuição de contêineres por destino",
  shareLink: "Compartilhar link",
  cameraOff: "Câmera desligada",
  video: "Vídeo",
  microphone: "Microfone",
  joinNow: "Entrar agora",
  youDidnTAddAnyItemsYet: "Você ainda não adicionou itens",
  copied: "Copiado",
  shareViaApp: "Compartilhar pelo App",
  shareViaLink: "Compartilhar por link",
  shareViaSms: "Compartilhar por SMS",
  shareViaWhatsapp: "Compartilhar pelo Whatsapp",
  openWhatsappToShare: "Abrir Whatsapp para compartilhar",
  shareViaEMail: "Compartilhar por e-mail",
  shareTheVideoSurveyWithTheCustomer: "Compartilhar a pesquisa de vídeo com o cliente",
  shareTheInventoryWithTheCustomer: "Compartilhar o inventário com o cliente",
  shareTheEstimateWithTheCustomer: "Compartilhar a estimativa com o cliente",
  shareInventory: "Compartilhar inventário",
  shareEstimate: "Compartilhar estimativa",
  shareVideoSurvey: "Compartilhar pesquisa de vídeo",
  inventoryUpdated: "Inventário atualizado",
  youAreAboutToLeaveVideoSurveyAreYouSure: "Você está prestes a sair da pesquisa de vídeo. Tem certeza?",
  theCustomerWillBeForcedToLeaveToo: "O cliente também será forçado a sair.",
  youHaveUnsavedChangesInTheInventory: "Você tem alterações não salvas no inventário.",
  audioDeviceTest: "Teste de dispositivo de áudio",
  recording: "Gravando...",
  playing: "Reproduzindo...",
  leave: "Sair",
  noIssuesDetected: "Nenhum problema detectado",
  inputDevice: "Dispositivo de entrada",
  inputLevel: "Nível de entrada",
  speaker: "Alto-falante",
  outputDevice: "Dispositivo de saída",
  outputLevel: "Nível de saída",
  connectivityAndBandwidthTest: "Teste de conectividade e largura de banda",
  taskTypeIsRequired: "O tipo de tarefa é obrigatório.",
  orderTypeIsRequired: "O tipo de pedido é obrigatório.",
  orderTypeStatus: "Status do tipo de pedido",
  sequence: "Sequência",
  poNumber: "Número da OP",
  despatchedQuantity: "Quantidade despachada",
  destinationDcCmlDc: "DC de destino (CML DC)",
  estimateClearedForPickUp: "Estimativa autorizada para coleta",
  estimateUnpackDate: "Data estimada de desembalagem",
  actualArriveWh: "Chegada real ao armazém",
  bookedFor: "Reservado para",
  at: "em",
  contactEmailCom: "contato@email.com",
  expectedCallQuality: "Qualidade de chamada esperada:",
  deliverOrder: "Entregar pedido",
  generateReport: "Gerar relatório",
  generatePDFreports: "Gerar relatórios PDF",
  hideSection: "Ocultar seção",
  showSection: "Mostrar seção",
  online: "Online",
  offline: "Offline",
  collapse: "Recolher",
  allow: "Permitir",
  notAllow: "Não permitir",
  allowCustomer: "Permitir ao cliente",
  screenshotSavedSuccessfully: "Captura de tela salva com sucesso",
  couldNotSaveScreenshot: "Não foi possível salvar a captura de tela",
  couldNotRetrieveScreenshots: "Não foi possível recuperar as capturas de tela",
  loadingDespatches: "Carregando despachos",
  checklistStatus: "Status da lista de verificação",
  warehouseStatus: "Status do armazém",
  branchStatus: "Status da filial",
  someRequiredInformationAreMissing: "Faltam informações obrigatórias",
  addAnExistentContact: "Adicionar contato existente",
  selectAContact: "Selecionar contato",
  hideInput: "Ocultar entrada",
  hideForm: "Ocultar formulário",
  createNewContact: "Criar novo contato",
  loadingData: "Carregando dados...",
  qty: "Qtd.",
  isThisMaterialAnItem: "Este material é um item?",
  automationAndControlForIncreasedSupplyChainVisibility: "Automação e controle para maior visibilidade da cadeia de suprimentos.",
  youHavenTAddedAnyItemsYet: "Você ainda não adicionou itens",
  youHavenTAddedAnyMaterialYet: "Você ainda não adicionou nenhum material",
  prices: "Preços",
  createNewPrice: "Criar novo preço",
  price: "Preço",
  addNewGroup: "Adicionar novo grupo",
  DimensionFee: "Taxa de {dimensão}",
  searchAgent: "Pesquisar agente",
  preferredUplift: "Coleta preferida",
  accessRuleName: "Nome da regra de acesso",
  addAccessRule: "Adicionar regra de acesso",
  groupName: "Nome do grupo",
  newGroup: "Novo grupo",
  subTotal: "Subtotal",
  deleteThisLine: "Excluir esta linha",
  thereMustBeAtLeastOneServiceInAGroup: "Deve haver pelo menos um serviço em um grupo",
  deleteThisGroup: "Excluir este grupo",
  thereMustBeAtLeastOneGroupInAPrice: "Deve haver pelo menos um grupo em um preço",
  editGroupName: "Editar nome do grupo",
  searchCurrency: "Pesquisar moeda",
  searchService: "Pesquisar serviço",
  priceCreatedSuccessfully: "Preço criado com sucesso",
  groupAddedSuccessfully: "Grupo adicionado com sucesso",
  serviceAddedSuccessfully: "Serviço adicionado com sucesso",
  pressToConfirmGroupNameChange: "Pressione para confirmar a alteração do nome do grupo",
  pressToCancelGroupNameChange: "Pressione para cancelar a alteração do nome do grupo",
  fillNameAndPressSaveOrEnter: "Preencha o nome e pressione salvar ou Enter",
  addNewLine: "Adicionar nova linha",
  originCosts: "Custos de origem",
  destinationCosts: "Custos de destino",
  extras: "Extras",
  deleteThisPrice: "Excluir este preço",
  agentSelected: "Agente selecionado",
  pricingListUpdatedOn: "Lista de preços atualizada em",
  noneAgentSelected: "Nenhum agente selecionado",
  totalCosts: "Custos totais",
  manageNeverBeenEasier: "Gerenciar nunca foi tão fácil",
  visibilityAtItsBest: "Visibilidade no seu melhor",
  shipeeziIsTheEssentialToolForCompaniesOfAllSizesToConsolidateAutomateAndUncomplicateInformationAndShipmentFlowAcrossTheGlobe: "O Shipeezi é a ferramenta essencial para empresas de todos os portes consolidarem, automatizarem e simplificarem o fluxo de informações e envios em todo o mundo",
  saveTimeAndMoney: "Economize tempo e dinheiro",
  withShipeeziVisibilityAndIncreasedControlIsDeliveredSavingMoreThan30InLogisticsCostsAnd60InTimeReporting: "Com o Shipeezi, maior visibilidade e controle são entregues, economizando mais de 30% nos custos logísticos e 60% no tempo de relatórios",
  createYourAccount: "Crie sua conta",
  youAreJustMomentsAwayOfHavingFullVisibilityAndControlOverYourShipments: "Você está a momentos de ter total visibilidade e controle sobre seus envíos",
  confirmPassword: "Confirmar senha",
  haveAnAccount: "Tem conta?",
  signIn: "Entrar",
  shipeezi: "© Shipeezi",
  termsOfUse: "Termos de uso",
  passwordsDonTMatch: "*As senhas não coincidem",
  companyName: "Nome da empresa",
  companyType: "Tipo de empresa",
  selectCompanyType: "Selecionar tipo de empresa",
  spShipper: "SP - Expedidor",
  fmFreightManager: "FM - Gerente de carga",
  mvMoving: "MV - Mudanças",
  getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime: "Receba e-mails do Shipeezi sobre atualizações de produtos, notícias do setor e eventos.",
  byContinuingYouReAgreeingToShipeeziS: "Ao continuar, você concorda com os termos do Shipeezi",
  requestAccount: "Solicitar conta",
  ourTeamWillGetInTouchWithYouAsSoonAsPossible: "Nossa equipe entrará em contato com você o mais breve possível.",
  thankYouForSignUpYouCanCheckYourEmailToProceed: "Obrigado por se cadastrar. Você pode verificar seu e-mail para continuar.",
  youWillReceiveAnEmailTo: "Você receberá um e-mail para",
  toConfirmYourSignUp: "para confirmar seu cadastro.",
  thereWasAnErrorCreatingTheAccount: "Houve um erro ao criar a conta",
  captcha: "Captcha",
  captchaExpired: "Captcha expirado",
  and: "e",
  leaveVideoSurvey: "Sair da pesquisa de vídeo",
  wellDoneOnTheMeetingWith: "Bom trabalho na reunião com",
  donTForgetWhatYouHaveAvailableFromThisMeeting: "Não esqueça o que você tem disponível desta reunião.",
  didYouLeaveTheMeetingByMistake: "Você saiu da reunião por engano? ",
  rejoinTheMeetingHere: "Voltar à reunião aqui",
  packingMaterial: "Material de embalagem",
  estimateQuote: "Cotização estimada",
  agents: "Agentes",
  editEstimate: "Editar estimativa",
  charge: "Taxa",
  quantity: "Quantidade",
  rate: "Taxa",
  margin: "Margem",
  markUp: "Margem de lucro",
  discount: "Desconto",
  totalCost: "Custo total",
  paymentMethod: "Método de pagamento",
  creditCard: "Cartão de crédito",
  credit_card: "Cartão de crédito",
  account: "Conta",
  cash: "Dinheiro",
  goBackToApp: "Voltar ao app",
  closeTab: "Fechar aba",
  openCommunication: "Abrir comunicação",
  enableMicrophone: "Habilitar microfone",
  disableMicrophone: "Desabilitar microfone",
  enableCamera: "Habilitar câmera",
  disableCamera: "Desabilitar câmera",
  shareScreen: "Compartilhar tela",
  stopSharingScreen: "Parar compartilhamento de tela",
  cannotShareScreenWhenAnotherUserIsSharing: "Não é possível compartilhar a tela quando outro usuário está compartilhando",
  screenSharingIsNotSupportedWithThisBrowser: "O compartilhamento de tela não é suportado neste navegador",
  emailConfirmationTimeHasExpired: "O tempo de confirmação do e-mail expirou",
  thereWasAnErrorConfirmingTheEmail: "Houve um erro ao confirmar o e-mail",
  emailSuccessfullyConfirmed: "E-mail confirmado com sucesso",
  backToLoginPage: "Voltar à página de login",
  goToShipeeziBlog: "Ir para o blog do Shipeezi",
  isNowVerified: "está agora verificado!",
  chooseAPassword: "Escolha uma senha",
  useLettersNumbersAndSymbolsForSafety: "Use letras, números e símbolos para maior segurança",
  confirmYourPassword: "Confirme sua senha",
  theSameOneFromAbove: "A mesma de cima",
  youJustNeedToCreateAPasswordForYourAccount: "Você só precisa criar uma senha para sua conta.",
  predictiveDeparture: "Saída preditiva:",
  departure: "Saída",
  arrival: "Chegada",
  nextPortArrival: "Chegada ao próximo porto:",
  decimalSeparator: "Separador decimal",
  thousandSeparator: "Separador de milhares",
  usePoint: "Usar ponto (.)",
  useComma: "Usar vírgula (,)",
  newService: "Novo serviço",
  createANewServiceOrGroup: "Criar um novo serviço ou grupo",
  createNewGroup: "Criar novo grupo",
  inventoryList: "Lista de inventário",
  openLegacyVersion: "Abrir versão anterior",
  closeThisScreen: "Fechar esta tela",
  changeGroupStatus: "Alterar status do grupo",
  noAssociatedService: "Nenhum serviço associado.",
  viewGroups: "Ver grupos",
  groups: "Grupos",
  seemsLikeYouDidnTCreateAnyGroup: "Parece que você não criou nenhum grupo :(",
  searchGroups: "Pesquisar grupos",
  groupCosting: "Custo do grupo",
  totalOfPrice: "Total do preço ",
  sent: "Enviado",
  group: "Grupo",
  changeStatusTo: "Alterar status para",
  totalOf: "Total de",
  lastUpdated: "Última atualização",
  thisServiceCannotBeActivatedBecauseIsUnavailable: "Este serviço não pode ser ativado porque está indisponível",
  thisServiceCannotBeEditedBecauseIsUnavailable: "Este serviço não pode ser editado porque está indisponível",
  loadingPrices: "Carregando preços",
  updatePrices: "Atualizar preços",
  reviewPrices: "Revisar preços",
  editFile: "Editar arquivo",
  uploadCsv: "Enviar CSV",
  uploadCsvFile: "Enviar arquivo CSV",
  downloadTemplate: "Baixe nosso modelo CSV aqui",
  clickToDownloadThePriceTemplateAndFillPrices: "Clique para baixar o modelo de preços e preencher os preços",
  noFilesUploaded: "Nenhum arquivo enviado",
  noneDataHasFilled: "Nenhum dado foi preenchido",
  fee: "Taxa",
  thisServiceDoesNotExist: "Este serviço não existe",
  thereIsNoRelationshipBetweenThisServiceAndTheGroup: "Não há relação entre este serviço e o grupo",
  thisGroupDoesNotExist: "Este grupo não existe",
  thereIsNoRelationshipBetweenThisGroupAndTheService: "Não há relação entre este grupo e o serviço",
  theValueOfThisFieldIsInvalid: "O valor deste campo é inválido",
  thisCurrencyDoesNotExist: "Esta moeda não existe",
  nonGrouped: "Não agrupado",
  wasEditedSuccessfully: "foi editado com sucesso!",
  thisRecordCannotBeEditedBecauseThereIsAnErrorInTheServiceOrGroup: "Este registro não pode ser editado porque há um erro no serviço ou grupo",
  theseServicesWillNotBeUpdatedIfYouWouldLikeToCorrectThemYouShouldEditFile: "Estes serviços não serão atualizados. Se quiser corrigi-los, você deve editar o arquivo",
  thisCanBeCorrectedIfYouClickIn: "Isso pode ser corrigido se você clicar em ",
  latestUpload: "Último envio",
  youCanOnlyContinueAfterAllWarningsHaveBeenResolved: "Você só pode continuar após todas as advertências serem resolvidas",
  timeControl: "Controle de tempo",
  arrivedAtTheResidence: "Chegou à residência",
  breakFrom: "Intervalo de",
  to: "Para",
  leavingTheResidence: "Saindo da residência",
  arrivedBackToTheWarehouse: "Retornou ao armazém",
  timeSummary: "Resumo do tempo",
  transitTime: "Tempo de trânsito",
  breakTime: "Tempo de intervalo",
  workTime: "Tempo de trabalho",
  totalTime: "Tempo total",
  extraStaff: "Equipe extra",
  deleteSubscriber: "Excluir assinante",
  whenYouDeleteANotification: "Quando você exclui uma notificação, o contato associado receberá",
  wouldYouLikeToProceed: "Deseja continuar?",
  pricesUpdatedSuccessfully: "Preços atualizados com sucesso",
  weWillUpdateAllPricesDisregardingThoseMarkedWith: "Atualizaremos todos os preços, exceto os marcados com",
  ifYouWantToUpdateThesePricesYouShouldEditFile: "Se quiser atualizar esses preços, você deve editar o arquivo",
  newMessage: "Nova mensagem!",
  oopsIncorrectCredentials: "Ops! Credenciais incorretas.",
  leaveWithoutSave: "Sair sem salvar",
  youHaveUnsavedChangesAreYouSureYouWantToLeave: "Você tem alterações não salvas. Tem certeza que deseja sair?",
  youShouldSaveYourWorkBeforeLeaving: "Você deve salvar seu trabalho antes de sair.",
  doYouReallyWantToDeleteThisAgent: "Realmente deseja excluir este agente?",
  agentDetails: "Detalhes do agente",
  toAllowYourPasswordReset: "para permitir a redefinição da sua senha.",
  sorryTheLinkHasExpired: "Desculpe, o link expirou.",
  theResetPasswordLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow: "O link para redefinição de senha expirou. Você pode solicitar um novo clicando no botão abaixo",
  resetPasswordLink: "Link para redefinir senha",
  emailSuccessfullyResent: "E-mail reenviado com sucesso",
  anUnknownErrorHasOccurred: "Ocorreu um erro desconhecido",
  emailOrUsernameIsRequired: "E-mail ou nome de usuário é obrigatório",
  passwordIsRequired: "A senha é obrigatória",
  userLoggedIn: "Usuário com sessão iniciada",
  thereWasAnErrorCapturingYourEmailToResend: "Houve um erro ao capturar seu e-mail para reenvio",
  theEmailConfirmationLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow: "O link de confirmação de e-mail expirou. Você pode solicitar um novo clicando no botão abaixo",
  resendConfirmationLink: "Reenviar link de confirmação",
  thankYouForRequestingAnAccountWithShipeezi: "Obrigado por solicitar uma conta no Shipeezi.",
  ourTeamWillBeInContactWithYouPriorToActivatingYourAccount: "Nossa equipe entrará em contato com você antes de ativar sua conta",
  companyDetails: "Adicione as informações da sua empresa, endereço comercial e contato principal",
  uploadCentre: "Envie suas informações iniciais para que o Shipeezi possa conectar seus dados",
  goBackToHomePage: "Voltar à página inicial",
  goBackToLogin: "Voltar ao login",
  goBackToLoginPage: "Voltar à página de login",
  previous: "Anterior",
  skip: "Pular por agora",
  downloadOurCsvTemplateHere: "Baixe nosso modelo CSV aqui",
  addAdditionalUsers: "Adicionar usuários adicionais",
  theContactDetailsUsedToRegisterHasBecomeAnAdminUserAlready: "Os dados de contato usados no cadastro já se tornaram um usuário administrador",
  registeredUsers: "Usuários cadastrados",
  addUser: "Adicionar usuário",
  aud: "AUD",
  youCanSelectToUploadYourOwnFilesInformationNowOrLaterIfYouPreferYouCanUseOurDefaultInformationTheseInformationIsInRegardsToYourInventoryItemsServicesFleetStaffAndSoOn: "Você pode optar por enviar seus próprios arquivos agora ou depois. Se preferir, pode usar nossas informações padrão.",
  uploadOwnList: "Enviar minha própria lista",
  useShipeeziSDefaultList: "Usar a lista padrão do Shipeezi",
  inventoryListIso174511: "Lista de inventário ISO17451-1:2016 Certificada",
  usingShipeeziSDefault: "Usando o padrão do Shipeezi",
  itemsRoomsPackagingTypeMethodOfPreparationModeTypeExceptionCodesExceptionLocationCodeItemInstructionsAndItemDestination: "Itens, Quartos, Tipo de embalagem, Método de preparação, Tipo de modo, Códigos de exceção, Instruções do item e Destino do item",
  checklistForm: "Lista de verificação e Formulário",
  riskAssessmentTemplate: "Modelo de avaliação de risco",
  usingShipeeziSSampleData: "Usando dados de amostra do Shipeezi",
  listOfMaterials: "Lista de materiais",
  aFewCommonTypesOfPackingMaterialsWillBeLoaded: "Alguns tipos comuns de materiais de embalagem serão carregados",
  services: "Serviços",
  oneServiceTypeWillBeCreated: "Um tipo de serviço será criado",
  oneStaffWillBeCreated: "Um membro da equipe será criado",
  oneVehicleWillBeCreated: "Um veículo será criado",
  theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator: "Estas instruções podem ser usadas no aplicativo de Vendas e Operações para coleta, entrega ou coordenador de mudança",
  usualAccessQuestionsWillBeCreatedHere: "As perguntas habituais de acesso serão criadas aqui",
  iso174511CertifiedItems: "ISO17451-1:2016 Certificado: Itens, Quartos, Tipo de embalagem",
  csvUploaded: "CSV enviado",
  asPerYourSelectionWeAreGoingToUploadTheStandardContentForTheFollowingSections: "De acordo com sua seleção, vamos enviar o conteúdo padrão para as seguintes seções",
  youCanChooseFromTheListBelowWhichItemsYouWantToUploadAndWhichYouWantToUseShipeeziSDefault: "Você pode escolher na lista abaixo quais itens deseja enviar e quais usar com o padrão do Shipeezi",
  weAreLoadingTheUploadedContentPleaseWait: "Estamos carregando o conteúdo enviado, por favor aguarde",
  thisMightTakeAWhile: "Isso pode demorar um momento",
  ifThisIsTakingTooMuchLonger: "Se isto estiver demorando muito,",
  tryAgainHere: "tente novamente aqui",
  thankYouForCompleteThisProcess: "Obrigado por concluir o processo de configuração rápida.",
  readyToStartUsingShipeezi: "Pronto para começar a usar o Shipeezi?",
  getStarted: "Começar",
  confirmationEmailHasBeenSucessfullyResent: "O e-mail de confirmação foi reenviado com sucesso!",
  confirmationEmailCouldNotBeenResent: "O e-mail de confirmação não pôde ser reenviado.",
  resetUserPassword: "Redefinir senha do usuário",
  businessLogo: "Logo empresarial",
  businessIcon: "Ícone empresarial",
  addLogo: "Adicionar logo",
  choosePicture: "Escolher imagem",
  maxSize: "Tamanho máximo",
  formats: "Formatos",
  crop: "Cortar",
  version: "Versão",
  profile: "Perfil",
  emailToResetPasswordSent: "E-mail para redefinição de senha enviado",
  "2Mb": "2 MB",
  maxFileSize: "Tamanho máximo de arquivo:",
  fileTypes: "Tipos de arquivo:",
  accountDetails: "Detalhes da conta",
  csvTemplateIsInvalid: "O modelo CSV é inválido",
  line: "Linha",
  isRequired: "é obrigatório",
  mustBeOneOfTheValidOptions: "deve ser uma das opções válidas",
  mustBeFilledInWithXOrLeftEmpty: 'deve ser preenchido com "x" ou deixado vazio',
  mustBeANumber: "deve ser um número",
  mustBeADateWithTheFormatDdMmYyyy: "deve ser uma data no formato dd/mm/aaaa",
  errorsFound: "Erros encontrados",
  errorsFoundInYourFile: "Erros encontrados no seu arquivo",
  on: "Ativado",
  csvWeHaveFoundSomeErrorsYouShouldAdjustThoseLinesToProceed: "CSV, encontramos alguns erros. Você deve ajustar essas linhas para continuar",
  donTKnowWhatSWrong: "Não sabe o que está errado?",
  downloadOurTemplateHere: "Baixe nosso modelo aqui",
  downloadOurTemplate: "Baixe nosso modelo",
  logout: "Sair",
  logOut: "Sair",
  userProfile: "Perfil do usuário",
  helpCenter: "Central de ajuda",
  dispatchFilters: "Filtros de despacho",
  allTasks: "Todas as tarefas",
  allTeams: "Todas as equipes",
  unpublishedTasks: "Tarefas não publicadas",
  publishedTasks: "Tarefas publicadas",
  teamsWithUnpublishedTasks: "Equipes com tarefas não publicadas",
  teamsWithPublishedTasks: "Equipes com tarefas publicadas",
  someChangesMayTakeSomeTimeToBeAppliedOnThisScreen: "Algumas alterações podem demorar para ser aplicadas nesta tela",
  thisFleetIsUnavailableOnThisDate: "Esta frota não está disponível nesta data",
  thisMemberIsUnavailableOnThisDate: "Este membro não está disponível nesta data",
  theFilteredDataAffectsWhatYouSeeOnDispatch: "Os dados filtrados afetam o que você vê no Despacho",
  termsAndConditions: "Termos e condições",
  currentlyViewing: "Visualizando atualmente",
  changeTo: "Mudar para",
  switchingAccounts: "Alternando conta.",
  unknown: "Desconhecido",
  messageHasBeenSentSuccessfully: "A mensagem foi enviada com sucesso!",
  avatar: "Avatar",
  approvingCompany: "Aprovando empresa...",
  theCompanyHasBeenApproved: "A empresa foi aprovada!",
  nowIsReadyToRockAndRoll: "agora está pronta para funcionar.",
  quoteType: "Tipo de cotação",
  allProjects: "Todos os projetos",
  typeMobile: "Tipo Mobile",
  searchForTimezone: "Pesquisar fuso horário",
  inviteUser: "Convidar usuário",
  userEmail: "E-mail do usuário",
  userAddedSuccessfully: "Usuário adicionado com sucesso",
  unableToRegisterAdditionalUser: "Não é possível registrar um usuário adicional",
  inviteSentSuccessfully: "Convite enviado com sucesso!",
  saveAndInvite: "Salvar e convidar",
  createAndInvite: "Criar e convidar",
  anEmailWasSentToUsernameWithYourRequest: "Um e-mail foi enviado ao usuário com sua solicitação",
  companyInvitation: "Convite da empresa",
  inviteDeclined: "Convite recusado",
  youHaveBeenInvitedToBePartOf: "Você foi convidado para fazer parte de ",
  youHaveBeenInvitedToBePartOfCompany: "Você foi convidado para fazer parte da empresa",
  youCanAcceptOrDeclineTheInvitationAndWeWillNotifyTheCompanyAdministrator: "Você pode aceitar ou recusar o convite e notificaremos o administrador da empresa",
  weWillNotifyTheAdministrator: "Notificaremos o Administrador.",
  weWillNotifyTheAdministratorFor: "Notificaremos o Administrador de",
  youCanCloseThisWindow: "Você pode fechar esta janela",
  ifYouRejectedThisInvitationByMistakePleaseRequestANewInvite: "Se você recusou este convite por engano, solicite um novo convite",
  here: "aqui",
  yourInvitationExpired: "Seu convite expirou",
  companyUpdatedSuccessfully: "Empresa atualizada com sucesso",
  termsAcceptedSuccessfully: "Termos aceitos com sucesso",
  by: "por",
  entityName: "Nome da entidade",
  sorryTheLinkIsBroken: "Desculpe, o link está quebrado",
  theInviteLinkIsBroken: "O link do convite está quebrado.",
  theInviteLinkIsBrokenYouCanRequestANewOneByClickingOnTheButtonBelow: "O link do convite está quebrado. Você pode solicitar um novo clicando no botão abaixo",
  resendInviteLink: "Reenviar link do convite",
  goBack: "Voltar",
  theInviteLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow: "O link do convite expirou. Você pode solicitar um novo clicando no botão abaixo",
  thisFieldIsAnInvalidUrl: "Este campo contém uma URL inválida",
  thisFieldShouldHaveDigitsOnly: "Este campo deve conter apenas dígitos",
  validFormats: "Formatos válidos",
  typeOfInstruction: "Tipo de instrução",
  inputYourInstruction: "Insira sua instrução",
  asYouAddedAnItemThatDoesNotBelongToTheIso174511: "Você adicionou um item que não pertence à ISO17451-1:2016",
  requestingNewInvite: "Solicitando novo convite",
  youHaveAlreadyAcceptedThisInvitation: "Você já aceitou este convite!",
  loadingInvitation: "Carregando convite...",
  userHasNotBeenInvited: "O usuário não foi convidado",
  navigation: "NAVEGAÇÃO",
  someOfTheseEmailsProvidedIsInvalid: "Alguns dos e-mails fornecidos são inválidos",
  isThisAnItemDestination: "É este um destino de item?",
  ssccQty: "Qtd. SSCC",
  etdAtOrigin: "ETD na origem",
  etaAtDestination: "ETA no destino",
  subjects: "Assuntos",
  favorites: "Favoritos",
  reports: "Relatórios",
  company: "Empresa",
  itFeelsEmptyRightNow: "Parece vazio agora.",
  status: "Status",
  filter: "Filtrar",
  reference: "Referência",
  referenceNumber: "Número de referência",
  customer: "Cliente",
  pdf: "PDF",
  csv: "CSV",
  exportAs: "Exportar como",
  tags: "Etiquetas",
  nothingToShowHereYet: "Ainda não há nada para mostrar.",
  thisWarehouseDoesNotAllowStorageOfLooseItemsSelectAStorageBoxInstead: "Este armazém não permite armazenamento de itens soltos. Selecione uma caixa de armazenamento",
  iConfirmThatAllTheDetailsAboveAreTrue: "Confirmo que todos os detalhes acima são verdadeiros",
  notInformed: "Não informado",
  signHere: "Assine aqui",
  expandAllTasks: "Expandir todas as tarefas",
  hideAllTasks: "Ocultar todas as tarefas",
  checkIfAnyOfTheTasksEligibleForReportGenerationUpliftDeliveryLocalHasBeenCompletedAndHasADate: "Verifique se alguma tarefa elegível para relatórios (Coleta, Entrega, Local) foi concluída e tem data",
  asn: "ASN",
  containerSize: "Tamanho do contêiner",
  selectOne: "Selecionar um",
  seal: "Lacre",
  consignee: "Destinatário",
  consigneeCode: "Código do consignatário",
  deliverToWarehouse: "Entregar ao armazém",
  serviceType: "Tipo de serviço",
  shipTerms: "Termos de envio",
  mbl: "MBL",
  hbl: "HBL",
  loadingPort: "Porto de carga",
  destinationPort: "Porto de destino",
  dischargePort: "Porto de descarga",
  searchAddress: "Pesquisar endereço",
  shipperOriginAirport: "Aeroporto de origem do remetente",
  receiverDestinationAirport: "Aeroporto de destino do receptor",
  airports: "Aeroportos",
  ports: "Portos",
  roads: "Rodovias",
  scannedDate: "Data de escaneamento",
  pickUpFromOrigin: "Coletar na origem",
  ataAtOrigin: "ATA na origem",
  ataAtDestination: "ATA no destino",
  actualDeliveryDate: "Data de entrega real",
  senderOriginRoad: "Rodovia de origem do remetente",
  receiverDestinationRoad: "Rodovia de destino do receptor",
  roadName: "Nome da rodovia",
  estimatedDeliveryDate: "Data de entrega estimada",
  noReportsAddedToFavorites: "Nenhum relatório adicionado aos favoritos",
  go: "Ir",
  itemInstructions: "Instruções do item",
  chooseAnItemInstruction: "Escolher uma instrução de item",
  notHaveDatesYet: "Ainda não tem datas",
  videoSurveyRecordDeleted: "Registro de pesquisa de vídeo excluído",
  theVideoRecordedForThisSurveyWasDeletedAsTheStatusHasChangedTo: "O vídeo gravado para esta pesquisa foi excluído pois o status mudou para",
  youDoNotHaveAccessToThisRecordAnymore: "Você não tem mais acesso a este registro.",
  diary: "Diário",
  day: "Dia",
  days: "Dias",
  see: "Ver",
  moreTasks: "mais tarefas",
  sequenceMustBeAValidNumber: "*A sequência deve ser um número válido",
  sequenceMustBeAIntegerNumber: "*A sequência deve ser um número inteiro",
  sequenceMustBeGreaterThan0: "*A sequência deve ser maior que 0",
  sequenceMustBeSmallerThan1000: "*A sequência deve ser menor que 1000",
  noTasksRegisteredForTheDay: "Nenhuma tarefa registrada para o dia",
  startsAt: "Começa às: ",
  search: "Buscar",
  seeTaskOnOrder: "Ver tarefa no pedido",
  taskDetails: "Detalhes da Tarefa",
  storageBoxes: "Caixas de Armazenamento",
  storageBoxTypes: "Tipos de Caixas de Armazenamento",
  prepayment: "Pré-pagamento",
  noneInformationToShow: "Sem informação para mostrar",
  tasks: "Tarefas",
  assignTask: "Atribuir tarefa",
  printJob: "Imprimir trabalho",
  cancelTask: "Cancelar tarefa",
  yesCancelTask: "Sim, cancelar tarefa",
  areYouSureYouWantToCancelThisTask: "Tem certeza que deseja cancelar esta tarefa?",
  searchByFleet: "Pesquisar por frota",
  searchByStaff: "Pesquisar por equipe",
  searchByLeader: "Pesquisar por líder",
  searchByStorageBox: "Pesquisar por caixa de armazenamento",
  orderReference: "Referência do pedido",
  taskStartsAt: "A tarefa começa às",
  languageName: "Nome do idioma",
  australianEnglishSystem: "Inglês Australiano (Sistema)",
  thisIsTheName: "Este é o nome",
  term: "Termo",
  createdBy: "Criado por",
  lengthM: "Comprimento (m)",
  taskList: "Lista de tarefas",
  exception: "Códigos de exceção",
  cancelled: "Cancelado",
  labelTooltipRecording: "Gravando",
  labelTooltipNotRecording: "Não gravando",
  youAreNotAllowedToEditThisQuote: "Você não tem permissão para editar esta cotação",
  youAreNotAllowedToEditThisOrder: "Você não tem permissão para editar este pedido",
  fileDownloadComplete: "Download do arquivo concluído",
  scheduleNow: "Agendar agora",
  videoSurveyUnavailable: "Pesquisa de vídeo indisponível",
  thisVideoSurveyHasBeenClosed: "Esta pesquisa de vídeo foi encerrada",
  pleaseScheduleAnotherSurveyToContinue: "Por favor, agende outra pesquisa para continuar",
  youCanScheduleAnotherVideoSurveyNowOrLater: "Você pode agendar outra pesquisa de vídeo agora ou depois",
  theCustomerHasRemovedTheCallRecordingPermission: "O cliente retirou a permissão de gravação de chamada",
  theCustomerAllowedTheRecordThisCallIsBeingRecordedFromNowOn: "O cliente permitiu a gravação. Esta chamada está sendo gravada a partir de agora",
  recordingVS: "Gravando",
  notRecording: "Não gravando",
  readyToShip: "Pronto para enviar",
  port: "Porto",
  deliverTo: "Entregar para",
  plane: "Avião",
  journey: "Viagem",
  airwayBill: "Conhecimento aéreo",
  cfs: "CFS",
  addNewContainer: "Adicionar novo contêiner",
  acmeClothing: "Acme Clothing",
  purchasingOrganisation: "Organização de compras",
  orderNumber: "Número do Pedido",
  amosToken: "Token AMOS",
  token: "Token",
  australia: "Austrália",
  sistrs: "SISTRS",
  pleaseEnterAValidToken: "Por favor, insira um token válido",
  revokeConnection: "Revogar conexão",
  areYouSureYouWantToRevokeTheConnection: "Tem certeza que deseja revogar a conexão?",
  amos: "AMOS",
  copyKey: "Copiar chave",
  inviteSISTR: "Convidar SISTR",
  editSISTR: "Editar SISTR",
  SISTRemail: "E-mail SISTR",
  emailAlreadyExists: "O endereço de e-mail já existe",
  waybills: "Conhecimentos de transporte",
  moreOrders: "Mais pedidos",
  etd: "ETD",
  print: "Imprimir",
  seeReport: "Ver relatório",
  reportType: "Tipo de relatório",
  uploaded: "Enviado",
  uploadFile: "Enviar Arquivo",
  documentsUploaded: "Documentos enviados",
  dragOrClickToUploadYourFile: "Arraste ou clique para enviar seu arquivo",
  waybill: "Conhecimento de transporte",
  estimateDates: "Datas estimadas",
  aircraftDestination: "Destino da aeronave",
  aircraftOrigin: "Origem da aeronave",
  aircraft: "Aeronave",
  unpackDate: "Data de desembalagem",
  pickDate: "Data de coleta",
  arrivalOfDestination: "Data de entrega",
  deleteShipment: "Excluir envio",
  image: "Imagem",
  billOfLanding: "Conhecimento de embarque",
  enterBillOfLanding: "Inserir conhecimento de embarque",
  billOfLandingMustBeAtLeast7CharactersLong: "O conhecimento de embarque deve ter pelo menos 7 caracteres",
  billOfLandingMustBeAtMax20CharactersLong: "O conhecimento de embarque não pode ter mais de 20 caracteres",
  tradingName: "Nome comercial",
  youCanGetStartedTrackingShipmentsFromHereRegardlessOfHowManyForwardersOrRoutes: "Você pode começar a rastrear envios daqui, independentemente de quantos transitários ou rotas você tenha",
  eitherUploadACsvFileUsingTheTemplateOrClickNextToEnterAContainerNumber: "Envie um arquivo CSV usando o modelo ou clique em próximo para inserir um número de contêiner",
  uploadYourShipmentDetails: "Envie os detalhes do seu envio",
  due: "Pendente",
  notDefined: "Não definido",
  viewFile: "Ver arquivo",
  thisFileIsRequired: "Este arquivo é obrigatório",
  tryAgain: "Tentar novamente",
  tryAgain2: "Tentar novamente",
  ifThisIsTakingTooLong: "Se isto está demorando muito,",
  uploadMade: "Upload realizado",
  theFileMustBeLessThan2mbInSize: "O arquivo deve ser menor que 2 MB",
  invite: "Convidar",
  inviteSupplier: "Convidar fornecedor",
  inviteSuppliers: "Convidar fornecedores",
  doYouWantToInvite: "Deseja convidar",
  toShipeezi: "para o Shipeezi?",
  anInvitationWillBeSendTo: "Um convite será enviado para",
  activeContainers: "Contêineres ativos",
  avgContainerPerWeek: "Média de contêineres por semana",
  containersDelayed: "Contêineres atrasados",
  containersWaitingAtGate: "Contêineres aguardando no portão",
  totalContainers: "Total de contêineres",
  containersTracked: "Contêineres rastreados",
  averageDelay: "Atraso médio",
  shipmentsTracked: "Envios rastreados",
  currentVesselsWithShipmentsBeingTracked: "Embarcações atuais com envios sendo rastreados",
  ctaDate: "Data CTA",
  teu: "TEU",
  atd: "ATD",
  actualTimeOfDeparture: "Hora real de saída",
  etaDate: "Data ETA",
  arrivalDate: "Data de chegada",
  via: "Via",
  customerEmail: "E-mail do cliente",
  estimatedDate: "Data estimada",
  estimatedTimeOfPortArrival: "Tempo estimado de chegada ao porto",
  estimatedTimeOfAirportArrival: "Tempo estimado de chegada ao aeroporto",
  companyLogo: "Logo da empresa",
  yourShipmentIsExpectedToArriveAt: "Seu envio deve chegar a",
  poweredBy: "Desenvolvido por",
  localTime: "Hora local",
  booked: "Reservado",
  collectedFromShipper: "Coletado do remetente",
  notArrivedAtPortOfLoad: "Não chegou ao porto de carga",
  waitingAtPortOfLoad: "Aguardando no porto de carga",
  shippedOnBoard: "Embarcado a bordo",
  underway: "Em andamento",
  underwayToATranshipmentPort: "A caminho de um porto de transbordo",
  arrivalAtTranshipmentPort: "Chegada ao porto de transbordo",
  waitingAtTranshipmentPort: "Aguardando no porto de transbordo",
  shippedOnBoardAtTranshipmentPort: "Embarcado a bordo no porto de transbordo",
  arrivedAtPortOrDischarge: "Chegou ao porto ou descarga",
  waitingAtDestinationPort: "Aguardando no porto de destino",
  leftTheDestinationPort: "Saiu do porto de destino",
  shipmentCompleted: "Envio concluído",
  maerskCode: "Código Maersk",
  maerskBeCode: "Código BE Maersk",
  clientCode: "Código do cliente",
  addressCode: "Código de endereço",
  divisionCode: "Código de divisão",
  divisionDescription: "Descrição da divisão",
  departmentCode: "Código do departamento",
  departmentDescription: "Descrição do departamento",
  sscc: "SSCC",
  ssccQuantity: "Quantidade SSCC",
  quantityUnit: "Unidade de quantidade",
  purchasePrice: "Preço de compra",
  style: "Estilo",
  colour: "Cor",
  size: "Tamanho",
  expand: "Expandir",
  deleteThisSsccAndYourProducts: "Excluir este SSCC e seus produtos",
  purchaseOrders: "Ordens de compra",
  addNewOrder: "Adicionar Novo Pedido",
  orderDate: "Data do Pedido",
  shipper: "Remetente",
  readyForBooking: "Pronto para reservar",
  selectOrdersBelowToAddThem: "Selecione os pedidos abaixo para adicioná-los",
  expectedStartDate: "Data de início esperada",
  expectedEndDate: "Data de fim esperada",
  assigned: "Atribuído",
  bookByDate: "Reservar até",
  createBooking: "Criar reserva",
  confirmed: "Confirmado",
  underReview: "Em revisão",
  received: "Recebido",
  pending: "Pendente",
  loadingBookings: "Carregando reservas",
  scanned: "Escaneado",
  noThanks: "Não, obrigado",
  cancelBooking: "Cancelar reserva",
  areYouSureYouWantToCancelTheBooking: "Tem certeza que deseja cancelar a reserva?",
  scannedItems: "Itens escaneados",
  thisOrderIsCancelled: "Este pedido está cancelado",
  packingType: "Tipo de embalagem",
  conditionAtOrigin: "Condição na origem",
  conditionAtDestination: "Condição no destino",
  conditionsAtOrigin: "Condições na origem",
  conditionsAtDestination: "Condições no destino",
  conditionAt: "Condição em",
  upgradeVersionToDoThis: "Atualize a versão para fazer isso",
  viewProduct: "Ver produto",
  hscode: "HSCODE",
  unitPrice: "Preço unitário",
  totalPrice: "Preço total",
  shipDate: "Data de envio",
  fobPrice: "Preço FOB",
  createSSCC: "Criar SSCC",
  newSSCCwasCreated: "Um novo SSCC foi criado!",
  finish: "Finalizar",
  closeSSCC: "Fechar SSCC",
  noInformations: "Sem informações",
  itsCurrentlyLocatedAt: "está atualmente localizado em",
  atPosition: "na posição",
  asReportedByMarineTrafficTerrestrialAutomaticIdentificationSystem: "conforme relatado pelo Sistema de Identificação Automática Terrestre da MarineTraffic",
  theVesselIsCurrentlyAtPort: "O navio está atualmente no porto",
  afterAVoyageOriginatingFromPort: "após uma viagem originada no porto",
  currentLocation: "Localização atual",
  delayTime: "Tempo de atraso",
  newETA: "Novo ETA",
  sendTrackingLinkToACustomer: "Enviar link de rastreamento para um cliente ou outra pessoa",
  areYouSureYouWantToCloseThisSSCC: "Tem certeza que deseja fechar este SSCC?",
  thisActionCannotBeUndoneAndIfYouWantToModifyThisSSCCYouMustDeleteItAndCreateANewOne: "Esta ação não pode ser desfeita. Se quiser modificar este SSCC, você deve excluí-lo e criar um novo",
  selectProductsBelowToAddThemToSSCC: "Selecione produtos abaixo para adicioná-los ao SSCC",
  printLabel: "Imprimir etiqueta",
  allSelectedSsccMustBeClosedToBePrinted: "Todos os SSCCs selecionados devem estar fechados para serem impressos",
  moreContainers: "Mais contêineres",
  portOfOrigin: "Porto de carga (PoL)",
  consignmentInfo: "Informações de consignação",
  originAgent: "Agente de origem",
  destinationAgent: "Agente de destino",
  estimateTimeOfDeparture: "Horário de saída",
  estimateTimeOfArrival: "Horário de chegada",
  atDepartureDock: "No cais de saída",
  inactivateWaybill: "Inativar conhecimento de transporte",
  inactiveWaybill: "Conhecimento de transporte inativo",
  pleaseAddAValidContainerNumber: "Por favor, adicione um número de contêiner válido",
  waitingForUpdate: "Aguardando atualização",
  generated: "Gerado",
  containerNumberIsInvalid: "O número do contêiner é inválido",
  itemConditions: "Condições do item",
  addAPhoto: "Adicionar uma foto",
  conditionsAdded: "Condições adicionadas",
  noConditions: "Sem condições",
  noPhotosAdded: "Nenhuma foto adicionada",
  itemDescription: "Descrição do item",
  pleaseSelectADescriptiveSymbol: "Por favor, selecione um símbolo descritivo",
  cbm: "CBM",
  submitted: "Enviado",
  rejected: "Rejeitado",
  partiallyDelivered: "Parcialmente entregue",
  bookingMustBeConfirmed: "A reserva deve ser confirmada",
  notificationCentre: "Centro de notificações",
  notificationCenter: "Centro de notificações",
  addEmailTemplate: "Adicionar modelo de e-mail",
  from: "De",
  subject: "Assunto",
  bcc: "CCO",
  createNewTemplate: "Criar novo modelo",
  templateName: "Nome do modelo",
  newTemplate: "Novo modelo",
  emailDetails: "Detalhes do e-mail",
  emailContent: "Conteúdo do e-mail",
  editEmailTemplate: "Editar modelo de e-mail",
  viewEmailTemplate: "Ver modelo de e-mail",
  smsDetails: "Detalhes do SMS",
  smsContent: "Conteúdo do SMS",
  pushNotificationDetails: "Detalhes da notificação push",
  pushNotificationContent: "Conteúdo da notificação push",
  use178CharactersOrLessForBestDisplay: "Use 178 caracteres ou menos para melhor exibição",
  smsCharacterLimitHint: "Mensagens SMS com mais de 168 caracteres serão divididas em múltiplas mensagens",
  selectATemplate: "Selecionar um modelo",
  addSMSTemplate: "Adicionar modelo SMS",
  editSMSTemplate: "Editar modelo SMS",
  viewSMSTemplate: "Ver modelo SMS",
  quoteCreation: "Criação de cotação",
  quoteApproval: "Aprovação de cotação",
  quoteDecline: "Recusa de cotação",
  ordersCreation: "Criação de pedidos",
  orderDelivered: "Pedido entregue",
  orderCancelled: "Pedido cancelado",
  createNewDocument: "Criar novo documento",
  documentGenerated: "Documento gerado",
  resendInvite: "Reenviar convite",
  downloadBookingFile: "Baixar arquivo de reserva",
  createAndBook: "Criar e reservar",
  saveAndBook: "Salvar e reservar",
  editBooking: "Editar reserva",
  viewBooking: "Ver reserva",
  liveAnimalsAndFish: "Animais vivos e peixes",
  cerealGrains: "Grãos de cereais",
  otherAgriculturalProducts: "Outros produtos agrícolas",
  feedAndProductsOfAnimalOrigin: "Rações e produtos de origem animal",
  meatAndSeafood: "Carnes e frutos do mar",
  milledGrainProducts: "Produtos de grãos moídos",
  otherPreparedFoodstuffs: "Outros alimentos preparados",
  alcoholicBeverages: "Bebidas alcoólicas",
  tobaccoProducts: "Produtos de tabaco",
  buildingStone: "Pedra de construção",
  naturalSands: "Areias naturais",
  gravelAndCrushedStone: "Cascalho e pedra triturada",
  otherNonmetallicMinerals: "Outros minerais não metálicos",
  metallicOres: "Minérios metálicos",
  coal: "Carvão",
  crudePetroleum: "Petróleo bruto",
  gasolineKeroseneAndEthanol: "Gasolina, querosene e etanol",
  dieselAndOtherFuelOils: "Diesel e outros óleos combustíveis",
  otherFossilFuelProducts: "Outros produtos de combustíveis fósseis",
  basicChemicals: "Produtos químicos básicos",
  pharmaceuticalProducts: "Produtos farmacêuticos",
  fertilizers: "Fertilizantes",
  chemicalProductsAndPreparations: "Produtos e preparados químicos",
  plasticsAndRubber: "Plásticos e borracha",
  logsAndWoodInTheRough: "Toras e madeira em bruto",
  woodProducts: "Produtos de madeira",
  pulpPaperAndPaperboard: "Celulose, papel e papelão",
  paperOrPaperboardArticles: "Artigos de papel ou papelão",
  printedProducts: "Produtos impressos",
  textilesAndLeather: "Têxteis e couro",
  nonmetallicMineralProducts: "Produtos minerais não metálicos",
  metalInBasicShapes: "Metal em formas básicas",
  articlesOfMetal: "Artigos de metal",
  machinery: "Maquinaria",
  electronics: "Eletrônicos",
  motorizedAndOtherVehicles: "Veículos motorizados e outros veículos",
  otherTransportationEquipment: "Outros equipamentos de transporte",
  precisionInstruments: "Instrumentos de precisão",
  furniture: "Móveis",
  miscellaneousManufacturedProducts: "Produtos manufaturados variados",
  wasteAndScrap: "Resíduos e sucata",
  mixedFreight: "Carga mista",
  commodity: "Mercadoria",
  fillThisFieldBeforeAddingAnotherContainer: "Preencha este campo antes de adicionar outro contêiner",
  youShouldHaveAtLeastOneProductInsideAnSSCCToCloseIt: "Você deve ter pelo menos um produto dentro de um SSCC para fechá-lo",
  thisSupplierIsPartOfShipeezi: "Este fornecedor faz parte do Shipeezi",
  supplierNotFound: "Fornecedor não encontrado",
  thisSupplierNotHaveNameToSendInvitation: "Este fornecedor não tem nome para enviar convite",
  thisSupplierDoesNotHaveAnEmailToSendInvitation: "Este fornecedor não tem e-mail para enviar convite",
  emails: "e-mails",
  youCannotInviteInactiveSuppliers: "Não é possível convidar fornecedores inativos",
  financials: "Finanças",
  communicationCentre: "Central de Comunicação",
  communication_centre: "Central de comunicação",
  notificationTemplates: "Modelos de notificação",
  communicationCentreDescription: "Gerencie seus modelos de comunicação, notificações e configurações",
  templateCreatedSuccessfully: "Modelo criado com sucesso",
  templateUpdatedSuccessfully: "Modelo atualizado com sucesso",
  templateDuplicatedSuccessfully: "Modelo duplicado com sucesso",
  errorCreatingTemplate: "Erro ao criar modelo",
  duplicateTemplate: "Duplicar modelo",
  editTemplate: "Editar modelo",
  preFilled: "Pré-preenchido",
  emailTemplates: "Modelos de e-mail",
  emailTemplate: "Modelo de e-mail",
  manageEmailTemplatesDescription: "Crie e gerencie modelos de e-mail para diversas necessidades de comunicação",
  smsTemplates: "Modelos SMS",
  smsTemplate: "Modelo SMS",
  pushContentCannotExceed: "O conteúdo da notificação push não pode exceder 178 caracteres",
  smsContentCannotExceed: "O conteúdo do SMS não pode exceder 168 caracteres",
  manageSmsTemplatesDescription: "Crie e gerencie modelos SMS para notificações rápidas.",
  manageNotificationsDescription: "Configure preferências e configurações de notificação.",
  communicationSettings: "Configurações de comunicação",
  configureCommunicationSettingsDescription: "Configure as preferências de comunicação e as opções de entrega.",
  clickToManage: "Clique para gerenciar",
  searchTemplates: "Pesquisar modelos...",
  noTemplatesFound: "Nenhum modelo encontrado",
  content: "Conteúdo",
  availableIn: "Disponível em",
  areYouSureYouWantToChangeTheStatus: "Tem certeza que deseja alterar o status?",
  beneficiaryDetails: "Detalhes do beneficiário",
  beneficiaryBank: "Banco beneficiário",
  accountNumber: "Número da conta",
  invoiceNumber: "Número da Fatura",
  invoiceNo: "N.º da fatura",
  ciDate: "Data CI",
  financialsUpdatedSuccessfully: "Finanças atualizadas com sucesso",
  yourShipmentInformationIsLoading: "As informações do seu envio estão carregando",
  conditionAddedSuccessfully: "Condição adicionada com sucesso",
  atDestination: "No destino",
  someSelectedSupplierHasNoName: "Algum fornecedor selecionado não tem nome",
  someSelectedSupplierDoesNotHaveAnEmail: "Algum fornecedor selecionado não tem e-mail",
  allSelectedSuppliersMustHaveNameEmailAndNotYetBelongToShipeezi: "Todos os fornecedores selecionados devem ter nome, e-mail e ainda não pertencer ao Shipeezi",
  photoAddedSuccessfully: "Foto adicionada com sucesso",
  generalSettings: "Configurações gerais",
  invalidTag: "Etiqueta inválida",
  removeOrder: "Remover pedido",
  houseAirWaybill: "Conhecimento aéreo da casa",
  removeSelected: "Remover selecionados",
  createWarehouse: "Criar Armazém",
  noWarehousesToShow: "Nenhum armazém para mostrar",
  statusUpdatedSuccessfully: "Status atualizado com sucesso",
  supplierPortal: "Portal do fornecedor",
  youreReadyToGo: "Você está pronto para começar!",
  goToLoginPage: "Ir para a página de login",
  onUploadedCsvWeHaveFoundSomeErrors: "No CSV enviado, encontramos alguns erros",
  youShouldAdjustThoseLinesToproceed: "Você deve ajustar essas linhas para continuar",
  youreNowPartOfOurPortal: "Agora você faz parte do nosso portal!",
  ssccGeneration: "Geração de SSCC",
  mustHave: "Deve ter",
  digit: "dígito",
  digits: "dígitos",
  extensionDigit: "Dígito de extensão",
  gs1CompanyCode: "Código de empresa GS1",
  checkDigit: "Dígito verificador",
  columnMustBeFilled: "a coluna deve ser preenchida",
  notFound: "não encontrado",
  isNotValid: "não é válido",
  carton: "Caixa",
  alreadyHasTheLimitOfProductsInside: "já atingiu o limite de produtos",
  thereAreNoRecordsInThisFile: "Não há registros neste arquivo",
  importance: "Importância",
  important: "Importante",
  notImportant: "Não importante",
  markAsUnread: "Marcar como não lido",
  markAsRead: "Marcar como lido",
  markAsImportant: "Marcar como importante",
  unmarkAsImportant: "Desmarcar como importante",
  importantNotifications: "Notificações importantes",
  markAllAsRead: "Marcar tudo como lido",
  seeAllNotifications: "Ver todas as notificações",
  ssccOpen: "SSCC aberto",
  contactVia: "Contatar via",
  orderedQuantity: "Quantidade solicitada",
  percentage: "Percentual",
  areYouSureYouWantToConfirmThisBooking: "Tem certeza que deseja confirmar esta reserva?",
  onceConfirmedThisWillBeSentTo: "Uma vez confirmado, isso será enviado para",
  youAreNotAbleToMakeAnyAdditionalChanges: "você não poderá fazer alterações adicionais",
  valueShouldBeBetween: "O valor deve estar entre",
  valueShouldBe: "O valor deve ser",
  someQuantitiesFulilledAreWrongPleaseReviewAndChangeValues: "Algumas quantidades atendidas estão incorretas. Por favor, revise e altere os valores",
  areYouSureYouWantToDeleteThisShipment: "Tem certeza que deseja excluir este envio?",
  yesDeleteShipment: "Sim, excluir este envio",
  editWaybill: "Editar conhecimento de transporte",
  createWaybill: "Criar conhecimento de transporte",
  youCannotAddTheSameAgent: "Não é possível adicionar o mesmo agente",
  saveAndSubscribe: "Salvar e assinar",
  theProductsMustBelongToTheSameOrder: "Os produtos devem pertencer ao mesmo pedido",
  youShouldSelectTheProducts: "Você deve selecionar os produtos",
  haveProductsFromMultipleOrders: "Têm produtos de múltiplos pedidos",
  portOfLoading: "Porto de Carregamento",
  portOfDischarge: "Porto de Descarga",
  placeOfReceipt: "Local de Recebimento",
  shipperDischargeAirport: "Aeroporto de descarga do remetente",
  shipperReceiptAirport: "Aeroporto de recepção do remetente",
  cargoReadyDate: "Data de carga pronta",
  hasAlreadyBeenAssigned: "já foi atribuído",
  isMissingShipByDate: "está sem data de envio",
  shipByDateIsToEarlyForBooking: "A data de envio é muito cedo para a reserva",
  shipByDateIsToLateForBooking: "A data de envio é muito tarde para a reserva",
  office: "Escritório",
  offices: "Escritórios",
  notifyParty: "Parte notificada",
  youMustSelectABookingModeFirst: "Você deve selecionar um modo de reserva primeiro",
  isDifferentFromBooking: "é diferente da reserva",
  youMustSelectABookingLoadingPortFirst: "Você deve selecionar um porto de carga da reserva primeiro",
  youMustSelectABookingDestinationPortFirst: "Você deve selecionar um porto de destino da reserva primeiro",
  orderAssociated: "Pedido associado",
  selectOrder: "Selecionar pedido",
  youMustSelectABookingDischargePortFirst: "Você deve selecionar um porto de descarga da reserva primeiro",
  youMustSelectedABookingCargoReadyDateFirst: "Você deve selecionar uma data de carga pronta da reserva primeiro",
  mustHaveFourteenDifferenceAtMaxFromCargoReadyDate: "deve ter no máximo 14 dias de diferença da data de carga pronta",
  theLimitOfProductsInsideACartonIs: "O limite de produtos dentro de uma caixa é",
  tolerancePercentage: "Percentual de tolerância",
  activatingThisWillControlTheTolerancePercentageOfProductsInsideABookingToTheDefinedValue: "Ativar isso controlará o percentual de tolerância de produtos dentro de uma reserva ao valor definido",
  theInputValueWillBeConvertedIntoAPercentage: "O valor inserido será convertido em percentual",
  youNeedToMatchTheToleranceOfTheRequestedQuantities: "Você precisa corresponder à tolerância das quantidades solicitadas",
  atLeastOneCartonIsRequiredToCarryOutTheBooking: "Pelo menos uma caixa é necessária para realizar a reserva",
  allCartonsMustContainAtLeastOneProduct: "Todas as caixas devem conter pelo menos um produto",
  valueMustBeGreaterThanZero: "*O valor deve ser maior que zero",
  allSelectedProductsMustMeetTheCriteria: "Todos os produtos selecionados devem atender aos critérios",
  thisValueMustBeAnInteger: "*Este valor deve ser um inteiro",
  shipByDate: "Data de envio",
  bookedVolume: "Volume reservado",
  receivedVolume: "Volume recebido",
  bookedWeight: "Peso reservado",
  receivedWeight: "Peso recebido",
  ssccQuantityBooked: "Quantidade SSCC reservada",
  ssccQuantityReceived: "Quantidade SSCC recebida",
  theValuesWereTheSame: "Os valores eram iguais",
  lessThanBooked: "menor que o reservado",
  moreThanBooked: "maior que o reservado",
  volumeAndWeight: "Volume e peso",
  insertTotalValue: "Inserir valor total",
  insertValuesOf: "Inserir valores de",
  defineTotalValueOfSSCCs: "Definir valor total dos SSCCs",
  defineValuesOfOneSSCC: "Definir valores de um SSCC",
  SSCCCBM: "SSCC CBM",
  SSCCWeight: "Peso do SSCC",
  valueMustBeWithin10OfSupplierValue: "* O valor deve estar dentro de -/+ 10% do valor do fornecedor!",
  notReceived: "Não recebido",
  receiveSSCC: "Receber SSCC",
  changeIt: "Alterá-lo",
  theBookingWillBeSentBackToTheSupplier: "A reserva será enviada de volta ao fornecedor",
  areYouSureYouWantToChangeThisBookingStatusTo: "Tem certeza que deseja alterar o status desta reserva para",
  receiveAllSSCC: "Receber todos os SSCCs",
  closeIt: "Fechá-lo",
  areYouSureYouWantToMarkThisSSCCAsReceived: "Tem certeza que deseja marcar este SSCC como recebido?",
  youAreAboutMarkAllSSCCAsReceived: "Você está prestes a marcar todos os SSCCs como recebidos",
  areYouSure: "Tem certeza?",
  thisActionCannotbeUndone: "Esta ação não pode ser desfeita",
  yesReceiveAll: "Sim, receber todos",
  yesReceiveSSCC: "Sim, receber SSCC",
  allCartonsHaveAlreadyBeenMarkedAsReceived: "Todas as caixas já foram marcadas como recebidas",
  bookingSummary: "Resumo da reserva",
  downloadBookingData: "Baixar dados da reserva",
  downloadReport: "Baixar relatório",
  manageSSCC: "Gerenciar SSCC",
  closeSSCCs: "Fechar SSCCs",
  areYouSureYouWantToClosethese: "Tem certeza que deseja fechar estes",
  thisActionCannotBeUndoneAndIfYouWantToModifyTheseSSCCsYouMustDeleteItAndCreateNewOnes: "Esta ação não pode ser desfeita. Se quiser modificar estes SSCCs, você deve excluí-los e criar novos",
  allSSCCsMustBeReceived: "Todos os SSCCs devem ser recebidos",
  planned: "Planejado",
  allCartonsShouldBeClosedToCarryOutTheBooking: "Todas as caixas devem estar fechadas para realizar a reserva",
  unavailableNotification: "Notificação indisponível",
  shipeeziPredicts: "Shipeezi Prevê",
  carrierShipeeziPredicts: "Transportadora Shipeezi Prevê",
  allSSCCMustHaveProductsInsideThemToBeClosed: "Todos os SSCCs devem ter produtos dentro para serem fechados",
  photosOf: "Fotos de ",
  generalComments: "Comentários gerais",
  valueMustBeEqualToTheSupplierValue: "O valor deve ser igual ao valor do fornecedor",
  beCode: "Código BE",
  pleaseEnteraValidBecode: "Por favor, insira um código BE válido",
  sendTaskToSistrs: "Enviar tarefa para SISTRS",
  beCodeSupplierExample: "AUDASHING3 VDR",
  beCodeCustomerExample: " AUTHECOTT4 HQ",
  totalSSCC: "Total SSCC",
  markBookingAs: "Marcar reserva como",
  selectATriggerFirst: "Selecione um gatilho primeiro",
  default: "Padrão",
  commercialInvoice: "Fatura Comercial",
  beneficiaryName: "Nome do beneficiário",
  beneficiaryAddress: "Endereço do beneficiário",
  vatNumber: "Número de IVA",
  eori: "EORI -",
  fiscalAgentDetails: "Detalhes do agente fiscal",
  salesContractNumber: "Número do contrato de venda",
  salesContractDate: "Data do contrato de venda",
  expNumber: "Número EXP",
  bankName: "Nome do banco",
  bankAddress: "Endereço do banco",
  swiftCode: "Código SWIFT",
  paymentTerms: "Condições de Pagamento",
  termsOfDelivery: "Termos de entrega",
  udNumber: "Número UD",
  ercNumber: "Número ERC",
  rexNumber: "Número REX",
  commercialInvoiceDetails: "Detalhes da fatura comercial",
  cfsReview: "Revisão CFS",
  receivedByCFS: "Recebido pelo CFS",
  lining: "Forro",
  construction: "Construção",
  category: "Categoria",
  fabric: "Tecido",
  styleCode: "Código de estilo",
  brand: "Marca",
  manufacturerDetails: "Detalhes do fabricante",
  composition: "Composição",
  downloadAllFiles: "Baixar todos os arquivos",
  areYouSureYouWantToRemoveThe: "Tem certeza que deseja remover o",
  fromThisBooking: "desta reserva",
  removePurchaseOrder: "Remover ordem de compra",
  allSSCCsInsideThePurchaseOrderWillAlsoBeRemoved: "Todos os SSCCs dentro da ordem de compra também serão removidos",
  yesRemoveIt: "Sim, remover",
  markAndNumbers: "Marcas e números",
  limited: "Limitado",
  characters: "caracteres",
  saveEdit: "Salvar edição",
  cancelEdit: "Cancelar edição",
  purchaseOrderNumber: "Número da ordem de compra",
  cartonName: "Nome da caixa",
  quotesStatus: "Status das cotações",
  someInformationOfThisSkuAreMissing: "Faltam informações deste SKU",
  writeHere: "Escreva aqui",
  createNewRow: "Criar nova linha",
  noRowsCreatedYet: "Ainda não há linhas criadas",
  noData: "Sem dados",
  estimatedQuote: "Cotação estimada",
  yourEstimateQuoteInformationIsLoading: "As informações da sua cotação estimada estão carregando...",
  youAreAboutToApproveThisEstimateAreYouSure: "Você está prestes a aprovar esta estimativa. Tem certeza?",
  reasonForDeclining: "Motivo para recusa",
  reasonForReview: "Motivo para revisão",
  estimateQuoteHasBeenApproved: "A cotação estimada foi aprovada",
  thankYouSoMuchForApprovingTheEstimateWithUs: "Muito obrigado por aprovar a estimativa conosco",
  cantDeliverOrderWithBookedStatus: "Não é possível entregar pedidos com status Reservado",
  selectedPrice: "Preço selecionado: ",
  estimateQuoteHasBeenDeclined: "A cotação estimada foi recusada",
  thisEstimateQuoteHasBeenSentToReview: "Esta cotação estimada foi enviada para revisão",
  weAreVerySorryThatTheQuoteWasNotAsExpectedWeHopeYouCanTryAgainAndEverythingGoesWell: "Lamentamos muito se a estimativa não foi como esperado. Esperamos que você possa tentar novamente e que tudo corra bem",
  shipeeziWillAlwaysBeHereWithYou: "O Shipeezi sempre estará aqui com você",
  weHaveAlreadyNotifiedTheResponsibleCompanyThatThereAreRevisionsToBeMadeAndIfEverythingGoesCorrectlyYouWillReceiveAReturnShortly: "Já notificamos a empresa responsável que há revisões a serem feitas. Se tudo correr bem, você receberá uma resposta em breve",
  saveAndSendToCustomer: "Salvar e enviar ao cliente",
  youHaveToChooseAPriceInTheQuoteTab: "Você deve escolher um preço na aba Cotação",
  youHaveToChooseAPaymentMethodInTheQuoteTab: "Você deve escolher um método de pagamento na aba Cotação",
  noItems: "Sem itens",
  theFieldIsEmpty: "O campo está vazio",
  addNewMaterial: "Adicionar novo material",
  destinations: "Destinos",
  show: "Mostrar",
  taskAdded: "Tarefa adicionada",
  documentCreatedSuccessfully: "Documento criado com sucesso",
  documentsUploadedSuccessfully: "Documentos enviados com sucesso",
  noCommunicationOptionSelected: "Nenhuma opção de comunicação selecionada",
  notificationSent: "Notificação enviada",
  searchForLocation: "Pesquisar localização",
  noNotificationsForNow: "Sem notificações por enquanto",
  notificationsWillAppearHereWhenThereAreAnyUpdatesToTheTasksYouAreInvolvedIn: "As notificações aparecerão aqui quando houver atualizações nas tarefas em que você está envolvido",
  markAndNumbersShouldHaveAtLeastOneFilledLine: "Marcas e números devem ter pelo menos uma linha preenchida",
  theEstimatedQuoteWasSuccessfullyShared: "A cotação estimada foi compartilhada com sucesso",
  noItemsInQuotedInventory: "Sem itens no inventário cotado",
  of: "de",
  reportsTo: "Reporta a",
  changeStatusesTo: "Alterar status para",
  onlyBookingsWithReceivedByCFSCanChangeToReceivedStatus: "Somente reservas com status Recebido pelo CFS podem mudar para status Recebido",
  theLinkHasExpired: "O link expirou",
  theEstimatedQuoteLinkHasExpired: "O link da cotação estimada expirou.",
  youCanRequestANewOneByClickingOnTheButtonBellow: "Você pode solicitar um novo clicando no botão abaixo.",
  requestNewLink: "Solicitar novo link",
  requestedNewLinkSuccessfully: "Novo link solicitado com sucesso",
  whatDoYouWantToSendToCustomer: "O que você deseja enviar ao cliente?",
  shareViaVideoSurveyInvite: "Compartilhar via convite de pesquisa de vídeo",
  sendANewInvitationToTheScheduledVideoSurvey: "Enviar um novo convite para a pesquisa de vídeo agendada",
  shareViaEstimatedQuoteLink: "Compartilhar via link de cotação estimada",
  sendTheExternalLinkOfEstimatedQuote: "Enviar o link externo da cotação estimada",
  thisQuoteDoesNotHaveAValidVideoSurveyTask: "Esta cotação não tem uma tarefa de pesquisa de vídeo válida",
  thisQuoteDoesNotHaveAnEstimate: "Esta cotação não tem uma estimativa",
  createNewOffice: "Criar novo escritório",
  editOffice: "Editar escritório",
  officeStatus: "Status do escritório",
  selectAtLeastOnePort: "Selecionar pelo menos um porto",
  city: "Cidade",
  viewPort: "Ver porto",
  siteCode: "Código do site",
  locationName: "Nome da localização",
  portStatus: "Status do porto",
  site: "Site",
  cityCode: "Código da cidade",
  bookings: "Reservas",
  theInvitationWasSuccessfullySent: "O convite foi enviado com sucesso",
  youMustBeLoggedInToSeeTheInvitation: "Você deve estar conectado para ver o convite!",
  youHaveReachedTheEndOfNotifications: "Você chegou ao fim das notificações",
  youHaventAddedAnyPriceYet: "Você ainda não adicionou nenhum preço.",
  automaticallyApprove: "Aprovar automaticamente",
  addSignatureForEveryPage: "Adicionar assinatura em cada página",
  addSignatureForOwnerAndLeaderForEveryPageOfReportsInsteadOfTheLastOne: "Adicionar assinatura do proprietário e líder em cada página dos relatórios, em vez da última",
  whenTheUserApprovesHisQuoteThisWillAutomaticallyUpdateTheQuoteOnTheSystem: "Quando o usuário aprovar sua cotação, isso atualizará automaticamente a cotação no sistema",
  salesAndOPS: "Vendas e OPS",
  sales: "Vendas",
  ops: "OPS",
  onFieldStaff: "Equipe em campo",
  theCartonCanOnlyContainProductsOfTheSameTypeAndColor: "A caixa só pode conter produtos do mesmo tipo e cor",
  yourCompanyLogoAndIconRepresentYourBrandIdentityAndValuesThisWillBeUsedInAllCommunicationsAndDocumentsSoItWouldBeGoodToUpload: "O logo e o ícone da sua empresa representam a identidade e os valores da sua marca. Serão usados em todas as comunicações e documentos",
  downloadOurCsvTemplate: "Baixe nosso modelo CSV",
  csvActions: "Ações CSV",
  leavingOnboarding: "Saindo da configuração inicial",
  youAreAboutToExitTheOnboardingProcessAreYouSureYouWantToDoThis: "Você está prestes a sair do processo de configuração inicial. Tem certeza?",
  rememberThatYouWillOnlyBeAbleToUseTheSystemAfterCompletingThisProcess: "Lembre-se de que você só poderá usar o sistema após concluir este processo",
  branchName: "Nome da Filial",
  branchAddedSuccessfully: "Filial adicionada com sucesso!",
  viewBranches: "Ver filiais",
  inShipeeziYouCanManageBranchesPhysicalLocationsOfYourBusinessAMinimumOf: "No Shipeezi você pode gerenciar filiais (localizações físicas do seu negócio), com um mínimo de",
  oneBranch: "1 filial",
  mustBeRecorded: "deve ser registrado.",
  resubmitToMODS: "Reenviar para MODS",
  cantSubmitCancelledBookings: "Não é possível enviar reservas canceladas",
  cantDownloadCancelledBookings: "Não é possível baixar reservas canceladas",
  bookingsSubmittedSuccessfully: "Reserva(s) enviada(s) com sucesso",
  areYouSureYouWantToReSubmitTheSelectedBookings: "Tem certeza que deseja reenviar a(s) reserva(s) selecionada(s)?",
  theBookingFileWillBeSentWithAUpdateStatus: "O arquivo de reserva será enviado com um status de atualização",
  submit: "Enviar",
  addShipment: "Adicionar envio",
  noShipmentAssociatedYet: "Nenhum envio associado ainda",
  addShipmentToOrder: "Adicionar envio ao pedido",
  removed: "Removido",
  thisProductWasRemovedFromTheOrder: "Este produto foi removido do pedido",
  networkVisible: "Rede visível",
  partner: "Parceiro",
  uploadImage: "Enviar Imagem",
  thisImageWillBeUsedWhenGeneratingCommercialInvoiceAndPackingListDocumentsBeingUsedAsAnEsignature: "Esta imagem será usada ao gerar documentos de Fatura Comercial e Lista de embalagem, como assinatura eletrônica",
  hereYouCanChooseWheterToSeeTheNetworkAndHaveTheOptionToSelectAndAgent: "Aqui você pode escolher se deseja ver a Rede e ter a opção de selecionar um agente",
  doYouHaveAgentShipeeziNetworkKey: "Você tem a chave de rede Shipeezi do agente?",
  agentShipeeziNetworkToken: "Token de rede Shipeezi do agente",
  thisShipmentHasAPartner: "Este envio tem um parceiro",
  myAccount: "Minha conta",
  orderCancelledSuccessfully: "Pedido cancelado com sucesso",
  prime: "Prime",
  managePlan: "Gerenciar plano",
  lastInvoice: "Última fatura",
  seeInvoiceHistory: "Ver histórico de faturas",
  invoiceAmount: "Valor da fatura",
  amountOwing: "Valor devido",
  billingDate: "Data de cobrança",
  manage: "Gerenciar",
  userType: "Tipo de usuário",
  deductibleQty: "Qtd. dedutível",
  extraQty: "Qtd. extra",
  quantityUsed: "Quantidade utilizada",
  costPerExtraUnit: "Custo por unidade extra",
  totalValue: "Valor total",
  addons: "Complementos",
  addOn: "Complemento",
  dueDate: "Data de Vencimento",
  amount: "Valor",
  currentAccountAmountOwing: "Valor devido da conta atual",
  nextBillingDate: "Próxima data de cobrança",
  billingCountry: "País de cobrança",
  needToCancelYourSubscription: "Precisa cancelar sua assinatura?",
  cancelSubscription: "Cancelar assinatura",
  pleaseNotThatOurPricesAreGSTExclusiveGSTWillBeBilledToAustraliaCustomers: "Note que nossos preços não incluem GST. O GST será cobrado dos clientes da Austrália",
  weKnowCircumstancesCanStometimesChange: "Sabemos que as circunstâncias às vezes podem mudar",
  butBeforeYouGoHaveYouTriedOur: "Mas antes de sair, você já experimentou nossa",
  forTechnicalFAQ: "para perguntas frequentes técnicas",
  knowledgeBase: "Base de conhecimento",
  invoiceHistory: "Histórico de faturas",
  invoiceID: "ID da fatura",
  seeInvoice: "Ver fatura",
  noKeepSubscription: "Não, manter assinatura",
  areYouSureYouWantToCancelYourSubscription: "Tem certeza que deseja cancelar sua assinatura?",
  ifYouAreInDoubtWeOfferOtherPlansAsWell: "Se tiver dúvidas, também oferecemos outros planos",
  byChoosingToCancelARequestWillBeSentToTeamAndThe: "Ao escolher cancelar, uma solicitação será enviada à equipe e",
  weAreSorryToSeeYouGo: "Lamentamos ver você partir!",
  aCancellationRequestHasBeenSentToTheTeamAndWeWillContactYouShortlyToContinueTheOffBoardProcedure: "Uma solicitação de cancelamento foi enviada à equipe e entraremos em contato com você em breve",
  youCanLogoutNow: "Você pode sair agora",
  paid: "Pago",
  uncollectible: "Incobrável",
  waitingForPayment: "Aguardando pagamento",
  planSummary: "Resumo do plano",
  wantToChangeYourPlan: "Quer mudar seu plano?",
  contactSales: "contatar vendas",
  contactSupport: "Contatar suporte",
  ifYouWantToUpgradeOrDowngradeYourPlanPlease: "Se quiser atualizar ou fazer downgrade do seu plano, por favor",
  youDontHaveAnyInvoicesYetWhenAnInvoiceIsGeneratedYoullSeeItHere: "Você ainda não tem faturas. Quando uma fatura for gerada, você a verá aqui",
  thisShipmentHasAnAgent: "Este envio tem um agente",
  containerSizeType: "Tamanho e tipo de contêiner",
  addOrderToShipment: "Adicionar pedido ao envio",
  uploadYourFile: "Envie seu arquivo",
  maxImageSize: "Tamanho máximo de imagem",
  changePicture: "Alterar imagem",
  ExporterInformationIsDifferentFromTheVendor: "As informações do exportador são diferentes do fornecedor",
  exporterName: "Nome do exportador",
  exporterContactDetails: "Detalhes de contato do exportador",
  canBeJust: "pode ser apenas ",
  or: "ou",
  companies: "Empresas",
  ThisProcessIsRecommendedForCompaniesThatHave10OrMoreUsersButOnlyAdminAndGeneralRolesAreAvailableInThisStep: "Este processo é recomendado para empresas com 10 ou mais usuários, mas somente os cargos de Administrador e Geral estão disponíveis nesta etapa",
  introduction: "Introdução",
  welcomeToShipeezi: "Bem-vindo ao Shipeezi!",
  unleashThePowerOfYourNewSoftware: "Libere o poder do seu novo software - a poucos passos!",
  wereConfidentThatYoullFindOurPlatformToBeAnInvaluableTool: "Estamos confiantes de que você achará nossa plataforma uma ferramenta inestimável",
  firstlyLetsAddYourCompanyDetailsToYourAccountIncludingBusinessAddress: "Primeiro, vamos adicionar os detalhes da sua empresa à sua conta, incluindo o endereço comercial",
  nextWellSetUpYourCompanyUsersAndDefineTheirPermissionsAndAccessLevels: "Em seguida, configuraremos os usuários da sua empresa e definiremos suas permissões e níveis de acesso",
  finallyWellAskYouToUploadPreliminaryInformationToAssistOurTeamWithConnectingYourDataStreams: "Por fim, pediremos que você envie informações preliminares para ajudar nossa equipe a conectar seus fluxos de dados",
  deleteComment: "Excluir comentário",
  areYouSureYouWantToDeleteThisComment: "Tem certeza que deseja excluir este comentário?",
  itLooksLikeTheresNoCommentsYet: "Parece que ainda não há comentários",
  feelFreeToAddAnyCommentsYouFeelNecessary: "Sinta-se à vontade para adicionar os comentários que considerar necessários",
  typeHereYourNote: "Escreva aqui sua nota...",
  notifyPartyStatus: "Status da parte notificada",
  editNotifyParty: "Editar parte notificada",
  viewNotifyParty: "Ver parte notificada",
  createNotifyParty: "Criar parte notificada",
  searchForAgent: "Pesquisar agente",
  bodyOfEmail: "Corpo do e-mail",
  bodyOfSMS: "Corpo do SMS",
  cartons: "Caixas",
  custom: "Personalizado",
  customTime: "Hora personalizada",
  shipeeziBilling: "Cobrança do Shipeezi",
  theExtraQuantityIsTheDifferenceBetweenTheQuantityUsedAndDeductibleQty:
    'A quantidade extra é a diferença entre a "Quantidade utilizada" e a "Quantidade dedutível"',
  templateDetails: "Detalhes do modelo",
  youCannotCreateATemplateWithABrokenTag: "Não é possível criar um modelo com uma tag quebrada",
  receiveUsingCSV: "Receber usando CSV",
  couldNotFoundSSCC: "Não foi possível encontrar o SSCC",
  searchForAContact: "Pesquisar contato",
  setTemplateAsDefault: "Definir modelo como padrão",
  ssccNotFound: "SSCC não encontrado",
  ssccFound: "SSCC encontrado",
  setAsDefault: "Definir como padrão",
  yesChangeIt: "Sim, alterar",
  changeDefault: "Alterar padrão",
  doYouWantToMakeTheSelectedTemplateTheDefault: "Deseja definir o modelo selecionado como padrão?",
  theCurrentDefaultForThisTypeWillBeReplaced: "O padrão atual para este tipo será substituído.",
  youCanChangeItBackLaterIfYouWant: "Você pode alterá-lo de volta posteriormente se quiser.",
  cartonStatus: "Status da caixa",
  weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone: "O peso e CBM desta reserva devem ser confirmados antes de fazer isso",
  allSSCCMustBeReceived: "Todos os SSCCs devem ser recebidos",
  confirmAndReceive: "Confirmar e receber",
  allSSCCsFromCsvWereMarkedAsReceived: "Todos os SSCCs do CSV foram marcados como recebidos",
  boxesCouldntBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain: "as caixas não puderam ser marcadas como recebidas. Por favor, verifique todos os erros no documento de dados de escaneamento do armazém e tente novamente",
  NoneSSCCsCouldBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain: "Nenhum SSCC pôde ser marcado como recebido. Por favor, verifique todos os erros no documento de dados de escaneamento do armazém e tente novamente",
  attention: "Atenção",
  containerNumberIsRequired: "O número do contêiner é obrigatório",
  youShouldAddAtLeastOneOrderToTheShipment: "Você deve adicionar pelo menos um pedido ao envio",
  thisFieldMustBeGreaterThanOrEqualTo0: "*Este campo deve ser maior ou igual a 0",
  dcCode: "Código DC",
  thisIsADeliveryLocation: "Esta é uma localização de entrega",
  stayLoggedIn: "Manter sessão",
  aSubscribedShipmentWasUnselectedAndCannotBeRemoved: "Um envio assinado foi desmarcado e não pode ser removido!",
  saveAsDraft: "Salvar como rascunho",
  tracking: "Rastreamento",
  thereWasAProblemTryingToImportTheFilePleaseRefreshThePage: "Houve um problema ao tentar importar o arquivo. Por favor, recarregue a página",
  theFileWasSentToImport: "O arquivo foi enviado para importação",
  vesselPositionUpdateDailyAt5pmUTC: "As posições dos navios são atualizadas diariamente às 17h UTC",
  locationIndicatedAboveIsMoreAccurateIfItDiffersFromMapDisplay: "A localização indicada acima é mais precisa se diferir da exibição do mapa",
  unableToExportCSVFile: "Não é possível exportar o arquivo CSV",
  analytics: "Análise",
  uploadDateAndTime: "Data e hora do upload",
  exporter: "Exportador",
  shipmentNumber: "Número do Embarque",
  postCode: "CEP",
  itemType: "Tipo de item",
  consignmentNumber: "Número de consignação",
  pieces: "Peças",
  stocksToDespatch: "Estoques para despachar",
  palletsToDespatch: "Paletes para despachar",
  deliveryWindowOpen: "Abertura da janela de entrega",
  deliveryWindowClose: "Fechamento da janela de entrega",
  shippingItems: "Itens de envio",
  truck: "Caminhão",
  addExistingAddress: "Adicionar endereço existente",
  newAddress: "Novo endereço",
  noDeliveryAddressAddedYet: "Nenhum endereço de entrega adicionado ainda",
  noPickupAddressAddedYet: "Nenhum endereço de coleta adicionado ainda",
  addresses: "Endereços",
  createDespatch: "Criar despacho",
  editDespatch: "Editar despacho",
  staged: "Preparado",
  inTransit: "Em trânsito",
  newPickUpAddress: "Novo endereço de coleta",
  newDeliveryAddress: "Novo endereço de entrega",
  editPickUpAddress: "Editar endereço de coleta",
  editDeliveryAddress: "Editar endereço de entrega",
  labelAddress: "Endereço de etiqueta",
  pickUpAddress: "Endereço de coleta",
  addAddresses: "Adicionar endereços",
  palletsPerTrucks: "Paletes por caminhão",
  newShippingItem: "Novo item de envio",
  editShippingItem: "Editar item de envio",
  itLooksLikeThereSNoDataYet: "Parece que ainda não há dados",
  youWillBeAbleToSeeAllTheInformationAboutThe: "Você poderá ver todas as informações sobre o",
  associatedWithTheDespatchWhenYouAddThem: "associado ao despacho quando você os adicionar",
  addShippingItems: "Adicionar itens de envio",
  editTruck: "Editar caminhão",
  newTruck: "Novo caminhão",
  quantityOnHand: "Quantidade disponível",
  allDespatched: "Tudo despachado",
  available: "Disponível",
  youCanStartByCreatingANew: "Você pode começar criando um novo",
  passwordsDoNotMatch: "As senhas não coincidem.",
  theresNoEstimatesAvailableToView: "Não há estimativas disponíveis para ver",
  userHasAccessTo: "O usuário tem acesso a...",
  poConfirmedVsPOReceived: "OP Confirmada vs OP Recebida",
  poPastShipByDate: "OP passada a data de envio",
  pastShipByDate: "Passada a data de envio",
  pendingPurchaseOrders: "Ordens de compra pendentes",
  printReport: "Imprimir relatório",
  addTruck: "Adicionar caminhão",
  maxValueAccepted: "Valor máximo aceito",
  averageMonthlyCost: "Custo mensal médio",
  averageOverTheLast12MonthsExcludingTaxes: "Média dos últimos 12 meses excluindo impostos",
  templates: "Modelos",
  youShouldAddAtLeastOnePickUpAddress: "Você deve adicionar pelo menos um endereço de coleta",
  youShouldAddAtLeastOneDeliveryAddress: "Você deve adicionar pelo menos um endereço de entrega",
  youShouldAddAtLeastOneProduct: "Você deve adicionar pelo menos um produto",
  ayrtonSenna: "Ayrton Senna",
  positionInManufacturingCompany: "Cargo na empresa fabricante",
  nameOfManufacturingCompany: "Nome da empresa fabricante",
  egSupplier: "Ex. fornecedor",
  egShipeezi: "Ex. shipeezi",
  searchByCountry: "Pesquisar por país",
  vendorId: "ID do fornecedor",
  countryOfOrigin: "País de Origem",
  accessIntructions: "Instruções de acesso",
  generateInvoice: "Gerar fatura",
  schedule: "Agendar",
  associatedWithTheInvoicesWhenYouAddThem: "associado às faturas quando você os adicionar",
  loadingInvoices: "Carregando faturas",
  consol: "Consolidado",
  etaMonth: "Mês ETA",
  actualDelivery: "Entrega real",
  commInvNo: "N.º Fatura Com.",
  commInvDate: "Data Fatura Com.",
  partNumber: "Número da peça",
  receivedLinePrice: "Preço de linha recebido",
  invoiceExchangeRate: "Taxa de câmbio da fatura",
  audValue: "Valor AUD",
  duty: "taxa",
  lineDutyAmount: "Valor de taxa por linha",
  kewill: "Kewill",
  cblNo: "N.º CBL",
  mawbNo: "N.º MAWB",
  originCharges: "Encargos de origem",
  internationalFreight: "Frete internacional",
  destinationCharges: "Encargos de destino",
  totalFreightAUD: "Frete total AUD",
  unitFob: "FOB unitário",
  freightCPU: "Frete CPU",
  freightasFOB: "Frete como FOB",
  deleteInvoice: "Excluir fatura",
  areYouSureYouWantToDeleteTheInvoice: "Tem certeza que deseja excluir a fatura?",
  invoiceQuantity: "Quantidade da fatura",
  houseBill: "Conhecimento de casa",
  masterBill: "Conhecimento mestre",
  hblCountMode: "Modo de contagem HBL",
  chargeCode: "Código de encargo",
  overseasAmount: "Valor no exterior",
  exchangeRateCurrency: "Moeda da taxa de câmbio",
  exchangeRate: "Taxa de câmbio",
  invoicedLocalAmount: "Valor local faturado",
  gstAmount: "Valor GST",
  invoiceDate: "Data da Fatura",
  invoiceDueDate: "Data de vencimento da fatura",
  autoRate: "Taxa automática",
  cottonOnAdultsApportionment: "Rateio Cotton On adultos",
  cottonOnAdultsLocalAmount: "Valor local Cotton On adultos",
  ceresLifeApportionment: "Rateio Ceres Life",
  ceresLifeLocalAmount: "Valor local Ceres Life",
  bodyApportionment: "Rateio Body",
  bodyLocalAmount: "Valor local Body",
  factorieApportionment: "Rateio Factorie",
  factorieLocalAmount: "Valor local Factorie",
  kidsApportionment: "Rateio Kids",
  kidsLocalAmount: "Valor local Kids",
  rubiApportionment: "Rateio Rubi",
  rubiLocalAmount: "Valor local Rubi",
  foundationApportionment: "Rateio Foundation",
  foundationLocalAmount: "Valor local Foundation",
  typoApportionment: "Rateio Typo",
  typoLocalAmount: "Valor local Typo",
  gamedayApportionment: "Rateio Gameday",
  gamedayLocalAmount: "Valor local Gameday",
  supreApportionment: "Rateio Supre",
  supreLocalAmount: "Valor local Supre",
  fixturesApportionment: "Rateio Fixtures",
  fixturesLocalAmount: "Valor local Fixtures",
  consumablesApportionment: "Rateio Consumables",
  consumablesLocalAmount: "Valor local Consumables",
  otherApportionment: "Rateio Outros",
  otherLocalAmount: "Valor local Outros",
  dateType: "Tipo de data",
  searchBy: "Pesquisar por",
  sendReportByEmail: "Enviar relatório por e-mail",
  originCountry: "País de origem",
  part: "Parte",
  id: "Id",
  createSendRecurrence: "Criar recorrência de envio",
  daily: "Diário",
  weekly: "Semanal",
  monthly: "Mensal",
  frequency: "Frequência",
  isNotAValidEmail: "não é um e-mail válido",
  emailScheduled: "E-mail agendado",
  emailSent: "E-mail enviado",
  storageStatus: "Status de armazenamento",
  newStorageBox: "Nova caixa de armazenamento",
  editStorageBox: "Editar caixa de armazenamento",
  newStorageBoxType: "Novo tipo de caixa de armazenamento",
  editStorageBoxType: "Editar tipo de caixa de armazenamento",
  typeNumber: "Número do tipo",
  depth: "Profundidade",
  deleteStorageBox: "Excluir caixa de armazenamento",
  deleteStorageBoxType: "Excluir tipo de caixa de armazenamento",
  areYouSureYouWantToDeleteThisStorageBox: "Tem certeza que deseja excluir esta caixa de armazenamento?",
  areYouSureYouWantToDeleteThisStorageBoxType: "Tem certeza que deseja excluir este tipo de caixa de armazenamento?",
  createSmsTemplate: "Criar modelo SMS",
  notBeingUsed: "Sem uso",
  inUse: "Em uso",
  template: "Modelo",
  hideCc: "Ocultar CC",
  hideBcc: "Ocultar CCO",
  showCc: "Mostrar CC",
  showBcc: "Mostrar CCO",
  sendEstimateToCustomer: "Enviar estimativa ao cliente",
  writeYourOwnOrChooseFromPreSetTemplates: "Escreva o seu ou escolha entre os modelos pré-definidos",
  storageBoxesAndUnits: "Caixas e Unidades de Armazenamento",
  writeYourOwnOrChooseFromTemplates: "Escreva o seu ou escolha entre os modelos",
  movement: "Movimento",
  movements: "Movimentos",
  objectToMove: "Objeto a mover",
  storageBox: "Caixa de armazenamento",
  looseItem: "Item solto",
  typeOfObject: "Tipo de objeto",
  seeObjectActivity: "Ver atividade do objeto",
  moveTo: "Mover para",
  object: "Objeto",
  moveToLocation: "Mover para localização",
  move: "Mover",
  someObjectDetailsWillBeDisplayedWhenYouSelectIt: "Alguns detalhes do objeto serão exibidos aqui quando você selecioná-lo",
  noObjectSelected: "Nenhum objeto selecionado",
  insideAStorageBox: "Dentro de uma caixa de armazenamento",
  seeFullDetails: "Ver detalhes completos",
  section: "Seção",
  storageBoxDetails: "Detalhes da caixa de armazenamento",
  dateIntoStorage: "Data de entrada no armazenamento",
  lastMoved: "Último movimento",
  isLocatedInTheCellYouAreGoingToMoveDoYouWantToContinue: "está localizado na célula para a qual você vai mover. Deseja continuar?",
  isPlacedInThisLocationRightNowWouldYouLikeToMoveItToAnUnknowLocationForNow: "está localizado nesta localização agora. Deseja movê-lo para uma localização desconhecida por enquanto?",
  the: "O",
  locationIsFull: "A localização está cheia",
  accessTo: "Acesso a",
  rows: "Linhas",
  columns: "Colunas",
  levels: "Níveis",
  createMap: "Criar mapa",
  editMap: "Editar mapa",
  input: "Entrada",
  columnsQuantity: "Quantidade de colunas",
  characterUsed: "Caractere usado",
  initial: "Inicial",
  suffix: "Sufixo",
  rowsQuantity: "Quantidade de linhas",
  levelsQuantity: "Quantidade de níveis",
  buildMap: "Construir mapa",
  numbers: "Números",
  alphabetical: "Alfabético",
  ascendant: "Ascendente",
  descendant: "Descendente",
  deleteMap: "Excluir mapa",
  viewMap: "Ver mapa",
  areYouSureYouWantToDeleteThisMap: "Tem certeza que deseja excluir este mapa?",
  thisFieldMustBeGreaterThanZero: "Este campo deve ser maior que zero",
  mapGenerated: "Mapa gerado",
  topView: "Vista superior",
  applySearch: "Aplicar pesquisa",
  cartonCondition: "Condição da caixa",
  eventDate: "Data do evento",
  deliveryStore: "Loja de entrega",
  storeNumber: "Número da loja",
  estimateArriveWH: "Estimativa de chegada ao armazém",
  arrivalFinalPort: "Chegada ao porto final",
  meChecklist: "Lista M&E",
  haveYouDoneTheMEChecklistOnThisItem: "Você realizou a lista M&E neste item?",
  meChecklistDone: "Lista M&E concluída",
  unsetAsDefault: "Desmarcar como padrão",
  storageAccounts: "Contas de armazenamento",
  period: "Período",
  nextBilling: "Próxima cobrança",
  createNew: "Criar novo",
  settlement: "Liquidação",
  createNewStorageAccount: "Criar nova conta de armazenamento",
  storageAccountOrder: "Pedido de conta de armazenamento",
  pickedUp: "Coletado",
  assignLocation: "Atribuir localização",
  assignStorageBox: "Atribuir caixa de armazenamento",
  storageSpace: "Espaço de armazenamento",
  unit: "Unidade",
  assignStorageBoxLocation: "Atribuir localização de caixa de armazenamento",
  typeStorage: "Tipo de armazenamento",
  storageFrom: "Armazenamento desde",
  gracePeriodEnd: "Fim do período de carência",
  storageEnd: "Fim do armazenamento",
  selectAPaymentMethod: "Selecionar um método de pagamento",
  plan: "Plano",
  totalGSTIncluded: "Total (GST incluído)",
  extraServices: "Serviços extras",
  grandTotal: "Total geral",
  etaUnpackDate: "Data ETA de desembalagem",
  finalPortArrival: "Chegada ao porto final",
  all: "Todos",
  estimateArrivalWH: "Estimativa de chegada ao armazém",
  selectAtLeastOneProject: "Selecionar pelo menos um projeto",
  expectedQty: "Qtd. esperada",
  quantityReceived: "Quantidade recebida",
  dateReceived: "Data de recebimento",
  selectBranch: "Selecionar filial",
  selectGroup: "Selecionar grupo",
  sections: "Seções",
  createNewSection: "Criar nova seção",
  contains: "contém",
  storageBoxType: "Tipo de caixa de armazenamento",
  selectAtLeastOneWarehouseOrSku: "Selecionar pelo menos um armazém ou SKU",
  locationPreviewStatus: "Status de prévia de localização",
  selectNewLocation: "Selecionar nova localização",
  noMapSelected: "Nenhum mapa selecionado",
  aLittleMapPreviewWillAppearHereWhenYouSelectTheSectionInTheObjectThatShouldBeMoved: "Uma pequena prévia do mapa aparecerá quando você selecionar a seção do objeto a ser movido",
  unload: "Descarregar",
  uploadDate: "Data de upload",
  viewInWarehouseMap: "Ver no mapa do armazém",
  changeLocation: "Alterar localização",
  funcionalityUnderDevelopment: "Funcionalidade em desenvolvimento",
  selectWhichOrderToUnload: "Selecionar qual pedido descarregar",
  pleasePayAttention: "Por favor, preste atenção!",
  onceTheOrderIsUnloadedItCannotChangeStatusAgain: "Uma vez descarregado o pedido, ele não pode mudar de status novamente.",
  full: "Cheio",
  unusable: "Inutilizável",
  couldNotFound: "Não foi possível encontrar",
  selectAtLeastOneContainer: "Selecionar pelo menos um contêiner",
  receivedExpected: "Recebido - Esperado",
  receivedUnexpected: "Recebido - Inesperado",
  notReceivedExpected: "Não recebido - Esperado",
  clear: "Limpar",
  clearFields: "Limpar campos",
  palletDimensions: "Dimensões do palete",
  cartonDimensions: "Dimensões da caixa",
  minimumValue: "Valor mínimo",
  newMap: "Novo mapa",
  theFollowingStorageBoxesAreLoadedAndCanNotChangeStatus: "As seguintes caixas de armazenamento estão carregadas e não podem mudar de status:",
  theFollowingMapsHaveLoadedLocationsAndCanNotChangeStatus: "Os seguintes mapas têm localizações carregadas e não podem mudar de status",
  theFollowingWarehousesHaveSectionsWithMapsInUseAndCanNotChangeStatus: "Os seguintes armazéns têm seções com mapas em uso e não podem mudar de status",
  selectAStartDate: "Selecionar uma data de início",
  enterAtLeast: "Inserir pelo menos",
  ordersHaveDifferent: "Os pedidos têm diferente",
  jobNumber: "Número do Trabalho",
  commercialInvoiceNumber: "Número da fatura comercial",
  commercialInvoiceDate: "Data da fatura comercial",
  lineDutyPercent: "Percentual de taxa por linha",
  nonAUEntryFees: "Taxas de entrada não australianas",
  totalUnitCosts: "Custos unitários totais",
  freightAUD: "Frete AUD",
  freightFob: "Flete FOB",
  new: "Novo",
  shareable: "Compartilhável",
  routePlanner: "Planejador de rotas",
  mapSettings: "Configurações do mapa",
  clearLocation: "Limpar localização",
  routing: "Roteamento",
  sharedWith: "Compartilhado com",
  belongsTo: "Pertence a",
  hasNoWarehouses: "não tem armazéns",
  belongsToWarehouse: "Pertence ao armazém",
  sharedWarehouses: "Armazéns compartilhados",
  isNotShareable: "Não é compartilhável",
  cartonsPerPallet: "Caixas por palete",
  allIncluded: "tudo incluído",
  exampleOfTiHi: "Exemplo de Ti-Hi",
  manufacture: "Fabricação",
  deleteProduct: "Excluir produto",
  unitsInTransit: "Unidades em trânsito",
  originShipments: "Envios de origem",
  cartonsToDespatch: "Caixas para despachar",
  companyCurrentStock: "Estoque atual da empresa",
  mainSupplier: "Fornecedor principal",
  stock: "Estoque",
  cartonWeight: "Peso da caixa",
  createProduct: "Criar produto",
  byWho: "Por quem",
  objectNumber: "Número do objeto",
  newMovement: "Novo movimento",
  none: "Nenhum",
  ordersQuantity: "Quantidade de pedidos",
  itemsInsideThisStorageBox: "Itens dentro desta caixa de armazenamento",
  bookingNumber: "Número da reserva",
  noLocation: "Sem localização",
  typeInLocation: "Digitar localização",
  startWarehouse: "Armazém de início",
  endWarehouse: "Armazém de fim",
  rta: "RTA",
  addToRoutePlanner: "Adicionar ao planejador de rotas",
  removingFromRoutePlanner: "Removendo do planejador de rotas",
  removeFromRoutePlanner: "Remover do planejador de rotas",
  removedFromRoutePlanner: "Removido do planejador de rotas",
  addingToRoutePlanner: "Adicionando ao planejador de rotas",
  addedToRoutePlanner: "Adicionado ao planejador de rotas",
  couldNotAddToRoutePlanner: "Não foi possível adicionar ao planejador de rotas",
  couldNotRemoveFromRoutePlanner: "Não foi possível remover do planejador de rotas",
  updatingInRoutePlanner: "Atualizando no planejador de rotas",
  updatedInRoutePlanner: "Atualizado no planejador de rotas",
  couldNotUpdateInRoutePlanner: "Não foi possível atualizar no planejador de rotas",
  addToRoutePlannerQuestionMark: "Adicionar ao planejador de rotas?",
  addAShift: "Adicionar um turno",
  shiftTime: "Horário do turno",
  shiftTimes: "Horários do turno",
  addASecondShiftDuration: "Adicionar uma segunda duração de turno",
  scacCode: "Código SCAC",
  carrierName: "Nome da transportadora",
  carrierNameAbbreviation: "Nome da transportadora (Abr.)",
  editCarrier: "Editar transportadora",
  createNewCarrier: "Criar nova transportadora",
  trackableBy: "Rastreável por",
  areYouSureYouWantToDeleteThisCarrier: "Tem certeza que deseja excluir esta transportadora?",
  deleteCarrier: "Excluir transportadora",
  transshipment: "Transbordo",
  dueDateBy: "Data limite por",
  requestedBy: "Solicitado por",
  assignedTo: "Atribuído a",
  newTransshipment: "Novo transbordo",
  showTodaysTransshipments: "Mostrar transbordos de hoje",
  generalDetails: "Detalhes gerais",
  whatToDo: "O que fazer",
  team: "Equipe",
  saveAndPublish: "Salvar e publicar",
  markItemsYouWantToMove: "Marque os itens que deseja mover",
  perItem: "Por item",
  bingoSheet: "Folha de bingo",
  transshiping: "Transbordando",
  thisFieldShouldHaveAlphaNumericCharactersOnly: "Este campo deve ter apenas caracteres alfanuméricos",
  bookingReference: "Referência de reserva",
  showAllStorageBoxes: "Mostrar todas as caixas de armazenamento",
  addStorageBox: "Adicionar caixa de armazenamento",
  createASingleUseBox: "Criar uma caixa de uso único",
  storageBoxNumber: "Número da caixa de armazenamento",
  volumeAvailable: "Volume disponível",
  theStorageBoxHasBeenAddedSuccessfully: "A caixa de armazenamento foi adicionada com sucesso",
  itLooksLikeTheresNoDataYet: "Parece que ainda não há dados",
  startSearchingForAStorageBoxOrCreateASingleUseBox: "Comece pesquisando uma caixa de armazenamento ou crie uma de uso único.",
  system: "Sistema",
  editTransshipment: "Editar transbordo",
  any: "Qualquer",
  pickUpTime: "Horário de coleta",
  deliveryTime: "Horário de entrega",
  addDespatchesToRoute: "Adicionar despachos à rota",
  removeDespatchesToRoute: "Remover despachos da rota",
  added: "Adicionado",
  searchForStorageBox: "Pesquisar caixa de armazenamento",
  noItemsToAddToTransshipment: "Sem itens para adicionar ao transbordo",
  showTodayTransshipments: "Mostrar transbordos de hoje",
  showing: "Mostrando",
  theOrderHasAlreadyBeenAdded: "O pedido já foi adicionado",
  publish: "Publicar",
  editProject: "Editar projeto",
  newProject: "Novo projeto",
  fileName: "Nome do arquivo",
  dateUploaded: "Data do upload",
  ofRows: "de linhas",
  addFile: "Adicionar arquivo",
  whenYouAddThem: "quando você os adicionar",
  youWillBeAbleToSeeAllThe: "Você poderá ver todos os",
  detailsHereWhenYouUploadAtLeastOne: "detalhes aqui quando você enviar pelo menos um",
  createProject: "Criar projeto",
  uploadAFile: "Enviar um arquivo",
  willBeRemoveAllOfTheItemsWillUnloadFromIt: "Será removido. Todos os itens serão descarregados dele.",
  areYouSureYouWantToContinue: "Tem certeza que deseja continuar?",
  removeStorageBox: "Remover caixa de armazenamento",
  cellInUse: "Célula em uso",
  allWarehouses: "Todos os armazéns",
  yourStorageBoxesAreBeingUploaded: "Suas caixas de armazenamento estão sendo enviadas",
  automate: "Automatizar",
  sentToEmail: "Enviado por e-mail",
  editAutomation: "Editar automação",
  deletedSuccessfully: "Excluído com sucesso",
  deleteAutomation: "Excluir automação",
  doYouReallyWantToDeleteTheAutomation: "Realmente deseja excluir a automação?",
  createOrder: "Criar pedido",
  addNewproducts: "Adicionar novos produtos",
  manual: "Manual",
  paragraph: "Parágrafo",
  options: "Opções",
  addOption: "Adicionar opção",
  youNeedToLogOutAndLogBackInForSomeChangesToBeApplied: "Você precisa sair e entrar novamente para que algumas alterações sejam aplicadas",
  someChangesWereNotApplied: "Algumas alterações não foram aplicadas",
  enableAsAStorageBox: "Habilitar como caixa de armazenamento",
  enablingThisAllowsTheUserToChooseTheVehicleForStorageMovementOrTransshipmentAndIndicateWhenItemsArePlacedInsideLikeAStorageBox: "Habilitar isso permite ao usuário escolher o veículo para movimento de armazenamento ou transbordo e indicar quando os itens estão dentro",
  projectUpdatedWithSuccess: "Projeto atualizado com sucesso",
  deleteBrandName: "Excluir nome de marca",
  deleteBrandNames: "Excluir nomes de marca",
  areYouSureYouWantToDeleteTheBrandName: "Tem certeza que deseja excluir o nome de marca?",
  areYouSureYouWantToDeleteThese: "Tem certeza que deseja excluir estes?",
  brandName: "Nome de marca",
  brandNames: "Nomes de marca",
  brandCode: "Código de marca",
  addNewBrandName: "Adicionar novo nome de marca",
  youCanStartByAddingANewBrandName: "Você pode começar adicionando um novo nome de marca",
  loadingBrands: "Carregando marcas",
  newBrand: "Nova marca",
  logo: "Logo",
  editBrand: "Editar marca",
  viewBrand: "Ver marca",
  deleteBrands: "Excluir marcas",
  previewOnSSCCLabel: "Prévia na etiqueta SSCC",
  noPdfFileSpecified: "Nenhum arquivo PDF especificado",
  loadType: "Tipo de carga",
  groupageVanline: "Grupagem/Vanline",
  otherEnterDims: "Outro (inserir dims)",
  parties: "Partes",
  rail: "Ferroviário",
  itemIsAHardwareBox: "O item é uma caixa de hardware",
  youCanSeeTheReportsAfterSelectingTheFollowingFilters: "Você pode ver os relatórios após selecionar os seguintes filtros",
  selectAProject: "Selecionar um projeto",
  selectAWarehouse: "Selecionar um armazém",
  selectASKU: "Selecionar um SKU",
  selectAContainer: "Selecionar um contêiner",
  brands: "Marcas",
  repeat: "Repetir",
  weAreCheckingIfALinkIsAvailable: "Estamos verificando se há um link disponível",
  pleaseSelectAOrderType: "Por favor, selecione um tipo de pedido",
  etaDestination: "ETA destino",
  etaDespatch: "ETA despacho",
  trackable: "Rastreável",
  downloadShipmentInformations: "Baixar informações do envio",
  boxContents: "Conteúdo da caixa",
  packedInto: "Embalado em",
  indicateLiftvanOrSectionTheItemCanBeFound: "Indique o liftvan ou seção onde o item pode ser encontrado",
  values: "Valores",
  automaticallyCreateOneHardwareBoxInEveryInventory: "Criar automaticamente uma caixa de hardware em cada inventário",
  needsAtLeastOneActiveHardwareBoxItemToBeEnabled: "Precisa de pelo menos um item ativo de caixa de hardware para ser habilitado.",
  carrierScac: "SCAC da transportadora",
  fieldsAreRequired: "Número do contêiner, referência de reserva ou conhecimento de embarque são obrigatórios",
  theFleetNameIsUsedAsTheSystemDefault: "O nome da frota é usado como padrão do sistema",
  isBox: "É caixa",
  isBoxInterrogation: "É caixa?",
  isThisTypeOfPackagingABox: "Este tipo de embalagem é uma caixa?",
  hardwareBox: "Caixa de hardware",
  itemIsHighRiskOrHighValue: "O item é de alto risco/alto valor",
  thisCarrierAllowsShipmentTrackingBy: "Esta transportadora permite rastreamento de envios por",
  meChecklistIsmandatoryForThisItemPleaseAnswerIt: "A lista M&E é obrigatória para este item, por favor responda",
  enableEstimateEditing: "Habilitar edição de estimativa",
  enable: "Habilitar",
  areYouSureYouWantToEnableEditingEstimateForThisQuote: "Tem certeza que deseja habilitar a edição de estimativa para esta cotação?",
  changesMadeToThisQuoteMayAlsoAffectOrder: "As alterações feitas nesta cotação também podem afetar o pedido.",
  measurementPreview: "Prévia de medidas",
  me: "M&E",
  highRiskHighValue: "Alto risco / Alto valor",
  proGear: "Pro-Gear",
  itemIsAME: "O item é M&E",
  youCanSeeTheReportsAfterSelectingAtLeast: "Você pode ver os relatórios após selecionar pelo menos",
  warehouseCodeAlreadyExistsPleaseAssignANewCode: "O código de armazém já existe. Por favor, atribua um novo código.",
  enterTheBoxNumberToSearch: "Insira o número da caixa para pesquisar.",
  enterTheOrderToSearch: "Insira o pedido para pesquisar.",
  noResults: "Sem resultados",
  etdOrigin: "ETD origem",
  etaPlanned: "ETA planejado",
  addNewShipment: "Adicionar Novo Embarque",
  basedOnABooking: "Baseado em uma reserva",
  box: "Caixa",
  case: "Estojo",
  pallet: "Palete",
  ftl: "FTL",
  ltl: "LTL",
  fcl: "FCL",
  lcl: "LCL",
  groupage: "Grupagem",
  roro: "RORO",
  bulk: "Granel",
  commodityHSCode: "Código HS da mercadoria",
  enterTheLocationToSearch: "Insira a localização para pesquisar.",
  productPhoto: "Foto do produto",
  masterbillOfLanding: "Conhecimento de embarque mestre",
  housebillOfLanding: "Conhecimento de embarque da casa",
  shipmentDetails: "Detalhes do envio",
  placeOfOrigin: "Local de origem",
  shipperCode: "Código do remetente",
  addAnotherContainer: "Adicionar outro contêiner",
  volumetricWeight: "Peso volumétrico",
  grossVolume: "Volume bruto",
  tareWeight: "Peso tara",
  netWeight: "Peso Líquido",
  verifiedGrossWeight: "Peso bruto verificado",
  selectABooking: "Selecionar uma reserva",
  noSubscriberAdded: "Sem assinante adicionado",
  selectABookingBellowToStartAShipmentBasedOnIt: "Selecione uma reserva abaixo para iniciar um envio baseado nela",
  selectJustOneBookingPerShipment: "Selecione apenas uma reserva por envio",
  startByAddingASubscribertoShipment: "Comece adicionando um assinante ao envio",
  youMustSelectAShipmentLoadingPortFirst: "Você deve selecionar um porto de carga do envio primeiro",
  youMustSelectAShipmentDestinationFirst: "Você deve selecionar um destino do envio primeiro",
  youMustSelectAShipmentOriginFirst: "Você deve selecionar uma origem do envio primeiro",
  youMustSelectAShipmentDischargePortFirst: "Você deve selecionar um porto de descarga do envio primeiro",
  youMustSelectAShipmentModeFirst: "Você deve selecionar um modo do envio primeiro",
  youMustSelectAShipmentIncotermFirst: "Você deve selecionar um incoterm do envio primeiro",
  variance: "Variância",
  youCanStartByAddingAnOrder: "Você pode começar adicionando um pedido",
  editSubscriber: "Editar assinante",
  fromThisShipment: "deste envio",
  regularCargo: "Carga regular",
  hazardousCargo: "Carga perigosa",
  foodGradeCargo: "Carga de grau alimentício",
  rareCargo: "Carga rara",
  reeferCargoRefrigerated: "Carga refrigerada (Reefer)",
  addInAContainer: "Adicionar em um contêiner",
  chooseAContainerToAddTheSsccInto: "Escolha um contêiner para adicionar o SSCC",
  choose: "Escolher",
  distanceTravelled: "Distância percorrida",
  distanceToGo: "Distância a percorrer",
  route: "Rota",
  shipeeziPredictsETA: "Shipeezi Prevê ETA",
  plannedETA: "ETA planejado",
  theCarrierProvidesDateTimesBelowAndMayNotMatchObservationsAndPredictionsInOtherSections: "A transportadora fornece datas e horários abaixo que podem não corresponder a observações e previsões em outras seções",
  events: "Eventos",
  notEventsToShowAtTheMoment: "Sem eventos para mostrar no momento",
  dayDelay: "Dia de atraso",
  daysDelay: "Dias de atraso",
  invalidNumber: "Número inválido",
  trackingNotFound: "Rastreamento não encontrado",
  shipmentCreated: "Envio criado",
  checkTheInformationYouHaveFilledInUpdateItAndSaveItWellValidateItAgainInAFewMinutes: "Verifique as informações que você preencheu, atualize e salve. Validaremos novamente em alguns minutos",
  weReStillValidatingInformationToSeeIfThisShipmentIsTrackableRefreshThisPageInAFewMinutes: "Ainda estamos validando as informações para ver se este envio é rastreável. Atualize esta página em alguns minutos",
  thereIsNoTrackingAvailableForThisShipment: "Não há rastreamento disponível para este envio.",
  yourShipmentWasSuccesfullyCreatedAndWereNowValidatingTheInformationToSeeIfItsTrackable: "Seu envio foi criado com sucesso e agora estamos validando as informações para ver se é rastreável",
  inAFewMinutesYouCanConsultTheTrackingInfoByClickingTheViewOrEditIconButtonInTheActionsColumnOnTheGrid: "Em alguns minutos, você pode consultar as informações de rastreamento clicando no ícone de ver ou editar na coluna de ações",
  whatDoYouWantToSend: "O que você deseja enviar?",
  sendTrackingViaSMSOrEmail: "Enviar rastreamento por SMS ou e-mail",
  sendShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse: "Enviar rastreamento do envio por SMS ou e-mail ao cliente ou a outra pessoa",
  writeAnEmailOrUseATemplate: "Escreva um e-mail ou use um modelo",
  writeASMSOrUseATemplate: "Escreva um SMS ou use um modelo",
  writeAPushNotificationOrUseATemplate: "Escreva uma notificação push ou use um modelo",
  sendJSONFile: "Enviar arquivo JSON",
  sendOnlyTheJSONFileToCustomer: "Enviar apenas o arquivo JSON ao cliente",
  trackingNotAvailable: "Rastreamento não disponível",
  doYouAlsoWantToCancelTheLinkedOrder: "Você também deseja cancelar o pedido vinculado?",
  areYouSureYouWantToDeleteThisProduct: "Tem certeza que deseja excluir este produto?",
  createSingleUseBox: "Criar uma caixa de uso único",
  newSingleUseBox: "Nova caixa de armazenamento de uso único",
  createAnotherSingleUseBox: "Criar outra caixa de uso único",
  searchByContactNameMobilePhoneOrEmailAddress: "Pesquisar por nome do contato, celular ou e-mail",
  searchOrAddAContact: "Pesquisar ou adicionar um contato",
  howMany: "Quantas?",
  autoNumberThem: "Numerar automaticamente",
  typePrefix: "Digitar prefixo",
  singleUse: "Uso único",
  noWarehouses: "Sem armazéns",
  byWhom: "Por quem",
  enterTheObjectToSearch: "Insira o objeto para pesquisar.",
  orderOrCustomer: "Pedido ou Cliente",
  salutation: "Saudação",
  allowance: "Subsídio",
  secondReference: "2.ª Referência",
  editLiftvans: "Editar liftvans",
  addLiftvans: "Adicionar liftvans",
  areYouSureYouWantToCancelTheTransshipment: "Tem certeza que deseja cancelar o transbordo?",
  yesCancelTransshipment: "Sim, cancelar transbordo",
  cancelTransshipment: "Cancelar transbordo",
  sendTheShipmentTrackingViaSMSToTheCustomerOrAnotherPerson: "Enviar o rastreamento do envio por SMS ao cliente ou a outra pessoa",
  sendTrackingViaSMS: "Enviar rastreamento por SMS",
  createdOn: "Criado em",
  sendTheShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse: "Enviar o rastreamento do envio por SMS ou e-mail ao cliente ou a outra pessoa",
  sendTrackingViaSMSorEmail: "Enviar rastreamento por SMS ou e-mail",
  weightAndMeasurements: "Peso e medidas",
  storageBoxAdded: "Caixa de armazenamento adicionada",
  storageBoxRemoved: "Caixa de armazenamento removida",
  generateCsv: "Gerar CSV",
  revokeInvite: "Revogar convite",
  yesRevoke: "Sim, revogar",
  revokeInvitation: "Revogar convite",
  doYouWantToRevokeTheInvitationSentTheUserWillNoLonge: "Deseja revogar o convite enviado? O usuário não poderá mais",
  youCanAlwaysInviteThemAgain: "Você sempre pode convidá-los novamente.",
  cancelInvite: "Cancelar convite",
  thisInviteWasRevoked: "Este convite foi revogado",
  oopsItLooksLikeThisInvitationHasBeenRevoked: "Ops, parece que este convite foi revogado e não é mais válido",
  ifYouThinkThisIsAnErrorPleaseContactTheCompanyResponsibleToBetter: "Se achar que isso é um erro, contate a empresa responsável",
  unlinkInventory: "Desvincular inventário",
  yesUnlink: "Sim, desvincular",
  doYouWantToUnlinkTheInventory: "Deseja desvincular o inventário?",
  inventoryLinked: "Inventário vinculado",
  inventoryUnlinked: "Inventário desvinculado",
  inventoryLinkedSuccessfully: "Inventário vinculado com sucesso",
  inventoryUnlinkedSuccessfully: "Inventário desvinculado com sucesso",
  relinkInventory: "Revincular inventário",
  yesRelink: "Sim, revincular",
  doYouWantToRelink: "Deseja revincular?",
  thisActionWillReplaceTheValuesYouveSetWithTheValuesFromYourActualInventory: "Esta ação substituirá os valores que você definiu pelos valores do seu inventário real",
  whenYouUnlinkTheInventoryYouCanEditTheTotalValuesThisMeansThatAnyFutureChangesYouMakeToTheInventoryWillNotBeReflectedInTheseMeasurements: "Quando você desvincular o inventário, poderá editar os valores totais. Isso significa que as alterações futuras no inventário não serão refletidas nessas medidas",
  inventoriesSummary: "Resumo de inventários",
  itemIsProGear: "O item é Pro-Gear",
  apps: "Aplicativos",
  thisStorageBoxTypeIsCurrentlyInUseAndItsStatusCantBeChanged: "Este tipo de caixa de armazenamento está em uso e seu status não pode ser alterado",
  allowItemPhotosToBeUploadedFromTheDevicesImageGallery: "Permitir que fotos de itens sejam enviadas da galeria de imagens do dispositivo",
  thisSettingsEnablesMobileAppUsersToUploadImagesFromTheirDevicesGallery: "Esta configuração permite aos usuários do app móvel enviar imagens da galeria do seu dispositivo",
  thisMayCauseADataSecurityRiskAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices: "Isso pode causar risco de segurança de dados, pois pode incentivar o armazenamento de fotos de itens de clientes em dispositivos pessoais",
  allowUseOfDeviceGallery: "Permitir uso da galeria do dispositivo",
  galleryUsePermission: "Permissão de uso da galeria",
  enablesUsersToUploadItemImagesFromTheirDevicesGallery: "Permite aos usuários enviar imagens de itens da galeria do dispositivo",
  note: "Nota",
  thisMayCauseAPersonalInformationSecurityRisksAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices: "Isso pode causar riscos de segurança de informações pessoais ao incentivar o armazenamento de fotos de itens de clientes em dispositivos pessoais",
  typeHere: "Digite aqui...",
  hideCC: "Ocultar CC",
  hideBCC: "Ocultar CCO",
  cc: "Cc",
  linkedTo: "Vinculado a",
  linkedMaterials: "Materiais vinculados",
  selectAMaterial: "Selecionar um material",
  addAnExistingGroup: "Adicionar um grupo existente",
  newBlankGroup: "Novo grupo em branco",
  selectOneOrMoreGroups: "Selecionar um ou mais grupos",
  addGroup: "Adicionar grupo",
  showCC: "Mostrar CC",
  showBCC: "Mostrar CCO",
  asTheShipmentIdentificationIsUniqueYouCannotChangeItAfterCreation: "Como a identificação do envio é única, você não pode alterá-la após a criação",
  generatePDFReport: "Gerar relatório PDF",
  reportLanguage: "Idioma do relatório",
  taskReportType: "Tipo de relatório de tarefa",
  addedToContainer: "Adicionado ao contêiner",
  ssccs: "SSCCs",
  typeAComment: "Digitar um comentário",
  addAComment: "Adicionar um comentário",
  commentsHistory: "Histórico de comentários",
  addedOn: "Adicionado em",
  youCanStartByCreatingASscc: "Você pode começar criando um SSCC",
  hereIsYourShipmentInfo: "Aqui estão as informações do seu envio",
  yourShipmentHasArrivedAt: "Seu envio chegou a",
  commentSpecialInstruction: "Comentário/Instrução especial",
  hsCode: "Código HS",
  typeInAConsignee: "Digitar um consignatário",
  typeInACustomer: "Digitar um cliente",
  typeInOtherParty: "Digitar outra parte",
  otherAdditionalParty: "Outra parte adicional",
  byFillingInOneOrMoreOfTheseFieldsYourShipmentWillBeTracked: "Ao preencher um ou mais desses campos, seu envio será rastreado",
  moreContainerType: "Mais tipos de contêiner",
  sendCustomerPortalLink: "Enviar link do portal do cliente",
  typeInToSearch: "Digite para pesquisar",
  flight: "Voo",
  generatedBySystem: "Gerado pelo sistema",
  mandatory: "Obrigatório",
  newDocument: "Novo documento",
  clearFile: "Limpar arquivo",
  areYouSureYouWantToDelete: "Tem certeza que deseja excluir?",
  deleteDocument: "Excluir documento",
  notAvailableYet: "Ainda não disponível",
  documentsForThisShipment: "Documentos para este envio",
  shipmentMustBeConfirmed: "O envio deve ser confirmado",
  clearingFile: "Limpando arquivo",
  generatingFile: "Gerando arquivo",
  openingFile: "Abrindo arquivo",
  shareCustomerPortalLink: "Compartilhar link do portal do cliente",
  sendTheCustomerPortalLinkWithAccessToTheOrderOnline: "Enviar o link do portal do cliente com acesso ao pedido online",
  loading: "Carregando",
  escalation: "Escalação",
  escalationContactRaised: "Escalação/Contato levantado",
  removeEscalationRequest: "Remover solicitação de escalação",
  noKeepIt: "Não, manter",
  ohNoSomethingWentWrongPleaseTryAgain: "Oh não! Algo deu errado. Por favor, tente novamente.",
  escalationRequestHasBeenRemoved: "A solicitação de escalação foi removida",
  removingThisEscalationChangeRequestWillClearAnyPendingRequests: "Remover esta solicitação de escalação/mudança limpará todas as solicitações pendentes",
  areYouSureYouWishToProceed: "Tem certeza que deseja prosseguir?",
  yourEscalationRequestHasBeenSentSuccessfully: "Sua solicitação de escalação foi enviada com sucesso",
  inputComment: "Inserir comentário",
  sendTo: "Enviar para",
  selectedPerson: "Pessoa selecionada",
  selectWhoToNotify: "Selecionar quem notificar",
  theFollowingEmail: "O seguinte e-mail",
  notify: "Notificar",
  contactUs: "Entre em contato",
  packingItems: "Embalando itens",
  closingTheBoxes: "Fechando as caixas",
  listeningToBubbleWrapConfessions: "Ouvindo confissões do plástico bolha",
  parkingTheShip: "Estacionando o navio",
  talkingToTheFish: "Conversando com os peixes",
  cartonContents: "Conteúdo da caixa",
  ata: "ATA",
  thereIsNoTrackingInformationAvailableForThisShipment: "Não há informações de rastreamento disponíveis para este envio",
  thisTabWillShowSomeTrackingInformationIfAvailableAfterYouCreateTheShipment: "Esta aba mostrará informações de rastreamento, se disponíveis, após você criar o envio",
  theresNoTrackingInformationYet: "Ainda não há informações de rastreamento",
  livePosition: "Posição ao vivo",
  containerCase: "Contêiner / Estojo",
  containerCaseSize: "Tamanho do contêiner / Estojo",
  sealMarkings: "N.º de lacre / Marcações",
  selectALoadType: "Selecionar um tipo de carga",
  selectAContainerCaseSize: "Selecionar um tamanho de contêiner ou estojo",
  typeAContainerCaseSize: "Digitar um tamanho de contêiner ou estojo",
  dContainer: "Contêiner D",
  eContainer: "Contêiner E",
  ldnContainer: "Contêiner LDN",
  liftvan: "Liftvan",
  liftvans: "Liftvans",
  eur1Iso1Pallet: "Palete EUR1/ISO1",
  eur2Iso2Pallet: "Palete EUR2/ISO2",
  itLooksLikeThereNoDataYet: "Parece que ainda não há dados",
  startByAddingAnOrderToShipment: "Comece adicionando um pedido ao envio",
  thisValueShouldBeAPositiveNumber: "Este valor deve ser um número positivo",
  selectTheLoadTypeFirst: "Selecione o tipo de carga primeiro",
  hsCommodityCode: "Código HS / Mercadoria",
  searchForAnAgent: "Pesquisar um agente",
  enterAValueGraterThanNetWeight: "Insira um valor maior que o peso líquido",
  enterAValueLowerThanGrossWeight: "Insira um valor menor que o peso bruto",
  youShouldAddAtLeastOneContainerToTheShipment: "Você deve adicionar pelo menos um contêiner ao envio",
  thisRepresentsTheInitialEstimatedTimeOfArrivalProvidedByTheCarrier: "Isso representa o tempo estimado inicial de chegada fornecido pela transportadora",
  thisIsYourShipmentInformation: "Estas são as informações do seu envio",
  today: "Hoje",
  configure: "Configurar",
  last15Days: "Últimos 15 dias",
  lastMonth: "Mês Passado",
  monthToDate: "Mês até a data",
  lastYear: "Ano Passado",
  customDate: "Data personalizada",
  customPeriod: "Período personalizado",
  configureOverview: "Configurar visão geral",
  adjustWidgetsAndViewAsYouWish: "Ajuste os widgets e a visualização como desejar",
  purchaseOrdersWidgets: "Widgets de ordens de compra",
  poStatuses: "Status de OP",
  lastReceivedOrders: "Últimos pedidos recebidos",
  poConfirmedVSPoReceived: "OP confirmada vs OP recebida",
  productsOrigin: "Origem dos produtos",
  mostRequestedProducts: "Produtos mais solicitados",
  productsRunningOutOfStock: "Produtos com estoque baixo",
  containersByArrivalDate: "Contêineres por data de chegada",
  shipmentsPerTime: "Envios por período",
  shipmentStatuses: "Status de envios",
  resetToDefault: "Restaurar padrão",
  ofTotal: "Do total",
  inboundAtPortAtDC: "Entrada, no porto e no DC",
  containersStatuses: "Status de contêineres",
  amountOfSSCC: "Quantidade de SSCC",
  apply: "Aplicar",
  searchForAConsultant: "Pesquisar um consultor",
  enableQuoteEditing: "Habilitar edição de cotação",
  areYouSureYouWantToEnableEditingForThisQuote: "Tem certeza que deseja habilitar a edição para esta cotação?",
  trackYourShipmentByFillingInEitherOrBothFields: "Rastreie seu envio inserindo o conhecimento de embarque (BOL), referência de reserva ou número de contêiner",
  pleaseFillInAtLeastOnField: "Por favor, preencha pelo menos um campo.",
  dimensionalWeight: "Peso dimensional",
  airportOfOrigin: "Porto de descarga (PoD)",
  airportOfDestination: "Aeroporto de destino",
  arrivalAOfDestination: "Data de entrega",
  accounts: "Contas",
  ofUsers: "de usuários",
  newAccount: "Nova conta",
  companyAddress: "Endereço da empresa",
  accountLogo: "Logo da conta",
  notEnoughData: "Dados insuficientes",
  thereIsInsufficientDataToGenerateGraphicsForTheSelectedPeriod: "Há dados insuficientes para gerar gráficos para o período selecionado",
  atDC: "No DC",
  incoterms: "Incoterms",
  uldContainers: "Contêineres ULD",
  uldPallets: "Paletes ULD",
  thisActionWillAlsoRemoveAnyFilesYouHaveUploadedInIt: "Esta ação também removerá todos os arquivos que você enviou.",
  actualInventory: "Inventário real",
  checkAllSteps: "Verificar todas as etapas",
  milestones: "Marcos",
  checkYourMoveFileOnline: "Verifique seu arquivo de mudança online",
  logedInAs: "Conectado como",
  english: "Inglês",
  yourOrder: "Seu pedido",
  theTokenProvidedIsIncorrect: "O token fornecido está incorreto",
  nextStep: "Próxima etapa",
  survey: "Pesquisa",
  typeYourCommentsHere: "Digite seus comentários aqui",
  agentContactDetails: "Detalhes de contato do agente",
  distanceToNextPort: "Distância ao próximo porto",
  kg: "Kg",
  eventsUnavailable: "Eventos indisponíveis",
  routeUnavailable: "Rota indisponível",
  trackingInformationUnavailable: "Informações de rastreamento indisponíveis no momento.",
  nauticalMiles: "Milhas náuticas",
  closeAllSSCCs: "Fechar todos os SSCCs",
  areYouSureYouWantToCloseAllSSCCs: "Tem certeza que deseja fechar todos os SSCCs?",
  isItByDefaultAMilestone: "É, por padrão, um marco?",
  newTask: "Nova Tarefa",
  addTask: "Adicionar Tarefa",
  tasksAndMilestones: "Tarefas e marcos",
  milestonesFunctionallity: "Funcionalidade de marcos",
  aMilestoneIsAKeyDateThatShowsOnTheCustomerPortalMilestonesAreDisplayedAsAMoveFlowInAscendingOrderTasksAreSetByDefaultToBeConsideredAMilestoneOrNot: "Um marco é uma data-chave que aparece no portal do cliente. Os marcos são exibidos como um fluxo de mudança em ordem ascendente. As tarefas são configuradas por padrão para ser consideradas um marco ou não.",
  youCanEditTheseDefaultsInSystemSettings: "Você pode editar esses padrões nas configurações do sistema.",
  youCanAlsoChooseToChangeThemAsNeededForThisFileOnly: "Você também pode optar por alterá-los conforme necessário apenas para este arquivo.",
  setAsMilestone: "Definir como marco",
  removeAsMilestone: "Remover como marco",
  youCanChooseFromTheListBelowWhichItemsYouWantToUpload: "Você pode escolher na lista abaixo quais itens deseja enviar",
  downloadCSVTemplate: "Baixar modelo CSV",
  theFilesWereUploadedAndUpdatedSuccesfully: "Os arquivos foram enviados e atualizados com sucesso",
  anErrorOccurredLoadingUploadCentreTryAgain: "Ocorreu um erro ao carregar o Centro de envio, tente novamente",
  weHaveFoundSomeErros: "encontramos alguns erros",
  branchCode: "Código da Filial",
  warehouseCode: "Código do Armazém",
  branchCodeNotFound: "Código de filial não encontrado",
  warehouseCodeNotFound: "Código de armazém não encontrado",
  thisBranchIsNotRelatedToInformedWarehouse: "Esta filial não está relacionada ao armazém informado",
  serviceCodeAlreadyExistsPleaseAssignANewCode: "O código de serviço já existe. Por favor, atribua um novo código.",
  materialCodeAlreadyExistsPleaseAssignANewCode: "O código de material já existe. Por favor, atribua um novo código.",
  codeAlreadyExistsPleaseAssignANewCode: "O código já existe. Por favor, atribua um novo código.",
  codeIsDuplicated: "O código está duplicado",
  codeNotFound: "Código não encontrado",
  anErrorOccurredOnTryAgain: "Ocorreu um erro, tente novamente",
  looseItems: "Itens soltos",
  thisFieldMustHaveAtLeastOneItem: "Este campo deve ter pelo menos um item",
  theOrderAlreadyIsInATransshipment: "O pedido já está em um transbordo",
  publishTask: "Publicar tarefa",
  unpublishTask: "Cancelar publicação da tarefa",
  noCommentsAdded: "Sem comentários adicionados",
  actualAtDepartureDock: "Chegada no PoD",
  actualArrivalOfDestination: "Data de entrega",
  noRecord: "Sem registro",
  hwab: "HWAB",
  selectAPeriod: "Selecionar um período",
  storageBoxSingleUseSelected: "Caixa de armazenamento de uso único selecionada",
  youCanAddOnlyOneOrderToAStorageBoxSingleUse: "Você pode adicionar apenas um pedido a uma caixa de armazenamento de uso único",
  createsANomenclatureBasedOnTheTransshipmentNumberAndTheQuantityOfLiftvans: "Cria uma nomenclatura baseada no número de transbordo e na quantidade de liftvans",
  result: "Resultado",
  results: "Resultados",
  youCanOnlyUseOneStorageBoxSingleUsePerOrder: "Você pode usar apenas uma caixa de armazenamento de uso único por pedido",
  youCanOnlyUseStorageBoxSingleUseForJustOneOrder: "Você pode usar caixa de armazenamento de uso único apenas para um pedido.",
  completed: "Concluído",
  initialRequest: "Solicitação inicial",
  noStepsInformed: "Sem etapas informadas",
  noTrackingAvailable: "Nenhum rastreamento disponível",
  dateNotInformed: "Data não informada",
  invoiceTotal: "Total da Fatura",
  receivedDate: "Data de recebimento",
  error: "Erro",
  waitingUpdate: "Aguardando atualização",
  shipeeziDefault: "Padrão do Shipeezi",
  theFileToUploadMustBeInCSVFormat: "O arquivo a ser enviado deve estar no formato .csv",
  pleaseFillInTheRequiredFieldsBeforeSaving: "Por favor, preencha os campos obrigatórios antes de salvar.",
  changeAssignee: "Alterar responsável",
  selectAPerson: "Selecionar uma pessoa",
  theAssignedPersonHasBeenChangedSuccessfully: "A pessoa atribuída foi alterada com sucesso",
  shipmentsPerDate: "Envios por data",
  for: "para",
  chapter: "Capítulo",
  heading: "Título",
  subHeading: "Subtítulo",
  statisticalClassification: "Classificação estatística",
  applicableTo: "Aplicável a",
  inactivatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeInactivatedAsWell: "Ao inativar uma seção, capítulo ou título, todos os códigos HS/mercadoria relacionados também serão inativados",
  doYouWantToInactivateAllOfThemAsWell: "Deseja inativar todos eles também?",
  activatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeActivatedAsWell: "Ao ativar uma seção, capítulo ou título, todos os códigos HS/mercadoria relacionados também serão ativados",
  doYouWantToActivateAllOfThemAsWell: "Deseja ativar todos eles também?",
  inactivateCode: "Inativar código",
  activateCode: "Ativar código",
  typeInTheFirst6Digits: "Digite os primeiros 6 dígitos",
  typeInTheLast2To4Digits: "Digite os últimos 2 a 4 dígitos",
  typeInTheCommodityCodeDescription: "Digite a descrição do código da mercadoria",
  typeInCountryOrRegion: "Digite o país ou região",
  commodityCode: "Código da mercadoria",
  doYouReallyWantToDeleteThisCommodityCode: "Realmente deseja excluir este código de mercadoria?",
  deleteCommodityCode: "Excluir código de mercadoria",
  clone: "Clonar",
  adjustTheDataAsDesiredToCreateTheNewCode: "Ajuste os dados como desejar para criar o novo código.",
  insertAValidCode: "*Insira um código válido",
  youMustFillInTheFieldsInRed: "Você deve preencher os campos em vermelho",
  importCSV: "Importar CSV",
  importCSVFile: "Importar arquivo CSV",
  weHaveFoundSomeErrors: "encontramos alguns erros",
  regions: "Regiões",
  defineWheterTheStorageBoxTypeCanApperInAllWarehouses: "Defina se o tipo de caixa de armazenamento pode aparecer em todos os armazéns",
  defineIfTheStorageBoxTypeCanBeUsedInTransitInsideTheWarehouseOrBoth: "Defina se o tipo de caixa pode ser usado em trânsito, dentro do armazém ou ambos",
  pleaseSelectAtLeastOne: "Por favor, selecione pelo menos um",
  originAirport: "Aeroporto de origem",
  finalDestinationAirport: "Aeroporto de destino final",
  plannedETD: "ETD planejado",
  departureFrom: "Saída de",
  departedFrom: "Saiu de",
  theAirplanePositionIsUpdatedFrom15To15Minutes: "A posição do avião é atualizada a cada 15 minutos.",
  inviteCustomer: "Convidar cliente",
  inviteCustomers: "Convidar clientes",
  supplyChain: "Cadeia de suprimentos",
  allSelectedCustomersMustHaveNameEmailAndNotYetBelongToShipeezi: "Todos os clientes selecionados devem ter nome, e-mail e ainda não pertencer ao Shipeezi",
  theBranch: "A filial",
  warehouseNotFound: "Armazém não encontrado",
  isNotRelatedToInformedWarehouse: "não está relacionado ao armazém informado",
  writeACommentInSKU: "Escrever um comentário no SKU",
  loadMore: "Carregar mais",
  commentHistory: "Histórico de comentários",
  readMore: "Ler mais",
  return: "Devolução",
  toAdd: "para adicionar",
  shiftReturn: "Shift + Enter",
  toBreakLine: "para quebrar linha",
  now: "Agora",
  inMoment: "Em um momento",
  justNow: "Agora mesmo",
  in: "in",
  years: "anos",
  yearAgo: "ano atrás",
  yearsAgo: "anos atrás",
  months: "meses",
  monthAgo: "mês atrás",
  monthsAgo: "meses atrás",
  weeks: "semanas",
  weekAgo: "semana atrás",
  weeksAgo: "semanas atrás",
  tomorrow: "Amanhã",
  yesterday: "Ontem",
  daysAgo: "dias atrás",
  hour: "hora",
  hours: "horas",
  hourAgo: "hora atrás",
  hoursAgo: "horas atrás",
  minute: "minuto",
  minutes: "minutos",
  minuteAgo: "minuto atrás",
  minutesAgo: "minutos atrás",
  pleaseTypeLessThanCharacters: "Por favor, digite menos de {{maxLength}} caracteres",
  emailConfiguration: "Configuração de e-mail",
  selectAll: "Selecionar Todos",
  "common.clearAll": "Limpar tudo",
  youCantRemoveColumsTheMinimumIs: "Você não pode remover colunas. O mínimo é",
  allTime: "Todo o tempo",
  lastWeek: "Semana Passada",
  allTypes: "Todos os tipos",
  editions: "Edições",
  loads: "Cargas",
  unloads: "Descargas",
  member: "Membro",
  spouse: "Cônjuge",
  whoDoesThisItemBelongTo: "A quem pertence este item?",
  searchOrAddAnItem: "Pesquisar ou adicionar um item",
  writeYourMessageHere: "Escreva sua mensagem aqui",
  message: "Mensagem",
  youAreNotifying: "Você está notificando",
  perDestination: "Por destino",
  asQuoted: "Conforme cotado",
  noItemsHaveBeenRegisteredYet: "Ainda não foram registrados itens",
  onceItemsAreAddedToInventoryYouWillBeAbleToSeeTheirDetails: "Quando itens forem adicionados ao inventário, você poderá ver seus detalhes",
  goodMorning: "Bom dia",
  goodAfternoon: "Boa tarde",
  goodNight: "Boa noite",
  youDontHaveAnyMovesWithUsYet: "Você ainda não tem mudanças conosco.",
  youHaveNotYetRequestedAQuoteFromUs: "Você ainda não solicitou uma cotação.",
  itSeemsLikeEverythingIsFineAroudHere: "Parece que tudo está bem por aqui",
  weAreHereToHelpYourMoveToBeAsSmoothlyAsPossible: "Estamos aqui para ajudar sua mudança a ser o mais tranquila possível",
  weAreHereToHelpYourQuoteToBeAsSmoothlyAsPossible: "Estamos aqui para ajudar sua cotação a ser o mais tranquila possível",
  yourMoves: "Suas mudanças",
  yourQuotes: "Suas cotações",
  scheduled: "Agendado",
  needsYourAttention: "Precisa da sua atenção",
  yourScheduleIsSqueakyCleanNoUpcomingAppointmentsToWorryAbout: "Sua agenda está completamente livre. Não há compromissos futuros com os quais se preocupar.",
  ifWeNeedYouForAnythingHereItIsThePlaceToTakeAction: "Se precisarmos de você para algo, aqui é o lugar para tomar ação.",
  actualMilestone: "Marco real",
  trackingAvailable: "Rastreamento disponível",
  howAboutHavingACoffe: "Que tal tomar um café?",
  everythingIsUpToDate: "Tudo está atualizado",
  youWillSeeAllTheCommunicationBetweenYourselfAndUsHere: "Você verá toda a comunicação entre você e nós aqui.",
  transshipped: "Transbordado",
  weDidNotFindAnyMovesRelatedTo: "Não encontramos nenhuma mudança relacionada a",
  noResultsFound: "Nenhum resultado encontrado",
  nothingScheduledForNow: "Nada agendado por enquanto",
  timeline: "Linha do tempo",
  home: "Início",
  checkAllMilestones: "Verificar todos os marcos",
  yourMoveProgress: "Progresso da sua mudança",
  showMore: "Mostrar mais",
  transport: "Transporte",
  originContacts: "Contatos de origem",
  destinationContacts: "Contatos de destino",
  checkMyInventories: "Verificar meus inventários",
  messageSentThankYouForContactingUsWellGetBackToYouSoon: "Mensagem enviada! Obrigado por entrar em contato. Retornaremos em breve.",
  contactHistory: "Histórico de contatos",
  youContacted: "Você contatou",
  yourMoveDocumentStatus: "Status dos documentos da sua mudança",
  pleaseFillInEitherTheMobileNumberOrPhoneNumberField: "Por favor, preencha o campo de número celular ou número de telefone",
  pleaseFillAtLeastOne: "Por favor, preencha pelo menos um",
  allItemsPacked: "Todos os itens embalados",
  allYourItemsHaveBeenPackedAndEverythingIsFine: "Todos os seus itens foram embalados e tudo está bem.",
  couldNotFoundWithUsernamePassword: "Não encontramos uma conta com essas credenciais. Por razões de segurança,",
  members: "Membros",
  teams: "Equipes",
  newTeam: "Nova equipe",
  equipments: "Equipamentos",
  leaderUser: "Líder (Usuário)",
  inviteMember: "Convidar membro",
  newMember: "Novo membro",
  chooseTheTypeOfMember: "Escolher o tipo de membro",
  theMemberCanHaveAccessToSystemOrNot: "O membro pode ou não ter acesso ao sistema",
  personalDetails: "Dados pessoais",
  generalInformationAboutTheMember: "Informações gerais sobre o membro",
  howThePersonAccessesAndInteractsWithTheSystem: "Como a pessoa acessa e interage com o sistema",
  additional: "Adicional",
  hasAccessToShipeeziSystemWithALoginAndPassword: "Tem acesso ao sistema Shipeezi com login e senha",
  thisMemberBelongsToASubcontractor: "Este membro pertence a um subcontratado",
  subcontractor: "Subcontratado",
  nickname: "Apelido",
  startEmploymentDate: "Data de início do emprego",
  endEmploymentDate: "Data de término do emprego",
  citizenship: "Cidadania",
  license: "Licença",
  jobTitle: "Título do cargo",
  editPhoto: "Editar foto",
  specificDetailsAboutTheStaffPerson: "Detalhes específicos sobre o membro da equipe",
  staffInformation: "Informações da equipe",
  typerOfUser: "Tipo de usuário",
  notApproved: "Não aprovado",
  review: "Revisão",
  expiry: "Vencimento",
  certification: "Certificação",
  certifications: "Certificações",
  newCertification: "Nova certificação",
  uploadANewFile: "Enviar um novo arquivo",
  confirmThisCertificationIsValidated: "Confirmar que esta certificação está validada",
  expire: "Vencimento",
  preferNotToSay: "Prefiro não dizer",
  nonBinary: "Não-binário",
  searchForCitizenship: "Pesquisar cidadania",
  serchForCountry: "Pesquisar país",
  thisUserIsAlsoALeader: "Este usuário também é um líder",
  pleaseCompleteAllRequiredFields: "Por favor, preencha todos os campos obrigatórios",
  createMember: "Criar membro",
  associatedWithThisMemberWhenYouAddThem: "associado a este membro quando você os adicionar",
  associatedWithThisEquipmentWhenTheyAreAdded: "associado a este equipamento quando forem adicionados",
  newAbsence: "Nova ausência",
  absences: "Ausência",
  absence: "Ausência",
  allDayAbsence: "Ausência de dia inteiro",
  availability: "Disponibilidade",
  convertStaffIntoUser: "Converter equipe em usuário",
  convertUserIntoStaff: "Converter usuário em equipe",
  configureAsSubcontractor: "Configurar como subcontratado",
  doYouWantToConvertThisUserIntoStaff: "Deseja converter este usuário em equipe?",
  doYouWantToConvertThisStaffIntoUser: "Deseja converter esta equipe em usuário?",
  youWillNeedToFillInTheMissigInformation: "Você precisará preencher as informações faltantes",
  thisMemberIsA: "Este membro é um",
  andIsDefinedAsA: "e está definido como",
  subconttractorFor: "subcontratado para",
  own: "Próprio",
  convertInto: "Converter em",
  subcontractorFor: "subcontratado para",
  timesheet: "Registro de horas",
  timesheets: "Registros de horas",
  typeOfMember: "Tipo de membro",
  ifTheTeamAlreadyHasALeaderTheMemberWillBeAddedAsStaff: "Se a equipe já tiver um líder, o membro será adicionado como equipe",
  emergencyEmail: "E-mail de emergência",
  newTime: "Novo horário",
  editTeam: "Editar equipe",
  addMember: "Adicionar membro",
  addTeam: "Adicionar equipe",
  nameL: "Nome",
  equipmentPhoto: "Foto do equipamento",
  maxSize2mb: "Tamanho máximo 2 MB",
  formatsJpgGifPng: "Formatos: JPG, GIF, PNG",
  equipmentIcon: "Ícone do equipamento",
  rental: "Aluguel",
  leased: "Arrendado",
  noMembersAssociatedToThisEquipment: "Nenhum membro associado a este equipamento",
  youCanStartByAddingAMember: "Você pode começar adicionando um membro",
  newUnavailabilityTime: "Novo horário de indisponibilidade",
  allDayUnavailable: "Indisponível o dia todo",
  rolesecurity: "Cargo (segurança)",
  loaction: "Localização",
  addMembers: "Adicionar membros",
  youwillbeabletoseealltheinformationabouttheavailabilityofthismemberwhenyouaddthem: "Você poderá ver todas as informações sobre a disponibilidade deste membro quando os adicionar",
  addUnavailability: "  Adicionar indisponibilidade",
  addTeams: "Adicionar equipes",
  enableThisFleetAsAStrorageBox: "Habilitar esta frota como caixa de armazenamento",
  dates: "Datas",
  selectAnOptionToSeeTheForm: "Selecione uma opção para ver o formulário",
  typeInToSearchAMebmer: "Digite para pesquisar um membro",
  pantech: "Pantech",
  nickName: "Apelido",
  EuroNorm: "EUROnorm",
  driverLicense: "Carteira de motorista",
  manufacturer: "Fabricante",
  branch1: "Filial 1",
  warehouse1: "Armazém 1",
  enableThisFleetAsAStorageBox: "Habilitar esta frota como caixa de armazenamento",
  writeADescription: "Escreva uma descrição",
  chooseAvehicleTypeOfEquipmentLikeAForkliftOrATruck: "Escolha um tipo de equipamento veicular, como uma empilhadeira ou um caminhão",
  chooseAVehicleTypeOfEquipmentLikeAForkliftOrATruck: "Escolha um tipo de equipamento veicular, como uma empilhadeira ou um caminhão",
  createMoreGeneralizedEquipmentWithAFewDetails: "Criar equipamento mais generalizado com poucos detalhes",
  whoOwnsThisEquipment: "Quem é o proprietário deste equipamento?",
  businessphone: "Telefone empresarial",
  vatcode: "Código IVA",
  iban: "IBAN",
  bic: "BIC",
  usesameasgeneraladdress: "Usar o mesmo endereço geral",
  addaequipment: "Adicionar um equipamento",
  quickcreationequipment: "Criação rápida de equipamento",
  addequipment: "Adicionar equipamento",
  addAMember: "Adicionar um membro",
  addATeam: "Adicionar uma equipe",
  createnew: "Criar novo",
  businessdetails: "Dados empresariais",
  businessinformationaboutthesubcontractor: "Informações empresariais sobre o subcontratado",
  generalinformationabouttheowner: "Informações gerais sobre o proprietário",
  bankingdetails: "Dados bancários",
  nomembersassociatedtothisequipment: "Nenhum membro associado a este equipamento",
  youcanstartbyaddingamember: "Você pode começar adicionando um membro",
  createnewmember: "Criar novo membro",
  addanexistentmember: "Adicionar membro existente",
  quickcreation: "Criação rápida",
  equipment: "Equipamento",
  quicklycreateanewequipmentwithessentialdetailsaddmoreinformationanytimeinsettings: "Crie rapidamente um novo equipamento com detalhes essenciais. Adicione mais informações a qualquer momento nas configurações",
  createmoregeneralizedequipmentwithafewdetails: "Criar equipamento mais generalizado com poucos detalhes",
  personaldetails: "Dados pessoais",
  platenumber: "Número da placa",
  subcontractors: "Subcontratados",
  newSubcontractor: "Novo subcontratado",
  qtyMembers: "Qtd. membros",
  qtyEquipments: "Qtd. equipamentos",
  businessDetails: "Dados empresariais",
  businessInformationAboutTheSubcontractor: "Informações empresariais sobre o subcontratado",
  businessPhone: "Telefone empresarial",
  generalInformationAboutTheOwner: "Informações gerais sobre o proprietário",
  addNumberHere: "Adicione número aqui",
  bankingDetails: "Dados bancários",
  vatCode: "Código IVA",
  useSameAsGeneralAddress: "Usar o mesmo endereço geral",
  contactEmail: "E-mail de Contato",
  noMembersAssociatedToThisSubcontractor: "Nenhum membro associado a este subcontratado",
  createNewMember: "Criar novo membro",
  addAnExistentMember: "Adicionar membro existente",
  noMembersToShow: "Nenhum membro para mostrar",
  noTeamsToShow: "Nenhuma equipe para mostrar",
  typeInToSearchAMember: "Digite para pesquisar um membro",
  addWorkTimeToMember: "Adicionar tempo de trabalho ao membro",
  howDoYouWantToAddAnewTime: "Como deseja adicionar um novo horário?",
  createMockTask: "Criar tarefa fictícia",
  createAMimicTaskToRecordHoursForThisMember: "Criar uma tarefa fictícia para registrar horas deste membro.",
  selectExistentTask: "Selecionar tarefa existente",
  selectAnExistingTaskInTHeOrderToLogWorkTime: "Selecionar uma tarefa existente no pedido para registrar tempo de trabalho",
  addTime: "Adicionar tempo",
  backFromBreak: "De volta do intervalo",
  itLooksLikeNoOrderWasSelectYet: "Parece que nenhum pedido foi selecionado ainda",
  startSearchingForAnOrderToBeAbleToCreateANewTask: "Comece pesquisando um pedido para criar uma nova tarefa",
  searchOrderBy: "Pesquisar pedido por",
  cancelAvailability: "Cancelar disponibilidade",
  doYouReallyWantToCancelThisAbsence: "Realmente deseja cancelar esta ausência para",
  yesCancel: "Sim, cancelar",
  thisActionCannotBeUndone: "Esta ação não pode ser desfeita.",
  viewTime: "Ver horário",
  editTime: "Editar horário",
  noLeaderAvailable: "Sem líder disponível",
  noStaffAvailable: "Sem equipe disponível",
  noTasks: "Sem tarefas",
  m3: "m³",
  unavailableUntil: "Indisponível até",
  lv: "LV",
  noEquipmentToShow: "Nenhum equipamento para mostrar",
  addEquipment: "Adicionar equipamento",
  addAnExistentEquipment: "Adicionar equipamento existente",
  addEquipments: "Adicionar equipamento",
  addAEquipment: "Adicionar um equipamento",
  newEquipment: "Novo equipamento",
  chooseTheTypeOfEquipment: "Escolher o tipo de equipamento",
  purchaseDate: "Data de compra",
  soldDate: "Data de venda",
  euronorm: "EUROnorm",
  lastInspectionDate: "Data da última inspeção",
  nextInspectionDate: "Data da próxima inspeção",
  pleaseSelectAnLaterDate: "Por favor, selecione uma data posterior",
  pleaseSelectAnEarlierDate: "Por favor, selecione uma data anterior",
  workedTime: "Tempo trabalhado",
  breaks: "Intervalos",
  waitingApproval: "Aguardando aprovação",
  noSubcontractorAvailable: "Sem subcontratado disponível",
  noLeaderAdded: "Sem líder adicionado",
  noStaffAdded: "Sem equipe adicionada",
  noEquipmentAdded: "Sem equipamento adicionado",
  noStorageBoxAdded: "Sem caixa de armazenamento adicionada",
  noOrders: "Sem pedidos adicionados",
  openOrder: "Abrir pedido",
  accessDetails: "Detalhes de acesso",
  membersAndTeams: "Membros e equipes",
  membersAndEquipments: "Membros e equipamentos",
  extraMembersAndTeams: "Membros e equipes extras",
  addTeamToBoard: "Adicionar equipe ao quadro",
  timeMustBeAfter: "A hora deve ser depois das",
  addALeader: "Adicionar um líder",
  addStaffs: "Adicionar equipe",
  addStorageBoxes: "Adicionar caixas de armazenamento",
  timeClock: "Relógio de ponto",
  removeTaskFromTeam: "Remover tarefa da equipe",
  youCannotPublishATaskWithoutALeader: "Não é possível publicar uma tarefa sem um líder",
  thisChangeWillBeProcessedShortly: "Esta alteração será processada em breve",
  noLanguageAvailable: "Sem idioma disponível",
  noJobTitleAvailable: "Sem título de cargo disponível",
  equipmentDetails: "Detalhes do equipamento",
  removeThisTeamFromTheBoard: "Remover esta equipe do quadro",
  areYouSureyouWantToCancelTheTask: "Tem certeza que deseja cancelar a tarefa?",
  forOrder: "Para o pedido",
  createCrew: "Criar tripulação",
  noTeamsAddedYet: "Nenhuma equipe adicionada ainda",
  allCaughtUpWhatAboutACoffee: "Tudo em dia! Que tal um café?",
  weAreDoingOneLastSearchWhatAboutACoffee: "Estamos fazendo uma última pesquisa... Que tal um café?",
  viewOptions: "Ver opções",
  showItemsUnavailable: "Mostrar itens indisponíveis",
  showEmptyOrdersTasks: "Mostrar pedidos/tarefas vazios",
  showEmptyTeams: "Mostrar equipes vazias",
  collapseOrdersTasks: "Recolher pedidos/tarefas",
  collapseTeams: "Recolher equipes",
  expandOrdersTasks: "Expandir pedidos/tarefas",
  expandTeams: "Expandir equipes",
  organization: "Organização",
  organiseByTask: "Organizar por tarefa",
  organiseByOrder: "Organizar por pedido",
  organiseByTeam: "Organizar por equipe",
  youCannotPublishThisTask: "Não é possível publicar esta tarefa",
  typeHereAndPressEnter: "Digite aqui e pressione Enter",
  noMemberFound: "Nenhum membro encontrado",
  noTeamFound: "Nenhuma equipe encontrada",
  noOrderFound: "Nenhum pedido encontrado",
  noInformationToShow: "Sem informação para mostrar",
  noEquipmentFound: "Nenhum equipamento encontrado",
  noStorageBoxFound: "Nenhuma caixa de armazenamento encontrada",
  pressToSearch: "Pressione para pesquisar",
  noOrderAvailable: "Nenhum pedido disponível",
  youHaveToUnpublishFirst: "Você deve cancelar a publicação primeiro",
  thisTaskAlreadyStartedByTheLeader: "Esta tarefa já foi iniciada pelo líder",
  thisTaskAlreadyFinished: "Esta tarefa já está finalizada",
  thisTaskAlreadyCancelled: "Esta tarefa já foi cancelada",
  youHaveToAddATaskBeforeCreateASingleUse: "Você deve adicionar uma tarefa antes de criar um uso único",
  youCannotAddASingleUseForDifferentOrders: "Não é possível adicionar um uso único para pedidos diferentes",
  createAStorageBoxSingleUse: "Criar uma caixa de armazenamento de uso único",
  thisTaskCannotBeCancelled: "Esta tarefa não pode ser cancelada",
  thereIsNoNeed: "Não há necessidade",
  vipMode: "Modo VIP",
  bluebarkMove: "Mudança Bluebark",
  satefyMove: "Mudança de segurança",
  dispatch: "Despacho",
  youHaveUnpublishedTasks: "Você tem tarefas não publicadas!",
  thisTeamHasTasksAlreadyPublishedForThisLeader: "Esta equipe tem tarefas já publicadas para este líder",
  anOperationalMemberUsedJustForRegisterPurposes: "Um membro operacional, usado apenas para fins de registro",
  boardDisplay: "Visualização do quadro",
  createATemporaryTeamoForTodaysTasks: "Criar uma equipe temporária para as tarefas de hoje",
  registredAddress: "Endereço registrado",
  noResultMatchYourSearch: "Nenhum resultado corresponde à sua pesquisa",
  searchAndSelectOrder: "Pesquisar e selecionar pedido",
  itLooksLikeNoOrderWasSelectedYet: "Parece que nenhum pedido foi selecionado ainda",
  startSearchingForAnOrderYoBeAbleToCreateANewTask: "Comece pesquisando um pedido para criar uma nova tarefa",
  newTaskFor: "Nova tarefa para",
  timeFor: "Horário para",
  notifyTheClientAboutTheStartOfTheTask30MinutesInAdvance: "Notificar o cliente sobre o início da tarefa com 30 minutos de antecedência",
  breakFromBreak: "De volta do intervalo",
  albertFloresMarvinMcKinneyJeromeBell: " Albert Flores, Marvin McKinney, Jerome Bell",
  extraMembers: "Membros e equipes extras",
  devonLane: "Devon Lane",
  readLess: "Ler menos",
  writeACommentIn: "Escrever um comentário em",
  shift: "turno",
  teamRemovalIsBlockedDueToThePresenceOfTasks: "A remoção da equipe está bloqueada pela presença de tarefas.",
  vipTreatment: "Tratamento VIP",
  personalAddress: "Endereço pessoal",
  pleaseSelectAStartDate: "Por favor, selecione uma data de início",
  morning: "Manhã",
  afternoon: "Tarde",
  evening: "Entardecer",
  night: "Noite",
  registeredAddress: "Endereço registrado",
  noTaskYest: "Sem tarefas ainda",
  writeAComment: "Escrever um comentário",
  allowBookingSearch: "Permitir pesquisa de reservas",
  securityLoginAttempts: "Por razões de segurança, após <strong>{{numberOfAttempts}} tentativas falhas</strong>",
  weakPassword: "Senha fraca",
  avaragePassword: "Senha regular",
  goodPassword: "Boa senha",
  strongPassword: "Senha forte",
  passwordMustHave: "Sua senha deve ter:",
  UpperAndLowercaseLetters: "Letras maiúsculas e minúsculas",
  aSpecialCharacter: "Um caractere especial (#$&@)",
  atLeastOneNumber: "Pelo menos um número",
  minLength: "12 ou mais caracteres",
  pleaseEnterANewPassword: "Por favor, insira uma nova senha",
  pleaseConfirmPassword: "Por favor, confirme a senha",
  autoTerminateSessionExpire: "Por razões de segurança, sua sessão expira após 8 horas de",
  yourSessionIsAboutToExpire: "Sua sessão está prestes a expirar",
  terminatedSession: "Esta sessão foi encerrada.",
  reEnterCreds: "Por favor <strong>insira novamente</strong> suas credenciais.",
  weWillSendALinkToResetYourPasswordToTheEmailAddressAssociatedWithYourAccount: "Enviaremos um link para redefinir sua senha para o endereço de e-mail associado à sua conta",
  sortReportBy: "Ordenar relatório por",
  sortedByInventory: "Ordenado por inventário",
  sortedAndGroupedByStorageBox: "Ordenado e agrupado por caixa de armazenamento",
  loadOrder: "Carregar pedido",
  areYouSureYouWantToLoadThisOrder: "Tem certeza que deseja carregar este pedido?",
  changeOrderStatusModalDescription: "O novo status do pedido será '{{status}}'.",
  noKeepItAsItIs: "Não, manter como está",
  noKeepItAsStatus: "Não, manter como {{status}}",
  yesLoad: "Sim, carregar",
  yesDeliver: "Sim, entregar",
  noPhotosHaveBeenAddedYet: "Nenhuma foto foi adicionada ainda",
  transportationType: "Tipo de transporte",
  assistance: "Assistência",
  doorToDoor: "Porta a porta",
  doorToPort: "Porta ao porto",
  doorToWarehouse: "Porta ao armazém",
  fotWarehouse: "FOT Armazém",
  portToDoor: "Porto à porta",
  portToPort: "Porto a porto",
  portToWarehouse: "Porto ao armazém",
  warehouseToDoor: "Armazém à porta",
  warehouseToPort: "Armazém ao porto",
  warehouseToWarehouse: "Armazém a armazém",
  accountType: "Tipo de conta",
  accountContact: "Contato da conta",
  bookingAgent: "Agente de reservas",
  personalPropertyProgram: "Programa de propriedade pessoal",
  searchForAnOption: "Pesquisar uma opção",
  memberWillChangeFromSubcontractorToOwnAfterSaving: 'O membro mudará de "subcontratado" para "próprio" após salvar',
  memberWillChangeFromOwnToSubcontractorAfterSaving: 'O membro mudará de "próprio" para "subcontratado" após salvar',
  memberWillChangeFromUserToStaffAfterSaving: 'O membro mudará de "usuário" para "funcionário" após salvar',
  memberWillChangeFromStaffToUserAfterSaving: 'O membro mudará de "funcionário" para "usuário" após salvar',
  noTaskYet: "Sem tarefa ainda",
  workHours: "Horas de trabalho",
  breakHours: "Horas de intervalo",
  mostCommonTask: "Tarefa mais comum",
  theCompanyDoesNotHaveARegisteredAddress: "A empresa não tem endereço registrado",
  noPhotoAdded: "Sem foto adicionada",
  exampleAyrton: "Exemplo: Ayrton",
  exampleSenna: "Exemplo: Senna",
  mailmailcom: "email@email.com",
  newUnavailability: "Nova indisponibilidade",
  editTask: "Editar Tarefa",
  notAllocated: "Não alocado",
  vipTasksWithAssign: "Tarefas VIP com atribuição",
  tasksWithNoAssign: "Tarefas sem atribuição",
  normalTasksWithAssign: "Tarefas normais com atribuição",
  noCrewAssigned: "Sem tripulação atribuída",
  certificationType: "Tipo de certificação",
  defineWheterTheStorageBoxTypeRequiresPhotosSealNumberOrBoth: "Defina se o tipo de caixa requer fotos, número de lacre ou ambos",
  checklist: "Lista de verificação",
  sealsNumber: "Número de lacres",
  ifNoRuleIsAddedToAnOrderTypeTheRequiredSealNumberWillBeEqualTo1: "Se nenhuma regra for adicionada a um tipo de pedido, o número de lacres requerido será igual a 1",
  checklistRules: "Regras da lista de verificação",
  itLooksLikeThereIsNoRulesAdded: "Parece que não há regras adicionadas",
  youCanStartByAddingANewRuleByClickingTheButtonBellow: "Você pode começar adicionando uma nova regra clicando no botão abaixo",
  addARule: "Adicionar uma regra",
  sealNumbersNeeded: "Números de lacres necessários",
  numberOfSealsRequired: "Número de lacres necessários",
  whenOrderTypeIs: "Quando o tipo de pedido é",
  addAnotherRule: "Adicionar outra regra",
  sealsValueMustBeGreaterThan0: "O valor de lacres deve ser maior que 0",
  pleaseFillInTheCustomerInformationFirst: "Por favor, preencha as informações do cliente primeiro.",
  isAllocated: "Está alocado",
  clearSelection: "Limpar seleção",
  typeIn: "Digite",
  newPlaceholderTask: "Nova tarefa marcador",
  taskName: "Nome da tarefa",
  typeHereAComment: "Digite aqui um comentário",
  deleteTask: "Excluir tarefa",
  yesDelete: "Sim, excluir",
  areYouSureyouWantToDeleteTheTask: "Tem certeza que deseja excluir a tarefa?",
  placeholder: "Marcador",
  taskDescription: "Descrição da tarefa",
  describeTaskHere: "Descreva a tarefa aqui",
  sealNumbers: "Números de lacres",
  sealNumber: "Número do Lacre",
  photosOfSpecialItemsInside: "Fotos de itens especiais dentro",
  photosOfCaulked: "Fotos de calafetagem",
  photosOfPackedAndSealed: "Fotos de embalado e lacrado",
  itLooksLikeThereIsNoPhotosYet: "Parece que ainda não há fotos",
  youCanStartByAddingANewPhotoOnTheButtonBelow: "Você pode começar adicionando uma nova foto no botão abaixo",
  addAnotherPhoto: "Adicionar outra foto",
  checklistDone: "Lista de verificação concluída",
  noTaskAdded: "Sem tarefa adicionada",
  createAnInternalTaskOrARegisterForADraftTask: "Criar uma tarefa interna ou um registro para uma tarefa rascunho",
  selectAReport: "Selecionar um relatório",
  crew_schedule_report: "Relatório de programação da tripulação",
  warehouse_schedule_report: "Relatório de programação do armazém",
  atLeastOneBranchMustBeSelected: "Pelo menos uma filial deve ser selecionada",
  reportTypeIsRequired: "O tipo de relatório é obrigatório",
  noReportGenerated: "Nenhum relatório gerado",
  reportGeneratedSuccessfully: "relatório gerado com sucesso",
  reportsGeneratedSuccessfully: "relatórios gerados com sucesso",
  youMustSelectAtLeast1BranchToPrint: "Você deve selecionar pelo menos 1 filial para imprimir",
  leaderName: "Nome do líder",
  memberName: "Nome do membro",
  equipmentName: "Nome do equipamento",
  multiDay: "Vários dias",
  theTaskIsFinishedSoItCannotBeRemoved: "A tarefa está finalizada, portanto não pode ser removida.",
  showSupplierNameOnTheSSCCLabel: "Mostrar nome do fornecedor na etiqueta SSCC",
  dateFor: "Data para",
  isThisAMultiDayTask: "Esta é uma tarefa de vários dias?",
  endDateCantBeBeforeStartDate: "A data de fim não pode ser anterior à data de início",
  quickSearch: "Pesquisa rápida",
  newSubscriber: "Novo assinante",
  searchForAnUserByTyping: "Pesquisar um usuário digitando",
  enterContactType: "Inserir tipo de contato",
  unselectAll: "Desmarcar todos",
  thereAreNoOrderBelongingToTheSelectedBranchesFor: "Não há pedidos pertencentes à(s) filial(is) selecionada(s) para",
  thereAreNoOrderBelongingToTheSelectedBranchesForToday: "Não há pedidos pertencentes à(s) filial(is) selecionada(s) para hoje",
  multi_day: "Vários dias",
  fullDay: "Dia inteiro",
  between: "entre",
  unavailableOn: "Indisponível em",
  h: "h",
  m: "m",
  withPhotos: "Com fotos",
  withoutPhotos: "Sem fotos",
  manageEmailSubscriptions: "Gerenciar assinaturas de e-mail",
  reportName: "Nome do relatório",
  subscribers: "Assinantes",
  editActivities: "Editar atividades",
  emailActivities: "Atividades de e-mail",
  activities: "Atividades",
  timestamp: "marca de tempo",
  changes: "Alterações",
  modifiedBy: "Modificado por",
  selectedFilters: "Filtros selecionados",
  deactivate: "Desativar",
  areYouSureYouWantToDeactivateThisReportEmailSubscription: "Tem certeza que deseja desativar esta assinatura de relatório por e-mail?",
  youWillNoLongerReceiveEmailsForTheSelectedReport: "Você não receberá mais e-mails para o relatório selecionado.",
  deactivateEmailScheduleForThisReport: "Desativar agendamento de e-mail para este relatório?",
  yesDeactivate: "Sim, desativar",
  cancelGoBack: "Cancelar e voltar",
  noEmailSubscriptionsRegistered: "Sem assinaturas de e-mail registradas",
  addAdminUser: "Adicionar usuário administrador",
  oneTime: "Uma vez",
  emailFrequency: "Frequência do e-mail",
  noOfTasks: "N.º de tarefas",
  orderCreated: "Pedido criado",
  totalOrders: "Total de pedidos",
  ordersCompleted: "Pedidos concluídos",
  totalTasks: "Total de tarefas",
  tasksCompleted: "Tarefas Concluídas",
  exportingCSV: "Exportando CSV",
  taskBooked: "Tarefa reservada",
  hideTasks: "Ocultar tarefas",
  showTasks: "Mostrar tarefas",
  lifetime: "Vida útil",
  reportLifetimeData: "Dados de vida útil do relatório",
  originBranch: "Filial de origem",
  destinationBranch: "Filial de destino",
  teamBranches: "Filiais da equipe",
  receiveOnlyOnce: "Receber apenas uma vez",
  receiveEveryWeek: "Receber toda semana",
  receiveOnceAMonth: "Receber uma vez por mês",
  sendOn: "Enviar em",
  sendEvery: "Enviar a cada...",
  onceYouClickOn: "Uma vez que você clicar em",
  youWillReceiveThisReportWithAllTheSelectedFiltersAndSetFrequency: "você receberá este relatório com todos os filtros selecionados e a frequência definida",
  emailDeliveryMayBeDelayedDueFactorsBeyondOurControl: "A entrega do e-mail pode ser atrasada por fatores fora do nosso controle.",
  pleaseWhitelistToAvoidEmailsGoingToSpam: "Por favor, adicione shipeezi.com à lista de permissões para evitar que os e-mails vão para spam.",
  subscriberMustBeRegisteredOnShipeezi: "O assinante deve estar registrado no Shipeezi",
  enterADayOfTheMonthBetween1and28: "Insira um dia do mês entre 1 e 28",
  selectReportType: "Selecionar tipo de relatório",
  allReports: "Todos os relatórios",
  selectTaskReportType: "Selecionar tipo de relatório de tarefa",
  generateAndDownload: "Gerar e baixar",
  workOrder: "Ordem de trabalho",
  applicableOnlyOnInventoryConditionReport: "Aplicável apenas no relatório de condição de inventário",
  applicableOnlyOnLoadAndTransshipmentReport: "Aplicável apenas no relatório de carga e transbordo",
  applicableOnInventoryConditionReportMechanicalAndEletricalChecklistHightValuePropertyDemange: "Aplicável no relatório de condição de inventário, lista de verificação mecânica e elétrica, propriedade de alto valor",
  listOfReports: "Lista de relatórios",
  allAvailableReportsForThisOrderWillBeGeneratedInOneBatchWhichMayTakeLongerThanUsual: "Todos os relatórios disponíveis para este pedido serão gerados em um lote, o que pode demorar mais que o usual",
  pleaseNoteThatGrayedOutReportsAreCurrentlyUnavailbaleForThisOrder: "Note que os relatórios em cinza não estão disponíveis para este pedido",
  youCanChooseTheSpecificReportsYouNeedAndEachSelectedReportWillBeGeneratedAsAnIndividualFileWhichMayTakeLongerThanUsual: "Você pode escolher os relatórios específicos que precisa e cada relatório selecionado será gerado como um arquivo individual",
  security: "Segurança",
  enableTwoFactorAuthenticationToLogin: "Habilitar autenticação de dois fatores para login",
  enableAnExternalMethodToAuthenticateLogin: "Habilitar um método externo para autenticar o login.",
  limitUnsuccessfulLogonAttempts: "Limitar tentativas de login sem sucesso",
  anThe4thFailedAttemptTheAccountWillBeLockedFor30Seconds: "Na 4.ª tentativa falha, a conta será bloqueada por 30 segundos",
  onThe5thFailedAttemptTheAccountWillBeLockedFor60Seconds: "Na 5.ª tentativa falha, a conta será bloqueada por 60 segundos",
  anyFailedAttemptsAfterThe5thTheAccountWillBeLockedFor120Seconds: "Qualquer tentativa malsucedida após a 5ª, a conta será bloqueada por 120 segundos.",
  onThe6thFailedAttemptTheAccountWillBeLockedFor120Seconds: "Na 6ª tentativa malsucedida, a conta será bloqueada por 120 segundos;",
  anyFailedAttemptsAfterThe6thTheAccountWillBeLockedFor120Seconds: "Qualquer tentativa malsucedida após a 6ª, a conta será bloqueada por 120 segundos.",
  autoTerminateSessionsAfter8HoursFromLogin: "Encerrar sessões automaticamente 8 horas após o login",
  thePlatformCalculates8HoursFromTheMostRecentLoginAndTerminatesTheSessionRequiringTheUserToLogInAgain: "A plataforma calcula 8 horas a partir do login mais recente e encerra a sessão, exigindo que o usuário faça login novamente.",
  aWarningAppears15MinutesBeforeTheSessionTeminates: "Um aviso aparece 15 minutos antes do encerramento da sessão.",
  minimumPasswordComplexityPolicy: "Política de complexidade mínima de senha",
  passwordsMustFulfilMinimumRequirementsForAComplexPasswordWhenCreatingOrResettingAPassword: "As senhas devem atender aos requisitos mínimos de uma senha complexa ao criar ou redefinir uma senha.",
  prohibitPasswordReuse: "Proibir reutilização de senha",
  prohibitUsersFromReusingAPreviousPasswordWhenCreatingOrResettingAPassword: "Proibir usuários de reutilizar uma senha anterior ao criar ou redefinir uma senha.",
  automatedPasswordResetPolicy: "Política de redefinição automática de senha",
  passwordsMustBeChangedEvery90Days: "As senhas devem ser alteradas a cada 90 dias.",
  operationsApp: "App de Operações",
  inventoryNumberingIsTheStartingInventoryNumberEditable: "Numeração de inventário: O número inicial do inventário é editável?",
  enforceAppLockScreen: "Aplicar tela de bloqueio do app",
  usingTheAppForMilitaryPurpose: "Usando o app para fins militares?",
  ifAUserIsInactiveForASetPeriodTheAppLocksAutomaticallyForSecurityUsersChooseAPinAtFirstLoginAndCanResetItUsingTheirUsernameAndPasswordThisPreventsUnauthorizedAccessToSensitiveData: "Se um usuário ficar inativo por um período definido, o app bloqueia automaticamente por segurança. Os usuários escolhem um PIN no primeiro login e podem redefini-lo usando seu nome de usuário e senha. Isso evita o acesso não autorizado a dados sensíveis.",
  enterInactivityTime: "Inserir tempo de inatividade",
  fieldRelatedSettings: "Configurações relacionadas ao campo",
  loadIntoStorageBoxIsMandatoryInUpliftTask: "Carregar em Caixa de Armazenamento é obrigatório na Tarefa de Coleta",
  systemConfigurationIsNotAvailablePleaseContactTheAdministratorForAssistance: "A configuração do sistema não está disponível. Entre em contato com o administrador para obter assistência.",
  updatedSuccessfully: "Atualizado com Sucesso",
  ifVolumeConfirmationIsMandatoryThenStorageBoxMandatoryOptionMustBeSetToFalse: "Se a Confirmação de Volume for obrigatória, a opção obrigatória de Caixa de Armazenamento deve ser definida como falso.",
  volumeConfirmation: "Confirmação de Volume",
  autofillBasedOnTheTask: "Preenchimento automático com base na tarefa",
  allowMultipleSelection: "Permitir seleção múltipla",
  inventoryFields: "Campos de inventário",
  expanseManagement: "Gerenciamento de Despesas",
  others: "Outros",
  cost: "Custo",
  onceDeletedThisEntryWillBePermanentlyRemoved: "Uma vez excluída, esta entrada será removida permanentemente.",
  loadingTaskInformation: "Carregando informações da tarefa...",
  taskNotFound: "Tarefa não encontrada",
  couldNotLoadRequestedTaskDetails: "Não foi possível carregar os detalhes da tarefa solicitada.",
  recalculateExpenses: "Recalcular Despesas",
  isTimeSlotRequiredForMultiDayTask: "É necessário horário para tarefa de vários dias?",
  fixedTimeSlot: "Horário fixo",
  variableTimeSlot: "Horário variável",
  addAnotherDate: "Adicionar outra data",
  itShouldBeAtLeastTwoDates: "Deve ter pelo menos duas datas.",
  endTimeMustBeGreaterThanStartTime: "O horário 'Até' deve ser maior que o horário 'De'.",
  generatingYourReportMightTakeLongerThanUsual: "A geração do seu relatório pode demorar mais do que o habitual.",
  weWillNotifyYouAsSoonAsItsReadyForDownload: "Nós o notificaremos assim que estiver pronto para download. Você pode fechar esta janela com segurança enquanto isso.",
  categorizeItemsInOperationsApp: "Categorizar itens no app de operações",
  checkedFieldsWillBeMarkedAsAMandatory: "Os campos marcados serão definidos como obrigatórios.",
  selectCategories: "Selecionar categorias",
  mandatoryFields: "Campos Obrigatórios",
  mandatoryFieldsByCategory: "Campos obrigatórios por categoria",
  noAccess: "Sem acesso",
  fullAccess: "Acesso completo",
  partialAccess: "Acesso parcial",
  newAccessRuleAdded: "Nova Regra de Acesso '{{accessRuleName}}' adicionada",
  newAccessRuleAddedAndSetAsInactive: "Nova Regra de Acesso '{{accessRuleName}}' adicionada e definida como inativa",
  accessRuleUpdatedSuccessfully: "Regra de Acesso '{{accessRuleName}}' atualizada com sucesso",
  accessRuleDeletedSuccessfully: "Regra de Acesso '{{accessRuleName}}' excluída com sucesso",
  thisIsASystemDefaultAccessRuleAndCannotBeModifiedYouAreWelcomeToCreateANewAccessRuleOrDuplicateAsNeeded: "Esta é uma regra de acesso padrão do sistema e não pode ser modificada. Você pode criar uma nova regra de acesso ou duplicar conforme necessário.",
  thisAccessRuleIsUtilizedBy: "Esta regra de acesso é utilizada por {{group}}",
  returnToPermissions: "Retornar às permissões",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeactivated: "Esta regra está sendo utilizada por grupos e não pode ser desativada.",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeleted: "Esta regra está sendo utilizada por grupos e não pode ser excluída.",
  pleaseUseOnlyLettersNumbersAndSpacesSpecialCharactersAreNotAllowed: "Use apenas letras, números e espaços. Caracteres especiais não são permitidos.",
  enterNameForThisAccessRule: "Insira o nome para esta regra de acesso",
  describeThisAccessRuleInFewWords: "Descreva esta regra de acesso em poucas palavras",
  failedToAssignPermissionsToAccessRulePleaseTryAgain: "Falha ao atribuir permissões à regra de acesso. Por favor, tente novamente.",
  yourPermissionsHaveBeenUpdatedPleaseLogInAgainToApplyTheNewChanges: "Um administrador atualizou as permissões de acesso do seu grupo. Para aplicar as alterações, você precisa sair e entrar novamente.",
  signBackIn: "Entrar novamente",
  groupAccessRuleUpdated: "Regra de acesso do grupo atualizada",
  theAccessRuleNameAlreadyExistsPleaseChooseADifferentName: "O nome da regra de acesso '{{accessRuleName}}' já existe. Por favor, escolha um nome diferente.",
  enterNickname: "Inserir apelido",
  nicknameIsForYourOwnReference: "O apelido é para sua própria referência",
  dateOfDeparture: "Data de saída",
  arrivalAtAod: "Chegada em AoD",
  enterOrder: "Inserir pedido",
  enterEmail: "Inserir e-mail",
  enterMobileNumber: "Inserir número celular",
  realTimeTrackingUnavailable: "Rastreamento em tempo real indisponível",
  liveTrackingIsUnavailableOnYourCurrentPlanUnlockThisFeatureByUpgradingYourPlanOrContactingOurSupportTeamForAssistance: "O rastreamento ao vivo não está disponível no seu plano atual. Desbloqueie este recurso atualizando seu plano ou contatando nossa equipe de suporte.",
  typeOfContact: "Tipo de contato",
  notifyVia: "Notificar via",
  refineByOrder: "Filtrar por pedido",
  bolBooking: "BoL/Reserva",
  pol: "PoL",
  utilization: "Utilização",
  destinationAirport: "Aeroporto de destino",
  display: "Mostrar",
  items2: "itens",
  exportCSV: "Exportar CSV",
  numberOfRowsPerPage: "Número de linhas por página",
  errorField: "Erro",
  showHideColumn: "Mostrar/Ocultar colunas",
  typeAndClickEnterToAdd: "Digite e pressione Enter para adicionar",
  communicationSentSuccessfully: "Comunicação enviada com sucesso!",
  deSelectAll: "Desmarcar todos",
  selectOrders: "Selecionar pedidos",
  addSelectedOption: "Adicionar pedidos selecionados",
  volumeAdded: "Volume adicionado",
  noLinkNotYet: "Ainda não há pedidos vinculados!",
  notifyUsers: "Notificar usuários",
  notificationSentSuccessfully: "Notificação enviada com sucesso!",
  continueBooking: "Continuar reserva",
  saveADraft: "Salvar rascunho",
  grossWeightKg: "Peso bruto (Kg)",
  saveThisSearch: "Salvar esta pesquisa",
  serial: "Série",
  groupManagementCreatedSuccessfully: "Grupo '{{groupName}}' criado com sucesso",
  groupManagementUpdatedSuccessfully: "Grupo '{{groupName}}' atualizado com sucesso",
  errorUpdateGroupManagement: "Ocorreu um erro ao atualizar o grupo '{{groupName}}'. Entre em contato com o suporte do Shipeezi.",
  groupInfoViewOnly: "Este é um grupo padrão do sistema que não pode ser modificado, mas você pode adicionar ou remover membros",
  groupNameAlreadyExists: "O nome do grupo '{{groupName}}' já existe. Por favor, escolha um nome diferente.",
  itLooksLikeYoureAboutToLeaveTheBookingProcessIfYouExitNowYourBookingWillNotBeCompletedAndAllTheInformationYouveEnteredSoFarWillBeLost: "Parece que você está prestes a sair do processo de reserva. Se sair agora, sua reserva não será concluída e todas as informações inseridas serão perdidas.",
  importantOnceYouLeaveTheresNoGuaranteeThatTheSameAvailabilityAndRatesWillStillApplyIfYouStartTheBookingAgain: "Importante: Uma vez que você saia, não há garantia de que a mesma disponibilidade e tarifas ainda se apliquem se você iniciar a reserva novamente.",
  areYouSureYouWantToCancel: "Tem certeza que deseja cancelar?",
  connectionTimeout: "Tempo de conexão esgotado: Por favor, tente novamente",
  timeoutDetail: "Está demorando mais que o esperado. Pode ser um problema temporário. Por favor, atualize a página ou tente novamente.",
  retry: "Tentar novamente",
  nothingToDisplayHere: "Nada para mostrar aqui!",
  toGetStartedFillOutTheSearchFormWithYourFreightDetailsAndHitTheSearchButtonToSeeTheBestAvailableOptions: 'Para começar, preencha o formulário de busca com os detalhes da sua carga e clique no botão "Buscar" para ver as melhores opções disponíveis.',
  averagePassword: "Senha regular",
  tariff: "Tarifa",
  roadFreightPickUp: "Frete rodoviário\n(coleta)",
  thcO: "THC-O",
  exportService: "Serviço de exportação",
  thcD: "THC-D",
  importService: "Serviço de importação",
  roadFreightDelivery: "Frete rodoviário (entrega)",
  carbonOffset: "Compensação de carbono",
  transportMode: "Modo de transporte",
  rateValidity: "Validade da tarifa",
  totalCargoWeight: "Peso total da carga",
  inspectionServices: "Serviços de inspeção",
  customClearance: "Desembaraço aduaneiro",
  etaAtWarehouse: "ETA no armazém",
  edd: "EDD",
  etaUnpack: "ETA de desembalagem",
  supplierPortalBannerMessagePaymentPending: "Com base no <strong>Incoterm {{incoterm}}</strong>, os custos devem ser pagos pelo comprador. A reserva será confirmada após o pagamento.",
  supplyChainBannerMessagePaymentPending: "Com base no <strong>Incoterm {{incoterm}}</strong>, os custos devem ser pagos para confirmar a reserva.",
  originTerminalHandlingCharge: "Taxa de manuseio no terminal de origem",
  destinationTerminalHandlingCharge: "Taxa de manuseio no terminal de destino",
  portOfLoadingPoL: "Porto de carregamento (PoL)",
  portOfDischargePoD: "Porto de descarga (PoD)",
  movementType: "Tipo de movimento",
  freightCharges: "Encargos de frete",
  payWithCard: "Pagar com cartão",
  notRequired: "Não obrigatório",
  paymentWillBeAvailableToTheBuyerSoon: "O pagamento estará disponível para o comprador em breve.",
  theBuyerHasPaidSuccessfully: "O comprador pagou com sucesso.",
  thisBookingHasExpiredAndBeenCancelled: "Esta reserva expirou e foi cancelada.",
  onceConfirmedThisWillBeSentToTheCarrierYouAreNotAbleToMakeAnyAdditionalChanges: "Uma vez confirmado, isso será enviado à transportadora. Você não poderá fazer alterações adicionais.",
  payBooking: "Pagar reserva",
  paidOn: "Pago em",
  noAllocated: "Não alocado",
  thisFieldDoesntAllowSpecialCharacters: "Este campo não permite caracteres especiais",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport: "Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente ou entre em contato com o suporte.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport: "Ocorreu um erro ao processar sua rejeição. Por favor, tente novamente ou entre em contato com o suporte.",
  errorProcessingRejection: "Erro ao processar a rejeição",
  errorProcessingRequest: "Erro ao processar a solicitação",
  areYouAnExistingShipeeziUser: "Você é um usuário existente do Shipeezi?",
  yesGoToLoginPage: "Sim, ir para a página de login",
  noRegisterAsAnAgent: "Não, registrar como agente",
  selectCompany: "Selecionar empresa",
  enterName: "Inserir nome",
  connect: "Conectar",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater: "Ocorreu um erro ao tentar conectar as empresas. Por favor, tente novamente mais tarde.",
  invalidOrExpiredLink: "Link inválido ou expirado",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation: "Este link de convite é inválido ou já expirou. Entre em contato conosco para receber um novo convite.",
  paymentPending: "Pagamento pendente",
  processing: "Processando",
  searchFreight: "Pesquisar frete",
  freightBooking: "Reserva de frete",
  YourShipeeziID: "Seu ID do Shipeezi",
  noOfOrders: "N.º de pedidos",
  carriersFound: "Transportadoras encontradas",
  LowToHigh: "Do menor ao maior",
  HighToLow: "Do maior ao menor",
  directRoutes: "Rotas diretas",
  alternateRoutes: "Rotas alternativas",
  alternate: "Alternativo",
  direct: "Direto",
  Shipmentno: "N.º do envio",
  passwordResetSuccesfully: "Senha redefinida com sucesso",
  frieghtid: "ID do frete",
  passwordRestLinkExpired: "O link de redefinição de senha expirou",
  valid: "Válido",
  customerIsNotAllowedToReceiveNotification: "O cliente não pode receber notificações",
  carbonFootprint: "Pegada de carbono",
  PlaceOfDestination: "Local de destino",
  advanceShippingNoticeIsRequired: "O aviso de envio antecipado é obrigatório",
  weightCantBe0: "O peso não pode ser 0",
  shipTermsIsRequired: "Os termos de envio são obrigatórios",
  selectOfficeFromTheDropdown: "Selecionar escritório do menu suspenso",
  marksAndNumber: "Marcas e números",
  requiredDocument: "Documentos obrigatórios",
  supportingDocuments: "Documentos de suporte",
  optionalShipmentData: "Dados opcionais do envio",
  requiredVolumeConfirmation: "A confirmação de volume é obrigatória",
  shipmentsSettings: "Envios",
  seaTrackingEnabled: "Rastreamento marítimo habilitado",
  airTrackingEnabled: "Rastreamento aéreo habilitado",
  accessRuleCreatedSuccessfully: "Nova regra de acesso '{{accessRuleName}}' adicionada",
  accessRuleDuplicatedSuccessfully: "Nova regra de acesso '{{accessRuleName}}' adicionada e inativada",
  accessRuleInfoViewOnly: "Esta é uma regra de acesso padrão do sistema e não pode ser modificada. Você pode criar uma nova ou duplicá-la conforme necessário.",
  viewGroupAccessRuleTitle: "Esta regra de acesso é usada por {{groupCount}} grupos",
  accessRuleNameHaveSpecialCharacter: "Por favor, use apenas letras, números e espaços. Caracteres especiais não são permitidos.",
  updatedPreference: "Preferência de tabela de dados atualizada!",
  subscriberThatLinkedToOrdersIsNotAllowedToBeDelete: "Assinantes vinculados a pedidos não podem ser excluídos!",
  minimumPageSizeGreaterThanTen: "O tamanho mínimo de página é 10",
  subscriberSuccessfullyAdded: "Assinante adicionado com sucesso",
  defaultTeam: "Equipe padrão",
  customTeam: "Equipe personalizada",
  created: "Criado",
  noMatchingRecordsFound: "Nenhum registro correspondente encontrado",
  tryAdjustingYourFilters: "Tente ajustar seus filtros.",
  noRecordFound: "Nenhum registro encontrado",
  haveTask: "Tem tarefa",
  dontHaveTask: "Não tem tarefa",
  forContainerOnRow: "Para contêiner na linha",
  column: "coluna",
  storeName: "Nome da loja",
  loadedStatus: "Status de carga",
  markAsDefault: "Marcar como padrão",
  enterTemplateName: "Inserir nome do modelo",
  enterSubject: "Inserir assunto",
  enterFromName: "Inserir nome do remetente",
  enterStatus: "Inserir status",
  enterAvailableIn: "Inserir disponível em",
  enterAutomation: "Inserir automação",
  enterLastUpdate: "Inserir última atualização",
  addBusinessIcon: "Adicionar ícone empresarial",
  addBusinessLogo: "Adicionar logo empresarial",
  addIcon: "Adicionar ícone",
  fromName: "Nome do remetente",
  formatsJPG_GIF_PNG: "Formatos: JPG, GIF, PNG",
  maxSize2MB: "Tamanho máximo: 2 MB",
  attachments: "Anexos",
  pushNotification: "Notificação push",
  salesApp: "App de Vendas",
  linkedAutomation: "Automação vinculada",
  noAutomationsLinked: "Sem automações vinculadas",
  notShared: "Não compartilhado",
  partiallyShared: "Parcialmente compartilhado",
  fullyShared: "Totalmente compartilhado",
  scac: "SCAC",
  inventorySummary: "Resumo do inventário",
  networkDetails: "DETALHES",
  networkRoles: "FUNÇÕES",
  networkWeightAndMeasurements: "PESO E MEDIDAS",
  networkPickup: "COLETA",
  networkDelivery: "ENTREGA",
  networkGeneralComments: "COMENTÁRIOS GERAIS",
  networkActualInventory: "INVENTÁRIO REAL",
  networkQuotedInventory: "INVENTÁRIO COTADO",
  networkPhotosAndVideos: "FOTOS E VÍDEOS",
  networkDocuments: "DOCUMENTOS",
  networkSettingsBannerMessage: "Escolha os campos de dados da seção abaixo que deseja exibir para o agente de rede ao aceitar a tarefa.",
  failedToSaveNetworkSettings: "Falha ao salvar configurações de rede",
  assignToAnAgent: "Atribuir a um agente?",
  selectAnAgent: "Selecionar um agente",
  additionalInstructions: "Instruções adicionais",
  enterAdditionalInstructions: "Inserir instruções adicionais",
  agentName: "Nome do agente",
  started: "Iniciado",
  taskAddedSuccessfully: "Tarefa adicionada com sucesso!",
  thisInstructionWillBeVisibleInTheEmailAndTaskView: "Esta instrução será visível no E-mail e na Visualização da Tarefa.",
  moreJobTypes: "Mais tipos de trabalho",
  moreTaskTypes: "Mais tipos de tarefa",
  moreTriggers: "Mais gatilhos",
  selectTaskTypes: "Selecionar tipos de tarefa",
  selectOrderTypes: "Selecionar tipos de pedido",
  selectTriggers: "Selecionar gatilhos",
  typeCode: "Código do tipo",
  newChecklist: "Nova lista de verificação",
  enterQuestionHere: "Insira a pergunta aqui",
  responseType: "Tipo de resposta",
  addLogic: "Adicionar lógica",
  shortDescription: "Descrição curta",
  enterDescriptionHere: "Insira a descrição aqui",
  singleChoiceQuestion: "Pergunta de escolha única",
  multipleChoiceQuestion: "Pergunta de múltipla escolha",
  inputText: "Inserir texto",
  inputNumber: "Inserir número",
  selectDate: "Selecionar Data",
  addSignature: "Adicionar assinatura",
  checklistItem: "Item da lista de verificação",
  enterOptions: "Inserir opções",
  option: "Opção",
  addQuestion: "Adicionar pergunta",
  defaultState: "Estado padrão",
  taskTypes: "Tipos de Tarefa",
  jobTypes: "Tipos de Trabalho",
  ifAnswer: "Se resposta",
  is: "é",
  isNot: "não é",
  then: "então",
  enterText: "Inserir texto",
  enterNumber: "Inserir número",
  selectOption: "Selecionar opção",
  isLesserThan: "é menor que",
  isGreaterThan: "é maior que",
  selected: "Selecionado",
  notSelected: "não selecionado",
  if: "Se",
  requireEvidence: "Exigir evidência",
  askQuestion: "Fazer pergunta",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected: "Escolha a evidência que será exigida quando esta resposta for selecionada.",
  youShouldAddAtLeastOneOption: "Você deve adicionar pelo menos uma opção.",
  youShouldAddAtLeastTwoOptions: "Você deve adicionar pelo menos duas opções.",
  allOptionsShouldHaveAName: "Todas as opções devem ter um nome.",
  methodOfPreparation: "Método de Preparação",
  itemCharacteristics: "Características do Item",
  highRiskHighValueChecklist: "Lista de Verificação de Alto Risco/Alto Valor",
  proGearChecklist: "Lista de Verificação Pro-Gear",
  isHighRisk: "É de alto risco",
  notHighRisk: "Não é de alto risco",
  isProGear: "É Pro-Gear",
  notProGear: "Não é Pro-Gear",
  meChecklistNotDone: "Lista M&E não concluída",
  unsavedItem: "Item não salvo, salve para aplicar todos os filtros corretamente",
  youHaveUnsavedChanges: "Você tem alterações não salvas.",
  doYouWantToSaveBeforeLeaving: "Deseja salvar antes de sair?",
  timezoneIssue: "Problema de fuso horário",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled: "Todas as perguntas devem ter um título e todos os campos de lógica devem ser preenchidos.",
  areYouSureYouWantToDeleteThisLogic: "Tem certeza que deseja excluir esta lógica?",
  deleteLogic: "Excluir lógica",
  atLeastOneOptionIsRequired: "Pelo menos uma opção é necessária",
  atLeastTwoOptionsAreRequired: "Pelo menos duas opções são necessárias",
  templateNameAlreadyExists: "O nome do modelo já existe!",
  invalidSystemReportForAvailableIn:
    "Um ou mais relatórios do sistema não são válidos para as opções de Disponível em selecionadas.",
  userUploaded: "Uploads do usuário",
  systemGenerated: "Uploads do sistema",
  uploadFiles: "Enviar arquivos",
  orDragAndDropHere: "ou arraste e solte arquivos aqui",
  maxFileSizeLimit: "O tamanho máximo de arquivo é 25 MB. Formatos aceitos:",
  quickOrder: "Pedido rápido",
  createQuickOrder: "Criar pedido rápido",
  orderAlreadyExists: "O pedido já existe",
  searchOrAddCustomer: "Pesquisar ou adicionar cliente",
  aCustomerWithSameIdAlreadyExists: "Um cliente com o mesmo ID já foi adicionado",
  addANoteAsEvidence: "Adicionar uma nota como evidência",
  addAPhotoAsEvidence: "Adicionar uma foto como evidência",
  displayInDispatchModule: "Exibir no módulo de despacho",
  leavingTheWarehouse: "Saindo do armazém",
  leads: "Leads",
  estimates: "Estimativas",
  proposal: "Proposta",
  invoicing: "Faturamento",
  creditNotes: "Notas de Crédito",
  expenses: "Despesas",
  claims: "Reclamações",
  storageBoxUnit: "Caixa de armazenamento e unidade",
  storageAccount: "Conta de Armazenamento",
  finance: "Finanças",
  packageType: "Tipo de Embalagem",
  methodType: "Tipo de método",
  itemInstruction: "Instrução do Item",
  leadSoure: "Fonte do lead",
  help: "Ajuda",
  askDumont: "Perguntar ao Dumont",
  dumontHelpDocumentation: "Ajuda e Documentação",
  dumontSendFeedback: "Enviar Feedback",
  dumontContactSupport: "Contatar Suporte",
  dumontLearnHowToUseDumont: "Saiba como usar o Dumont",
  dumontHelpUsImproveDumont: "Ajude-nos a melhorar o Dumont",
  dumontGetHelpFromTeam: "Obtenha ajuda da nossa equipe",
  dumontQuickActions: "Ações Rápidas",
  dumontContactOurSupport: "Contate nosso suporte",
  dumontGetHelpWithIssues: "Obtenha ajuda com problemas e dúvidas",
  dumontSendUsYourFeedback: "Envie-nos seu feedback",
  dumontShareThoughtsAndSuggestions: "Compartilhe seus pensamentos e sugestões",
  dumontCommonQuestions: "Perguntas Frequentes",
  dumontHowToCreateCustomAgent: "Como criar um agente personalizado?",
  dumontHowToCreateCustomAgentAnswer: "Para criar um agente personalizado, acesse a seção Agentes e clique em Criar Novo Agente. Você poderá configurar as capacidades e configurações do agente conforme necessário.",
  dumontWhatCanDumontHelp: "Com o que o Dumont pode me ajudar?",
  dumontWhatCanDumontHelpAnswer: "O Dumont é seu assistente de IA especializado em logística e mudanças. Posso ajudá-lo com planejamento de despacho, gerenciamento de pedidos, otimização de rotas e responder perguntas sobre suas operações.",
  dumontHowToAccessChatHistory: "Como acessar meu histórico de conversas?",
  dumontHowToAccessChatHistoryAnswer: "Clique no ícone de Histórico na barra lateral para ver todas as suas conversas anteriores com o Dumont. Você pode pesquisar no histórico e retomar qualquer conversa anterior.",
  dumontCanCustomizeAgentCapabilities: "Posso personalizar as capacidades dos agentes?",
  dumontResources: "Recursos",
  dumontKnowledgeBase: "Base de Conhecimento",
  dumontCompleteGuidesAndTutorials: "Guias completos e tutoriais",
  dumontSelectAnOption: "Selecione uma opção",
  dumontFeedbackHelpsImprove: "Seu feedback nos ajuda a melhorar o Dumont",
  dumontIssueType: "Tipo de Problema",
  dumontSubject: "Assunto",
  dumontBriefDescriptionOfIssue: "Breve descrição do problema",
  dumontMessage: "Mensagem",
  dumontPleaseDescribeIssueDetail: "Descreva seu problema em detalhes...",
  dumontIncludeErrorMessages: "Inclua mensagens de erro ou etapas para reproduzir o problema",
  dumontGotIt: "Entendido",
  dumontCancel: "Cancelar",
  dumontSendFeedbackButton: "Enviar Feedback",
  dumontSendMessage: "Enviar Mensagem",
  dumontSupportRequestSentSuccessfully: "Sua solicitação de suporte foi enviada com sucesso. Nossa equipe responderá em até 24 horas.",
  dumontFeedbackSentSuccessfully: "Seu feedback foi enviado com sucesso. Agradecemos sua contribuição!",
  dumontSearchPlaceholder: "Pesquisar conversas, agentes, histórico...",
  dumontNavigation: "Navegação",
  dumontNewChat: "Nova Conversa",
  dumontChats: "Conversas",
  dumontNoChatsFound: "Nenhuma conversa encontrada",
  dumontNoRecentChats: "Nenhuma conversa recente",
  dumontAgents: "Agentes",
  dumontNoAgentsFound: "Nenhum agente encontrado",
  dumontReturnToShipeezi: "Voltar para o Shipeezi",
  dumontHelp: "Ajuda",
  dumontWelcomeMessage: "Olá, {{userName}}, sou o Dumont, seu assistente de IA especializado em logística e mudanças. Criado para simplificar fluxos complexos, aprendo continuamente para oferecer suporte mais rápido, inteligente e preciso ao seu negócio.",
  dumontWelcomeMessageBusiness: "Olá, {{userName}}, sou o Assistente de Negócios Dumont! 💼 Especializo-me em vendas e cotações. Posso ajudá-lo a criar cotações precisas de frete, gerenciar relacionamentos com clientes e fechar negócios mais rapidamente. Como posso ajudá-lo hoje?",
  dumontWelcomeMessageOperations: "Olá, {{userName}}, sou o Assistente de Operações Dumont! 📊 Sou seu especialista em operações. Posso ajudá-lo a rastrear remessas, monitorar entregas, gerenciar trabalhos e garantir operações logísticas tranquilas. Com o que você precisa de ajuda?",
  dumontWelcomeMessageWarehousing: "Olá, {{userName}}, sou o Assistente de Armazenagem Dumont! 🏭 Especializo-me em estoque e operações de armazém. Posso ajudá-lo a gerenciar níveis de estoque, rastrear inventário, coordenar armazenamento e otimizar a eficiência do armazém. Como posso ajudar?",
  dumontDispatchQuickActions: "Ações rápidas para Despacho",
  dumontHistory: "Histórico",
  dumontConversationHistory: "Histórico de Conversas",
  dumontNoConversationsFound: "Nenhuma conversa encontrada",
  dumontNoConversationHistory: "Nenhum histórico de conversas",
  dumontTryDifferentSearchTerm: "Tente um termo de pesquisa diferente",
  dumontStartNewConversation: "Inicie uma nova conversa para vê-la aqui",
  dumontFileTooLarge: "Arquivo muito grande. O tamanho máximo é 10MB.",
  dumontUnsupportedFileType: "Tipo de arquivo não suportado. Selecione arquivos TXT, PDF ou DOC/DOCX.",
  dumontDocumentProcessing: "O processamento de PDF/DOC estará disponível em breve. Por favor, use arquivos TXT por enquanto.",
  dumontFileProcessingError: "Erro ao processar arquivo. Por favor, tente novamente.",
  dumontAskDumont: "Perguntar ao Dumont...",
  dumontAskDumontAnything: "Pergunte qualquer coisa ao Dumont",
  dumontUpload: "Enviar",
  dumontUsesAI: "O Dumont usa Inteligência Artificial. Revise as respostas.",
  dumontCopyConversation: "Copiar conversa",
  dumontExportChat: "Exportar conversa",
  dumontClearConversation: "Limpar conversa",
  dumontLoadingAgents: "Carregando agentes...",
  dumontAgentsTitle: "Agentes Dumont",
  dumontCreateAgent: "Criar Agente",
  dumontSearchAgents: "Pesquisar agentes...",
  dumontNoAgentsAvailable: "Nenhum agente disponível",
  dumontAgentsAvailableSoon: "Agentes estarão disponíveis em breve",
  featureLocked: "Recurso bloqueado",
  accountNotHaveAccess: "Sua conta não tem acesso a este recurso no momento.",
  reachSupportTeam: "Entre em contato com nossa equipe de suporte",
  forDetails: " para mais detalhes.",
  titleFeatureRequestSupport: "Solicitar acesso a este recurso",
  sendRequestSupport: "Enviar solicitação ao suporte",
  itLooksLikeYouDontHaveAcessThisFeatureYet: "Parece que você ainda não tem acesso a este recurso. Se quiser usá-lo, envie uma solicitação para nossa equipe de suporte.",
  feature: "Recurso",
  pleaseDescribeYouIntendUseFeature: "Por favor, descreva como pretende usar este recurso",
  yourMessageShouldLeast50Characters: "Sua mensagem deve ter pelo menos 50 caracteres.",
  minCharacters: "Sua mensagem deve ter pelo menos {{count}} caracteres.",
  maxCharacters: "Sua mensagem não deve exceder {{count}} caracteres",
  yourRequestHasBeenSentOurSupportTeam: "Sua solicitação foi enviada para nossa equipe de suporte",
  TermsConditions: "Termos e Condições",
  Iso14451: "ISO14451-1:2016",
  Iso17451: "ISO17451 - 1:2016",
  dumontComingSoon: "Em breve...",
  dumontBusinessAssistant: "Assistente de Negócios",
  dumontBusinessAssistantDesc: "Especializado em vendas e cotações",
  dumontOperationsAssistant: "Assistente de Operações",
  dumontOperationsAssistantDesc: "Especialista em todas as suas operações",
  dumontWarehousingAssistant: "Assistente de Armazenagem",
  dumontWarehousingAssistantDesc: "Especialista em estoque e operações de armazém",
  dumontCanCustomizeAgentCapabilitiesAnswer: "Sim! Cada agente pode ser personalizado para atender ao seu fluxo de trabalho específico. Você pode ajustar as capacidades, definir parâmetros específicos e configurar quais fontes de dados eles têm acesso.",
  dumontFeedbackType: "Tipo de Feedback",
  dumontYourFeedback: "Seu Feedback",
  dumontTellUsWhatYouThink: "Nos diga o que você pensa...",
  dumontPleaseSelectTextFile: "Selecione um arquivo de texto (.txt)",
  dumontDocumentAttached: "Documento anexado",
  dumontRemoveDocument: "Remover documento",
  dumontDefaultResponse: "Obrigado por entrar em contato! Estou analisando sua solicitação e fornecerei a melhor solução.",
  dumontSales: "Vendas",
  dumontOperations: "Operações",
  dumontLogistics: "Logística",
  dumontDispatchShowTodayOrders: "Mostrar pedidos de despacho de hoje",
  dumontDispatchShowTodayOrdersDesc: "Obtenha um resumo de todos os pedidos agendados para despacho hoje",
  dumontDispatchFindCustomer: "Encontrar pedidos por nome do cliente",
  dumontDispatchFindCustomerDesc: "Pesquise pedidos específicos usando informações do cliente",
  dumontDispatchTrackStatus: "Rastrear status do pedido",
  dumontDispatchTrackStatusDesc: "Verifique o status atual dos pedidos no sistema",
  dumontDispatchOptimizeRoutes: "Otimizar rotas de entrega",
  dumontDispatchOptimizeRoutesDesc: "Obtenha sugestões para as rotas de entrega mais eficientes",
  dumontWhatCanIHelpYouWith: "Como posso ajudá-lo?",
  dumontOptimizeLogisticsOperations: "Otimizar minhas operações logísticas",
  dumontOptimizeLogisticsOperationsDesc: "Obtenha recomendações personalizadas para melhorar a eficiência e reduzir custos",
  dumontTrackShipmentStatus: "Rastrear status da remessa",
  dumontTrackShipmentStatusDesc: "Obtenha atualizações em tempo real sobre suas remessas e estimativas de entrega",
  dumontCalculateShippingCosts: "Calcular custos de envio",
  dumontCalculateShippingCostsDesc: "Estime custos para diferentes métodos de envio e destinos",
  dumontFindWarehouseLocations: "Encontrar localizações de armazéns",
  dumontFindWarehouseLocationsDesc: "Descubra localizações ideais de armazéns para sua rede de distribuição",
  dumontManageInventoryLevels: "Gerenciar níveis de estoque",
  dumontManageInventoryLevelsDesc: "Obtenha informações sobre otimização de estoque e gestão de produtos",
  dumontScheduleDeliveries: "Agendar entregas",
  dumontScheduleDeliveriesDesc: "Planeje e otimize rotas de entrega para máxima eficiência",
  dumontHowCanIHelpYou: "Como posso ajudá-lo?",
  invalidFileType: "Tipo de arquivo inválido",
  uploadFailed: "Falha no upload",
  tooManyFiles: "Muitos arquivos",
  filesExceedSizeLimit: "Os arquivos excedem o limite de tamanho",
  allFilesUploadedSuccessfully: "Todos os arquivos foram enviados com sucesso",
  moreBranches: "Mais filiais",
  maximum10FilesPerUpload: "Máximo 10 arquivos por upload.",
  generate: "Gerar",
  onCSVWeHaveFoundSomeErrors: "No CSV <strong>{{csvFileName}}</strong> encontramos alguns erros. Você deve ajustar essas linhas para continuar:",
  weReSecurelyLoadingYourDataIntoShipeeziSCertifiedFramework: "Estamos carregando seus dados com segurança no framework certificado do Shipeezi.",
  weFoundSomeIssuesInYourCSV: "Encontramos alguns problemas em seu \"{{csvFileName}}\". Por favor, corrija essas linhas antes de continuar:",
  needHelp: "Precisa de ajuda?",
  forTheCorrectFormat: "para o formato correto.",
  noScreenshotsCaptured: "Nenhuma captura de tela capturada",
  noParticipantsAvailable: "Nenhum participante disponível",
  companySlug: "Slug da empresa",
  aUniqueIDUsedToIdentifyThisOrganization: "Um ID único para identificar esta organização",
  thisSubdomainIsNotAvailablePleaseChooseADifferentOne: "Este subdomínio não está disponível. Por favor, escolha um diferente.",
  fileIsTooBig: "O arquivo é muito grande. O tamanho máximo é 25 MB",
  multiFactorAuthentication: "Autenticação multifator",
  mfaMultiFactorAuthentication: "Autenticação multifator",
  configureMfaSettingsPerGroup: "Configurar configurações de MFA por grupo",
  mfaSettings: "Configurações de MFA",
  enableMfa: "Habilitar MFA",
  mfaEnabled: "MFA habilitado",
  mfaDisabled: "MFA desabilitado",
  authenticationMethod: "Método de autenticação",
  selectMethod: "Selecionar método",
  environments: "Ambientes",
  enabledEnvironments: "Ambientes habilitados",
  savingMfaSettings: "Salvando configurações de MFA...",
  mfaSettingsUpdated: "Configurações de MFA atualizadas com sucesso",
  errorUpdatingMfaSettings: "Erro ao atualizar configurações de MFA",
  noGroupsFound: "Nenhum grupo encontrado",
  mfaVerificationTitle: "Inserir código de verificação",
  mfaVerificationDescription: "Um código de verificação foi enviado para:",
  mfaVerificationCode: "Código de verificação",
  verify: "Verificar",
  resendCode: "Reenviar código",
  resendViaEmail: "Reenviar por e-mail",
  resendViaSms: "Reenviar por SMS",
  mfaCodeResent: "Código de verificação reenviado com sucesso",
  errorResendingCode: "Erro ao reenviar o código. Por favor, tente novamente.",
  invalidCode: "Código inválido. Por favor, tente novamente.",
  codeExpired: "Código expirado",
  expiresIn: "Expira em",
  smsRequiresPhoneNumber: "SMS requer número de telefone",
  activeLoginSessions: "Sessões de login ativas",
  operating_system: "Sistema operacional",
  application: "Aplicativo",
  shipeezi_platform: "Plataforma Shipeezi",
  ip_address: "Endereço IP",
  last_active_date: "Último acesso",
  youHaveToSelectAtLeastOnePlatform: "Você deve selecionar pelo menos uma plataforma",
  prohibitSimultaneousLogin: "Proibir login simultâneo",
  prohibitSimultaneousLoginDescription: "Impedir que os usuários façam login em múltiplos dispositivos ou plataformas ao mesmo tempo",
  applyToPlatforms: "Aplicar às plataformas",
  selectEquipmentType: "Selecionar tipo de equipamento",
  infoMessageEquipmentTypeFilterTitle: "Este filtro é opcional.",
  infoMessageEquipmentTypeFilterNoSelection: "Sem seleção → o relatório inclui todos os tipos de equipamento.",
  infoMessageEquipmentTypeFilterSpecificType: "Tipo específico selecionado → o relatório inclui apenas tarefas com esse tipo.",
  infoMessageEquipmentTypeFilterNoTasks: "Sem tarefas para o tipo selecionado → o relatório não mostra resultados.",
  defaultTemplate: "Modelo padrão",
  originFile: "Arquivo de origem",
  templateContent: "Conteúdo do modelo",
  onboardingTrigger: "Integração",
  signupTrigger: "Cadastro",
  offboarding: "Desligamento",
  sendViaVideoSurveyLink: "Enviar via link de pesquisa de vídeo",
  sendANewInvitationToTheScheduleVideoSurvey: "Enviar um novo convite para a pesquisa de vídeo agendada",
  thereIsNoActiveVideoSurvey: "Não há pesquisa de vídeo ativa.",
  videoSurveyLinkSentToCustomer: "Link da pesquisa de vídeo enviado ao cliente",
  videoSurveyLinkSendFailed: "Falha ao enviar link da pesquisa de vídeo",
  plainText: "Texto simples",
  header: "Cabeçalho",
  copyrightText: "Texto de direitos autorais",
  shipeeziBranding: "Marca Shipeezi",
  scheduleSend: "Agendar envio",
  sendDate: "Data de envio",
  sendTime: "Hora de envio",
  selectAnUser: "Selecionar um usuário",
  currentShipByDate: "Data de envio atual",
  originalShipByDate: "Data de envio original",
  signup: {
    left: {
      title: "Bem-vindo ao Shipeezi — onde visibilidade, controle e simplicidade se unem.",
      subtitle: "Comece seu teste gratuito e descubra como o Shipeezi unifica cada parte do seu fluxo de trabalho, de vendas a operações e armazenagem.",
      card1Title: "Simplicidade em escala",
      card1Desc: "O Shipeezi reúne todos os seus processos em um só lugar, ajudando sua equipe a trabalhar de forma mais inteligente e rápida em todo o mundo.",
      card2Title: "Mais controle, menos custos",
      card2Desc: "Com tudo conectado, você economizará tempo, reduzirá erros e cortará custos — enquanto proporciona aos seus clientes uma experiência perfeita.",
      trusted: "Confiado por líderes do setor em todo o mundo",
    },
    right: {
      createAccount: "Crie sua conta",
      subtitle: "Você está a poucos passos de ter total visibilidade e controle sobre seus envios!",
      haveAccount: "Tem conta?",
      signIn: "Entrar",
      thankYou: "Obrigado por solicitar uma conta no Shipeezi",
      pendingApproval: "Nossa equipe entrará em contato com você antes de ativar sua conta",
      step2Title: "Conte-nos sobre sua empresa",
      step2Subtitle: "Adaptaremos o Shipeezi às necessidades da sua empresa",
      companyName: "Nome da empresa",
      companyType: "Tipo de empresa",
      selectYourPlatform: "Selecione sua plataforma",
      step3Title: "O que você gostaria de melhorar com o Shipeezi?",
      step3Subtitle: "Escolha as áreas do seu negócio que deseja simplificar e escalar",
      sales: "Vendas",
      operations: "Operações",
      warehousing: "Armazenagem",
      next: "Próximo",
      back: "Voltar",
      requestAccount: "Solicitar conta",
      termsOfUse: "Termos de uso",
      privacyPolicy: "Política de Privacidade",
      and: "e",
      byContinuingYouReAgreeingToShipeeziS: "Ao continuar, você concorda com os termos do Shipeezi",
      getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime: "Receba e-mails do Shipeezi sobre atualizações de produtos, notícias do setor e eventos.",
      captchaExpired: "Captcha expirado",
      step4Title: "Ajude-nos a entender seu processo de vendas",
      step4Subtitle: "Suas respostas nos ajudarão a configurar o Shipeezi para sua equipe",
      videoSurveysQuestion: "Você oferece pesquisas de vídeo para seus clientes?",
      salesRepsQuestion: "Quantos representantes de vendas sua empresa tem?",
      yes: "Sim",
      no: "Não",
      range_1_10: "1-10",
      range_11_20: "11-20",
      range_above_30: "Acima de 30",
      salesStepTitle: "Ajude-nos a entender seu processo de vendas",
      salesStepSubtitle: "Suas respostas nos ajudarão a configurar o Shipeezi para sua equipe",
      operationsStepTitle: "Conte-nos sobre suas operações",
      operationsStepSubtitle: "Configuraremos o Shipeezi com base em como sua empresa opera hoje",
      warehousingStepTitle: "Conte-nos sobre seu armazenamento",
      warehousingStepSubtitle: "Otimizaremos sua configuração de armazenamento e inventário no Shipeezi",
      storageQuestion: "Você oferece armazenamento para seus clientes?",
      warehousesCountQuestion: "Quantos armazéns você gerencia?",
      shipmentType: "Tipo de envio",
      local: "Local",
      international: "Internacional",
      interstate: "Interestadual",
      military: "Militar",
      annualShipmentVolume: "Volume anual de envios",
      v_1_4: "1-4",
      v_5_600: "5-600",
      v_601_10000: "601 - 10,000",
      v_10001_20000: "10,001 - 20,000",
      v_20001_plus: "20,001 +",
      step5Title: "Incrível! Estamos quase lá!",
      step5Subtitle: "Adoraríamos saber como você descobriu o Shipeezi!",
      thankYouV2Title: "Obrigado por se cadastrar!",
      thankYouV2Description: "Nossa equipe entrará em contato em breve para ativar sua conta. Você estará pronto para experimentar o Shipeezi — uma plataforma, cada mudança.",
      returnToWebsite: "Voltar ao nosso site",
      discover: {
        website: "Nosso Site",
        email: "Email Marketing",
        google: "Google",
        newsletter: "Newsletter",
        aiTools: "Ferramentas de IA",
        referral: "Indicação",
        whereLabel: "Onde?",
        whoReferredLabel: "Quem te indicou?",
        other: "Outro",
      },
      wh_1_10: "1-10",
      wh_11_30: "11-30",
      wh_above_30: "Acima de 30",
      trustedBy: "Confiado por líderes do setor em todo o mundo",
      paymentTerms: "Termos de pagamento",
      privacyAndCompliance: "Política de privacidade e conformidade",
      saasAgreement: "Contrato SAAS e SLA",
      termsOfSale: "Termos de venda",
      termsPrefix: "Ao continuar, você concorda com os",
      ownWords: {
        questionLabel: "Quais são seus desafios ou obstáculos agora?",
        placeholder: "Digite algo...",
        characters: "caracteres",
        helperShort: "Sua mensagem deve ter pelo menos 50 caracteres.",
        helperLong: "Mantenha sua mensagem com menos de 500 caracteres.",
      },
    },
  },
  common: {
    close: "Fechar",
    save: "Salvar",
    saving: "Salvando",
  },
  onboarding: {
    pageTitle: "Integração",
    left: {
      title: "Bem-vindo ao Shipeezi — onde visibilidade, controle e simplicidade se unem.",
      subtitle: "Faltam apenas alguns passos rápidos para configurar sua conta. O Shipeezi ajudará você a simplificar processos, conectar sua equipe e ter controle total sobre cada mudança. Vamos começar.",
    },
    steps: {
      introduction: "Introdução",
      companyDetails: "Adicione as informações da sua empresa, endereço comercial e contato principal",
      myBilling: "Minha cobrança",
      members: "Membros",
      uploadCentre: "Envie suas informações iniciais para que o Shipeezi possa conectar seus dados",
      complete: "Concluir",
    },
    uploadCentre: {
      title: "Bem-vindo ao Shipeezi — onde visibilidade, controle e simplicidade se unem.",
      description: "Aqui você pode enviar seus próprios arquivos (como inventário, equipe ou listas de serviços) ou começar com a lista padrão do Shipeezi. Você sempre pode atualizar isso depois.",
      uploadOwnList: "Enviar minha própria lista",
      uploadOwnListDescription: "Traga seus próprios dados para personalizar o Shipeezi desde o início.",
      useDefaultList: "Usar a lista padrão do Shipeezi (ISO17451-1:2016)",
      useDefaultListDescription: "Comece rapidamente com nossa lista pré-configurada, construída no padrão global ISO17451-1:2016. Você pode atualizá-la ou expandi-la a qualquer momento.",
      downloadTemplate: "Baixe nosso modelo CSV aqui",
      complete: "Concluir",
    },
    complete: {
      title: "Bem-vindo ao Shipeezi — onde visibilidade, controle e simplicidade se unem.",
      subtitle: "",
      button: "Começar",
      leftTitle: "Configuração concluída!",
      leftSubtitle: "Tudo pronto para começar a gerenciar cada mudança em uma só plataforma.",
    },
    buttons: {
      goBackToLogin: "Voltar ao login",
      skip: "Pular por agora",
      downloadCsvTemplate: "Baixe nosso modelo CSV aqui",
      next: "Próximo",
      back: "Voltar",
    },
    introduction: {
      companyDetails: "Adicione as informações da sua empresa, endereço comercial e contato principal",
      members: "Membros",
      uploadCentre: "Envie suas informações iniciais para que o Shipeezi possa conectar seus dados",
    },
    members: {
      title: "Membros",
      description:     "Convide as pessoas que usarão o Shipeezi com você. Atribua função e filial para que tenham o acesso correto desde o início. Você pode atualizar ou adicionar mais membros depois.",
      registeredMembers: "Membros registrados",
      firstName: "Nome",
      lastName: "Sobrenome",
      email: "E-mail",
      memberCode: "Código do membro",
      branch: "Filial",
      mobile: "Celular",
      accessGroup: "Grupo de acesso",
      memberType: "Tipo de membro",
      additionalMembers: "Membros adicionais",
      uploadMembers: "Enviar membros",
      addMembers: "Adicionar membros",
      name: "Nome",
      group: "Grupo",
      type: "Tipo",
      noAdditionalMembers: "Nenhum membro adicional",
      downloadTemplate: "Baixar modelo",
      uploadCSV: "Enviar CSV",
      addMember: "Adicionar membro",
      userCode: "Código do usuário",
    },
    billing: {
      useSameAdmin: 'Usar os mesmos dados do "usuário administrador"',
      contactName: "Nome do contato de cobrança",
      email: "Email",
      phone: "Número de telefone",
      address: "Endereço",
      paymentMethod: "Método de pagamento",
      noPaymentMethod: "Nenhum método de pagamento registrado",
      addPaymentMethod: "Adicionar método de pagamento",
      creditCard: "Cartão de crédito",
      nameOnCard: "Nome no cartão",
    },
  },
  branding: "Marca",
  legal: "Jurídico",
  localization: "Localização",
  unitSystem: "Sistema de unidades",
  servicesAndTariffs: "Serviços e Tarifas",
  dumontYou: "Você",
  dumontSending: "Enviando…",
  dumontTypeAMessage: "Digite uma mensagem...",
  dumontThankYou: "Obrigado!",
  dumontConnectionError: "Houve um problema ao contatar o Ask Dumont. Por favor, tente novamente mais tarde.",
  dumontUnableToConnect: "Não foi possível conectar ao Ask Dumont.",
  dumontNoMessagesToCopy: "Nenhuma mensagem para copiar",
  dumontConversationCopied: "Conversa copiada para a área de transferência",
  dumontFailedToCopyConversation: "Falha ao copiar conversa",
  dumontNoMessagesToExport: "Nenhuma mensagem para exportar",
  dumontChatExportedSuccessfully: "Conversa exportada com sucesso",
  dumontFailedToExportChat: "Falha ao exportar conversa",
  dumontNoMessagesToClear: "Nenhuma mensagem para limpar",
  dumontConversationCleared: "Conversa limpa",
  dumontOpenInNewWindow: "Abrir Dumont AI em uma nova janela",
  dumontCloseShortcut: "Clique ou pressione ⌘K para fechar o Dumont AI",
  wouldYouLikeToSendAnInviteToAgentName: "Gostaria de enviar um convite para {{agentName}} para se juntar à sua rede Shipeezi?",
  selectAtLeastOneItem: "Selecione pelo menos um item",
  shipmentNotFound: "Embarque não encontrado",
  expensesRecalculatedSuccessfully: "Despesas recalculadas com sucesso",
  reconnecting: "Reconectando",
  pleaseSelectAFile: "Por favor, selecione um arquivo!",
  commentsSavedSuccessfully: "Comentários salvos com sucesso",
  couldNotSaveComments: "Não foi possível salvar os comentários",
  anErrorOccurred: "Ocorreu um erro",
  unknownError: "Erro desconhecido",
  newNotification: "Nova Notificação",
  externalAgentAssignmentInfo:
    "Você está atribuído a um agente externo, que receberá um convite por e-mail para aceitar ou rejeitar a atribuição. Caso não haja resposta, o sistema enviará e-mails de lembrete por três dias. Se o agente não responder dentro desse período, a tarefa será cancelada automaticamente.",
  page: "página",
  originCriterion: "Critério de Origem",
  originCriterionMustBeWOrP: "O Critério de Origem deve ser 'W' ou 'P'",
  uploadPDF: "Enviar PDF",
  addManualItems: "Adicionar itens manuais",
  editManualItems: "Editar itens manuais",
  editInventory: "Editar inventário",
  describeEachBingoItem: "Insira uma descrição para cada item abaixo. Use a paginação quando adicionar muitos itens.",
  createInventory: "Criar inventário",
  editInventoryManualTitle: "Editar inventário (itens manuais)",
  customerSurvey: "Pesquisa do Cliente (Saída)",
  statementOfAsp: "Declaração de Serviços Acessórios Realizados",
  associateShipmentToOrder: "Associar embarque ao pedido",
  shipmentSavedAsDraft: "Embarque salvo como rascunho",
  shipmentCreationFailedAtIndex: "Não foi possível criar o embarque {{current}} de {{total}}. Embarques anteriores podem ter sido salvos. Revise o pedido ou adicione os embarques restantes manualmente.",
  scacCodePlaceholder: "Pesquisar ou inserir código SCAC",
  grade: "Nota",
  gradePlaceholder: "ex: A, B, C",
  scacInformation: "Informações SCAC",
  scacDescription: "Descrição SCAC",
  claimsPhone: "Telefone para Sinistros",
  claimsEmail: "E-mail para Sinistros",
  itemIsTv: "O item é uma TV",
  screenSize: "Tamanho da tela",
  screenType: "Tipo de tela",
  remoteControl: "Controle remoto",
  powerCord: "Cabo de energia",
  tvBaseStand: "Base/suporte da TV",
  baseStandHardware: "Ferragens da base/suporte",
  tv: "TV",
  vehicle: "Veículo",
  serialNumberVin: "Número de série / VIN",
  odometerMiles: "Quilometragem do odômetro",
  km: "KM",
  accessoriesIncluded: "Acessórios incluídos",
  gasTankEmpty: "Tanque de combustível vazio",
  fuelSystemPurged: "Sistema de combustível purgado",
  batteryDisconnected: "Bateria desconectada",
  preApprovals: "Pré-aprovações",
  noPreApprovals: "Sem pré-aprovações",
  approvalItem: "Item de Aprovação",
  goShareId: "ID Go Share",
  count: "Contagem",
  storageInTransitOriginSit: "Armazenamento em Trânsito (SIT Origem)",
  sitInDate: "Data de entrada SIT",
  sitOutDate: "Data de saída SIT",
  sitOutDateMustBeAfterSitInDate: "A data de saída SIT deve ser posterior à data de entrada SIT.",
  sitNumber: "Número SIT",
  baseCode: "Código da base",
  baseDescription: "Descrição da base",
  areaCode: "Código da área",
  areaDescription: "Descrição da área",
  zipCode: "CEP",
  itemIsVehicle: "O item é um Veículo",
  vehicleType: "Tipo de Veículo",
  motorcycle: "Motocicleta",
  car: "Carro",
  boat: "Barco",
  startingNumber: "Número Inicial",
  decreaseStartingNumber: "Diminuir número inicial",
  increaseStartingNumber: "Aumentar número inicial",
  editDescriptionForItem: "Editar descrição do item",
  itemDescriptionDefaultPlaceholder: "Aplica-se a todos os itens deste inventário",
  defaultManualInventoryItemDescription: "Vide Inventário",
  customerSignature: "Assinatura do cliente",
  removalistName: "Nome do removedor",
  removalistSignature: "Assinatura do removedor",
  removeFile: "Remover arquivo",
  removeInventoryPdf: "Remover PDF do inventário",
  removeInventoryPdfConfirmation: "O PDF do inventário será removido deste pedido. Os itens já adicionados não serão excluídos. Continuar?",
  viewInventory: "Ver Inventário",
  noDocumentsHaveBeenAddedYet: "Nenhum documento foi adicionado ainda",
  askEnzo: "Perguntar ao Enzo",
  enzoHelpDocumentation: "Ajuda e Documentação",
  enzoSendFeedback: "Enviar Feedback",
  enzoContactSupport: "Contatar Suporte",
  enzoLearnHowToUseEnzo: "Aprenda a usar o Enzo de forma eficaz",
  enzoHelpUsImproveEnzo: "Ajude-nos a melhorar o Enzo",
  enzoGetHelpFromTeam: "Obtenha ajuda da nossa equipe",
  enzoQuickActions: "Ações Rápidas",
  enzoContactOurSupport: "Contate nosso suporte",
  enzoGetHelpWithIssues: "Obtenha ajuda com qualquer problema ou dúvida",
  enzoSendUsYourFeedback: "Envie-nos seu feedback",
  enzoShareThoughtsAndSuggestions: "Compartilhe suas opiniões e sugestões",
  enzoCommonQuestions: "Perguntas Frequentes",
  enzoHowToCreateCustomAgent: "Como criar um agente personalizado?",
  enzoHowToCreateCustomAgentAnswer: "Para criar um agente personalizado, navegue até a seção Agentes e clique no botão \"Criar Novo Agente\". Você pode então configurar as capacidades e configurações do agente de acordo com suas necessidades.",
  enzoWhatCanEnzoHelp: "Com o que o Enzo pode me ajudar?",
  enzoWhatCanEnzoHelpAnswer: "O Enzo é seu assistente de IA especializado em logística e mudanças. Posso ajudá-lo com planejamento de despacho, gerenciamento de pedidos, otimização de rotas e responder perguntas sobre suas operações.",
  enzoHowToAccessChatHistory: "Como acesso meu histórico de conversas?",
  enzoHowToAccessChatHistoryAnswer: "Clique no ícone Histórico na barra lateral para ver todas as suas conversas anteriores com o Enzo. Você pode pesquisar no histórico e retomar qualquer conversa anterior.",
  enzoCanCustomizeAgentCapabilities: "Posso personalizar as capacidades dos agentes?",
  enzoResources: "Recursos",
  enzoKnowledgeBase: "Base de Conhecimento",
  enzoCompleteGuidesAndTutorials: "Guias e tutoriais completos",
  enzoSelectAnOption: "Selecione uma opção",
  enzoFeedbackHelpsImprove: "Seu feedback nos ajuda a melhorar o Enzo",
  enzoIssueType: "Tipo de Problema",
  enzoSubject: "Assunto",
  enzoBriefDescriptionOfIssue: "Breve descrição do seu problema",
  enzoMessage: "Mensagem",
  enzoPleaseDescribeIssueDetail: "Por favor, descreva seu problema em detalhes...",
  enzoIncludeErrorMessages: "Inclua mensagens de erro ou passos para reproduzir o problema",
  enzoGotIt: "Entendi",
  enzoCancel: "Cancelar",
  enzoSendFeedbackButton: "Enviar Feedback",
  enzoSendMessage: "Enviar Mensagem",
  enzoSupportRequestSentSuccessfully: "Sua solicitação de suporte foi enviada com sucesso. Nossa equipe responderá em até 24 horas.",
  enzoFeedbackSentSuccessfully: "Seu feedback foi enviado com sucesso. Agradecemos sua contribuição!",
  enzoSearchPlaceholder: "Pesquisar conversas, agentes, histórico...",
  enzoNavigation: "Navegação",
  enzoNewChat: "Nova Conversa",
  enzoChats: "Conversas",
  enzoNoChatsFound: "Nenhuma conversa encontrada",
  enzoNoRecentChats: "Nenhuma conversa recente",
  enzoAgents: "Agentes",
  enzoNoAgentsFound: "Nenhum agente encontrado",
  enzoReturnToShipeezi: "Voltar ao Shipeezi",
  enzoHelp: "Ajuda",
  enzoWelcomeMessage: "Olá, {{userName}}, eu sou o Enzo, seu assistente de IA especializado em logística e mudanças. Criado para simplificar fluxos de trabalho complexos, eu aprendo continuamente para oferecer suporte mais rápido, inteligente e preciso ao seu negócio.",
  enzoWelcomeMessageBusiness: "Olá, {{userName}}, eu sou o Enzo Assistente Comercial! 💼 Sou especializado em vendas e cotações. Posso ajudá-lo a criar cotações de frete precisas, gerenciar relacionamentos com clientes e fechar negócios mais rápido. Como posso ajudá-lo hoje?",
  enzoWelcomeMessageOperations: "Olá, {{userName}}, eu sou o Enzo Assistente de Operações! 📊 Sou seu especialista em operações. Posso ajudá-lo a rastrear embarques, monitorar entregas, gerenciar trabalhos e garantir operações logísticas tranquilas. No que você precisa de ajuda?",
  enzoWelcomeMessageWarehousing: "Olá, {{userName}}, eu sou o Enzo Assistente de Armazém! 🏭 Sou especializado em inventário e operações de armazém. Posso ajudá-lo a gerenciar níveis de estoque, rastrear inventário, coordenar armazenamento e otimizar a eficiência do armazém. Como posso ajudar?",
  enzoDispatchQuickActions: "Ações rápidas para Despacho",
  enzoHistory: "Histórico",
  enzoConversationHistory: "Histórico de Conversas",
  enzoNoConversationsFound: "Nenhuma conversa encontrada",
  enzoNoConversationHistory: "Nenhum histórico de conversas",
  enzoTryDifferentSearchTerm: "Tente um termo de busca diferente",
  enzoStartNewConversation: "Inicie uma nova conversa para vê-la aqui",
  enzoFileTooLarge: "O arquivo é muito grande. O tamanho máximo é 10MB.",
  enzoUnsupportedFileType: "Tipo de arquivo não suportado. Selecione arquivos TXT, PDF ou DOC/DOCX.",
  enzoDocumentProcessing: "O processamento de PDF/DOC estará disponível em breve. Por favor, use arquivos TXT por enquanto.",
  enzoFileProcessingError: "Erro ao processar arquivo. Por favor, tente novamente.",
  enzoAskEnzo: "Pergunte ao Enzo...",
  enzoAskEnzoAnything: "Pergunte qualquer coisa ao Enzo",
  enzoUpload: "Enviar",
  enzoUsesAI: "O Enzo utiliza Inteligência Artificial. Revise as respostas.",
  enzoCopyConversation: "Copiar conversa",
  enzoExportChat: "Exportar conversa",
  enzoClearConversation: "Limpar conversa",
  enzoLoadingAgents: "Carregando agentes...",
  enzoAgentsTitle: "Agentes Enzo",
  enzoCreateAgent: "Criar Agente",
  enzoSearchAgents: "Pesquisar agentes...",
  enzoNoAgentsAvailable: "Nenhum agente disponível",
  enzoAgentsAvailableSoon: "Agentes estarão disponíveis em breve",
  enzoComingSoon: "Em breve...",
  enzoBusinessAssistant: "Assistente Comercial",
  enzoBusinessAssistantDesc: "Especializado em vendas e cotações",
  enzoOperationsAssistant: "Assistente de Operações",
  enzoOperationsAssistantDesc: "Seu especialista em operações",
  enzoWarehousingAssistant: "Assistente de Armazém",
  enzoWarehousingAssistantDesc: "Especialista em inventário e operações de armazém",
  enzoCanCustomizeAgentCapabilitiesAnswer: "Sim! Cada agente pode ser personalizado para se adequar ao seu fluxo de trabalho específico. Você pode ajustar suas capacidades, definir parâmetros específicos e configurar quais fontes de dados ele pode acessar.",
  enzoFeedbackType: "Tipo de Feedback",
  enzoYourFeedback: "Seu Feedback",
  enzoTellUsWhatYouThink: "Diga-nos o que você pensa...",
  enzoPleaseSelectTextFile: "Por favor, selecione um arquivo de texto (.txt)",
  enzoDocumentAttached: "Documento anexado",
  enzoRemoveDocument: "Remover documento",
  enzoDefaultResponse: "Obrigado por entrar em contato! Estou analisando sua solicitação e fornecerei a melhor solução.",
  enzoSales: "Vendas",
  enzoOperations: "Operações",
  enzoLogistics: "Logística",
  enzoDispatchShowTodayOrders: "Mostrar pedidos de despacho de hoje",
  enzoDispatchShowTodayOrdersDesc: "Obtenha um resumo de todos os pedidos programados para despacho hoje",
  enzoDispatchFindCustomer: "Encontrar pedidos por nome do cliente",
  enzoDispatchFindCustomerDesc: "Pesquise pedidos específicos usando informações do cliente",
  enzoDispatchTrackStatus: "Rastrear status do pedido",
  enzoDispatchTrackStatusDesc: "Verifique o status atual dos pedidos no sistema",
  enzoDispatchOptimizeRoutes: "Otimizar rotas de entrega",
  enzoDispatchOptimizeRoutesDesc: "Obtenha sugestões para as rotas de entrega mais eficientes",
  enzoWhatCanIHelpYouWith: "Como posso ajudá-lo?",
  enzoOptimizeLogisticsOperations: "Otimizar minhas operações logísticas",
  enzoOptimizeLogisticsOperationsDesc: "Obtenha recomendações personalizadas para melhorar a eficiência e reduzir custos",
  enzoTrackShipmentStatus: "Rastrear status do embarque",
  enzoTrackShipmentStatusDesc: "Obtenha atualizações em tempo real sobre seus embarques e estimativas de entrega",
  enzoCalculateShippingCosts: "Calcular custos de envio",
  enzoCalculateShippingCostsDesc: "Estime custos para diferentes métodos de envio e destinos",
  enzoFindWarehouseLocations: "Encontrar localizações de armazém",
  enzoFindWarehouseLocationsDesc: "Descubra localizações ideais de armazém para sua rede de distribuição",
  enzoManageInventoryLevels: "Gerenciar níveis de inventário",
  enzoManageInventoryLevelsDesc: "Obtenha insights sobre otimização de inventário e gerenciamento de estoque",
  enzoScheduleDeliveries: "Agendar entregas",
  enzoScheduleDeliveriesDesc: "Planeje e otimize rotas de entrega para máxima eficiência",
  enzoHowCanIHelpYou: "Como posso ajudá-lo?",
  fileSizeIsTooLarge: "O arquivo é maior que 2MB",
  propertyDamageReport: "Relatório de danos à propriedade",
  optional: "Opcional",
  photoRequiredAtUpliftCompletion: "Foto obrigatória na conclusão da coleta",
  customerPhoneNumber: "Telefone do cliente",
  alternativePhone: "Telefone alternativo",
  alternativeEmail: "E-mail alternativo",
  mailingAddress: "Endereço de correspondência",
  customerFields: "Campos do cliente",
  requireCustomerInformationFields: "Exigir campos de informação do cliente",
  customerFieldsWillBeRequired: "Os campos do cliente serão obrigatórios",
  selectMadatory: "Selecionar obrigatório",
  military: "Militar",
  templateType: "Tipo de modelo",
  assignedTemplate: "Modelo atribuído",
  packingList: "Lista de embalagem",
  billOfLading: "Conhecimento de embarque",
  inventoryReport: "Relatório de inventário",
  shippingManifest: "Manifesto de envio",
  deliveryReceipt: "Comprovante de entrega",
  customsDeclaration: "Declaração alfandegária",
  saveTemplates: "Salvar modelos",
  shipeeziDefault2: "Padrão Shipeezi",
  clientCustomTemplate: "Modelo Personalizado do Cliente",
  customTemplate: "Modelo Personalizado",
  reportTemplates: "Modelos de Relatório",
  defineWhichTemplateEachReportUses: "Defina qual modelo cada relatório utiliza. Os modelos são salvos por empresa e visíveis apenas para contas Militares. Identifique se cada relatório utiliza o modelo padrão Shipeezi ou um modelo personalizado do cliente.",
  accessToThisSectionIsRestrictedByPermissionLevel: "O acesso a esta seção é restrito por nível de permissão. As alterações são salvas por empresa e ocultas de contas Comerciais.",
  customerPortalAddress: "Endereço do Portal do Cliente",
  definesLinkYourCustomerWillUse: "Define o link que seus clientes usarão para rastrear pedidos e visualizar detalhes de embarques",
  dateFormat: "Formato de data",
  timeFormat: "Formato de hora",
  accountPreferences: "Preferências da conta",
  addPreApprovalItem: "Adicionar item de pré-aprovação",
  removePreApprovalItem: "Remover item",
  pleaseFillAllPreApprovalFields: "Preencha a descrição da pré-aprovação para cada linha.",
  unitOfMeasure: "Unidade de Medida (UdM)",
  boxes: "Caixas",
  pairs: "Pares",
  sets: "Conjuntos",
  pallets: "Paletes",
  customerLogo: "Logo do Cliente",
  email: "Email",
  sms: "SMS",
  downloadCsv: "Baixar CSV",
  removeShipmentFromOrder: "Remover Envio do Pedido",
  thisShipmentHasNoOtherOrdersAssociated:
    "Este envio não possui outros pedidos associados. O que você gostaria de fazer com ele?",
  revertToDraft: "Reverter para Rascunho",
  leaveAsDraft: "Manter como Rascunho",
  cancelShipment: "Cancelar Envio",
  areYouSureYouWantToDeleteThisShipment: "Tem certeza que deseja cancelar este envio?",
  yesDeleteShipment: "Sim, cancelar este envio",
  deleteShipment: "Deletar Envio",
  quickOrder: "Pedido Rápido",
  createQuickOrder: "Criar Pedido Rápido",
  automaticSequenceUnavailableEnterReferenceManually:
    "A sequência automática não está disponível. Informe a referência manualmente.",
  enableQuickOrder: "Habilitar Pedido Rápido",
  showOrderReportInManagement: "Mostrar relatório de pedidos em Management",
  reportsAvailableForSharingViaOpsApp:
    "Reports disponíveis para compartilhamento via Ops App",
  noReportsAvailableForSharingViaOpsApp:
    "Nenhum report disponível para compartilhamento via Ops App",
  opsAppReportsSharingEligibilityHint:
    "Cada opção só aparece no Ops App quando a task atual atende ao tipo de task e aos requisitos de dados abaixo.",
  opsAppReportsSharingEligibleTaskTypes: "Tipos de task elegíveis",
  opsAppReportsSharingRequirement: "Requisito",
  opsAppReportsSharingAnyFinishedTaskType: "Qualquer tipo de task finalizada",
  opsAppReportsSharingTaskTypePack: "Pack",
  opsAppReportsSharingRequirementFinishedTask: "A task deve estar finalizada",
  opsAppReportsSharingRequirementChecklistAnswersOnTask:
    "O checklist deve estar respondido na task atual",
  opsAppReportsSharingRequirementMandatoryMeItems:
    "O pedido deve incluir itens M&E obrigatórios",
  opsAppReportsSharingRequirementHighRiskItems:
    "O pedido deve incluir itens high-risk/high-value",
  opsAppReportsSharingRequirementProGearItems: "O pedido deve incluir itens pro-gear",
  opsAppReportsSharingRequirementPropertyDamage:
    "A task deve ter registros de property damage",
  opsAppReportsSharingRequirementTransshipment:
    "A task Uplift deve estar finalizada com transshipment concluído",
  opsAppReportsSharingRequirementVolumeCalculations:
    "A task deve ter dados de volume determination",
  opsAppReportsSharingRequirementVideoSurveyTask:
    "Deve existir uma task Video Survey no pedido",
  opsAppReportsSharingRequirementMotorcycleItems:
    "O pedido deve incluir itens motorcycle/vehicle",
  opsAppReportsSharingRequirementTvItems: "O pedido deve incluir itens TV",
  orderReport: "Relatório de Pedidos",
  resendWelcomeEmail: "Reenviar email de boas-vindas",
  resendWelcomeEmailConfirmation: "Enviar email de boas-vindas para [name]?",
  welcomeEmailSentSuccessfully: "Email de boas-vindas enviado com sucesso",
  showLastFinishedTasks: "Mostrar as últimas 5 tarefas concluídas",
  selectAContainerCaseSize: "Selecionar um tipo de contêiner ou tamanho de caixa",
  estimate: "Estimativa",
  MB: "MB",
  "Search...": "Pesquisar...",
  activate: "ativar",
  inactivate: "inativar",
  cancelButton: "Cancelar",
  cereLifeLocalAmount: "Valor local CereLife",
  commercial: "Comercial",
  confirmDelete: "Excluir",
  confirmation: "Confirmação",
  containerId: "ID do contêiner",
  createANewPort: "Criar um novo porto",
  customerLastName: "Sobrenome do cliente",
  customerPhone: "Telefone do cliente",
  dateCannotBeInThePast: "A data não pode estar no passado",
  decimalPlaces: "Casas decimais",
  deleteData: "Excluir dados",
  deletePlaceholderTask: "Excluir tarefa placeholder",
  editPort: "Editar porto",
  emailIsInvalid: "E-mail inválido",
  errorFetchingTriggers: "Erro ao buscar gatilhos",
  errorLoadingTemplates: "Erro ao carregar modelos",
  errorReadingFile: "Erro ao ler arquivo",
  errorUpdatingTemplate: "Erro ao atualizar modelo",
  errorUploadingFile: "Erro ao enviar arquivo",
  errorValidatingTemplateName: "Erro ao validar nome do modelo",
  inAMoment: "em instantes",
  invalidDateTime: "Data e hora inválidas",
  invalidTimeFormat: "Formato de hora inválido",
  inviteAgent: "Convidar agente",
  invoicedAmount: "Valor faturado",
  iso174511Description:
    "Use a lista de inventário padrão Shipeezi certificada ISO17451-1:2016. Você pode atualizá-la ou expandi-la a qualquer momento.",
  itShouldBeAtLeastOneBranch: "Deve haver pelo menos uma filial",
  itShouldHaveLeastOneBranch: "Você deve ter pelo menos uma filial",
  "label.item.packaging": "Embalagem do item",
  last: "Último",
  loadingLocations: "Carregando localizações...",
  militaryReportsDescription: "Configure modelos de relatório para contas militares.",
  noInformationToBeShwon: "Nenhuma informação a ser exibida",
  noLinkedAutomationsFound: "Nenhuma automação vinculada encontrada",
  noReports: "Nenhum relatório",
  only: "Apenas",
  operationFailed: "Operação falhou",
  origins: "Origens",
  picture: "Imagem",
  pictures: "Imagens",
  pushCharacterLimitExceeded: "Limite de caracteres da notificação push excedido",
  scheduledTimeCannotBeInThePast: "O horário agendado não pode estar no passado",
  seconds: "segundos",
  selectAContainerNumber: "Selecione um número de contêiner",
  selectAtLeastOneTarget: "Selecione pelo menos um destino",
  selectOptions: "Selecionar opções",
  sending: "Enviando",
  shipeeziDefaultTemplate: "Modelo padrão Shipeezi",
  shipmentInformation: "Informações do envio",
  smsCharacterLimitExceeded: "Limite de caracteres do SMS excedido",
  someFilesFailedToUpload: "Alguns arquivos falharam ao enviar",
  taskUnpublishedCannotBeEdited: "Tarefas não publicadas não podem ser editadas",
  theLimitOfLinesIs: "O limite de linhas é",
  thisCustomerDoesNotHaveAnEmailToSendInvitation: "Este cliente não possui e-mail para enviar o convite",
  thisFieldIsNumber: "Este campo deve ser um número",
  uploadCategories: "Categorias de upload",
  uploadCategoriesDescription: "Envie sua lista de categorias para começar.",
  uploadCentreDescription:
    "Aqui você pode enviar seus próprios arquivos (como inventário, equipe ou listas de serviços) ou começar com a lista padrão do Shipeezi. Você pode atualizar isso depois.",
  useShipeeziSDefaultListDescription:
    "Comece rapidamente com nossa lista pré-configurada, baseada no padrão global ISO17451-1:2016. Você pode atualizá-la ou expandi-la a qualquer momento.",
  url: "URL",
  v: "V",
  youCannotInviteInactiveCustomers: "Você não pode convidar clientes inativos",
  youDontHavePermissionToAccessShipmentData: "Você não tem permissão para acessar dados de envio",
  youHaveToAddAtLeastOneOrder: "Você precisa adicionar pelo menos um pedido",
  youMustEnterAAgentId: "Você deve informar um ID de agente",
  youMustHaveAtLeastOneContact: "Você deve ter pelo menos um contato",
  youMustHaveAtLeastOnePrimaryContact: "Você deve ter pelo menos um contato principal",
  yourPasswordMustBeAtLeast6CharactersLong: "Sua senha deve ter pelo menos 6 caracteres",
  memberCode: "Código do membro",
  uploadOwnListDescription: "Traga seus próprios dados para personalizar o Shipeezi desde o início.",
  downloadCsvTemplate: "Baixar modelo CSV",
};
